import { PRODUCT_KEYS } from "./products";
import { t } from "i18next";

export const OPTION_VALUES = {
  WIFE_DETAILS: "WIFE_DETAILS",
  Y_YES: "Yes",
  N_NO: "No",
  WITHOUT_KYC: "WITHOUT_KYC",
  ADHAR_KYC: "AADHAAR",
  PENDING: false,
  WITHOUT_EXISTING_EIA: "WITHOUT_EXISTING_EIA",
  EIA_ACCOUNT_NO: "EIA_ACCOUNT",
  PAN_KYC: "PAN",
  YES: "Y",
  NO: "N",
  TRUE_STRING: "true",
  FALSE_STRING: "false",
  MINSPOUSECOVER: 10000000,
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  GENDER: {
    MALE: "Male",
    FEMALE: "Female",
    MALE_M: "M",
    FEMALE_F: "F",
    TRANSGENDER: "Transgender",
    OTHER: "Other",
  },
  TYPE: {
    TEXT: "text",
    DROPDOWN: "dropdown",
    BOOLEAN: "boolean",
    ARRAY: "array",
    ARRAYDATA: "arraydata",
    CUSTOM: "custom",
    ADDRESS: "address",
    EMAIL: "email",
    DOB: "dob",
    TEXTAREA: "textarea",
    CHECKBOX: "checkbox",
    CHECKBOXGROUP: "checkboxgroup",
    RADIO: "radio",
  },
  OTHERS: "Others",
  NRI_YES: "Yes",
  NRI_NO: "No",
  DEP_YES: "Yes",
  DEP_NO: "No",
  EMP_YES: "Yes",
  EMP_NO: "No",
  NEGATIVE: "Negative",
  POSITIVE: "Positive",
  TRUE: true,
  FALSE: false,
  TOBACCO_CONSUMER_YES: "Smoker",
  TOBACCO_CONSUMER_NO: "NonSmoker",
  MARRIED: "Married",
  UNMARRIED: "0",
  LIFE_COVER_YES: "Yes",
  LIFE_COVER_NO: "No",
  MONEYBACK_YES: "LCB",
  MONEYBACK_NO: "Base",
  EQUAL_INCOME: "EQUAL_INCOME",
  ANNUAL_INCOME: {
    ONE_L_TWENTY_K: "120000",
    ONE_L_FIFTY_K: "150000",
    TWO_L_FIFTY_K: "250000",
    FIVE_L: "500000",
    EIGHT_L: "800000",
    TEN_L: "1000000",
    THREE_L: "300000",
    FOUR_L: "400000",
    THREE_L_SEVENTY_K: "370000",
    SIX_L_TWETNY_FIVE_K: "625000",
    SIX_L_FIFTY_K: "650000",
    SEVEN_L_FIFTY_K: "750000",
    EIGHT_L_SEVENTY_FIVE_K: "875000",
    NINE_L: "900000",
    TWELVE_L_FIFTY_K: "1250000",
    FIFTEEN_L: "1500000",
    SEVENTEEN_L_FIFTY_K: "1750000",
    TWENTY_L: "2000000",
    TWENTY_FIVE_L: "2500000",
    THERTY_L: "3000000",
    FORTY_L: "4000000",
    NRI_RANGE: {
      150000: { min: 0, max: 299999 },
      400000: { min: 300000, max: 499999 },
      650000: { min: 500000, max: 799999 },
      900000: { min: 800000, max: 999999 },
      1500000: { min: 1000000, max: 1999999 },
      3000000: { min: 2000000, max: 3999999 },
      4000000: { min: 4000000, max: Infinity },
    },

    RANGE: {
      150000: { min: 0, max: 299999 },
      400000: { min: 300000, max: 499999 },
      650000: { min: 500000, max: 799999 },
      900000: { min: 800000, max: 999999 },
      1500000: { min: 1000000, max: 1999999 },
      2000000: { min: 2000000, max: Infinity },
      3000000: { min: 2000000, max: 3999999 },
      4000000: { min: 4000000, max: Infinity },
    },
    SMARTKID_RANGE: {
      250000: { min: 0, max: 490000 },
      650000: { min: 500000, max: 740000 },
      875000: { min: 800000, max: 990000 },
      1250000: { min: 1000000, max: 1490000 },
      1750000: { min: 1500000, max: 1990000 },
      2000000: { min: 2000000, max: Infinity },
    },
    IWISH_RANGE: {
      150000: { min: 0, max: 249999 },
      400000: { min: 250000, max: 499999 },
      650000: { min: 500000, max: 799999 },
      900000: { min: 800000, max: 999999 },
      1500000: { min: 1000000, max: 1999999 },
      2000000: { min: 2000000, max: Infinity },
      3000000: { min: 2000000, max: 3999999 },
      4000000: { min: 4000000, max: Infinity },
    },
  },
  OCCUPATION: {
    SALARIED: "SPVT",
    SELF_EMPLOYEE: "BSEM",
    SELF_EMPLOYEE_CA: "SECA",
    CA: "CA",
    SELF_EMPLOYEE_DOCTOR: "SEDO",
    DOCTOR: "Doctor",
    SELF_EMPLOYEE_ARCHITECT: "SEAR",
    SELF_EMPLOYEE_BUSINESSMAN: "SEBU",
    SELF_EMPLOYEE_CONSULTANT: "SECO",
    SELF_EMPLOYEE_LAWYER: "SELA",
    LAWYER: "Lawyer",
    SELF_EMPLOYEE_OTHERS: "SEOT",
    IPRU: "IPRU",
    PROFESSIONAL: "PROF",
    RETIRED: "RETD",
    AGRICULTURALIST: "AGRI",
    STUDENT: "STDN",
    OTHERS: "SPRO",
    OTHER: "Other",
    HOUSEWIFE: "HSWF",
    UNEMPLOYED: "",
  },
  EDUCATION: {
    BELOW_TWELVE: "678",
    TWELVE_DIPLOMA: "679",
    GRADUATE: "680",
    BELOW_TEN: "677",
    TEN_TWELVE_DIPLOMA: "675",
  },
  STAFF_Y: "Y",
  STAFF_N: "N",
  OTHER_CITY: "OTHERS",
  PAYMENT_FREQUENCY: {
    MONTHLY: "Monthly",
    HALF_YEARLY: "Half-Yearly",
    YEARLY: "Yearly",
  },
  PAYMENT_FREQUENCY_ONCE: "ONCE",
  PAYMENT_TYPE: {
    MONTHLY: "p.m",
    HALF_YEARLY: "Half-Yearly",
    YEARLY: "p.a",
  },
  PAYMENT_OPTIONS: {
    REGULAR: "Regular Pay",
    LIMITED: "Limited Pay",
    ONE_TIME: "Single Pay",
  },
  FUND_ALLOCATE: {
    ONE_YEAR: "Perf1Year",
    THREE_YEARS: "Perf3Year",
    FIVE_YEARS: "Perf5Year",
    SEVEN_YEARS: "Perf7Year",
    TEN_YEARS: "Perf10Year",
    INCEPTION: "PerfInception",
  },
  WL: "WL",
  WLLP: "WLLP",
  SP: "SP",
  RP: "RP",
  LP: "LP",
  LP5: "LP5",
  LP7: "LP7",
  LP10: "LP10",
  LP15: "LP15",
  LPT5: "LPT5",
  LP60: "LP60",
  WLLP10: "WLLP10",
  WLLP60: "WLLP60",
  WLRP: "WLRP",
  PAYMENT_TENURE: {
    MONTHLY: "MONTHLY",
    HALF_YEARLY: "HALF_YEARLY",
    YEARLY: "YEARLY",
  },
  MARITAL_STATUS: {
    MARRIED: "696",
    SINGLE: "697",
    DIVORCED: "695",
    WIDOWED: "694",
  },
  HIGHEST_EDUCATION: {
    PG: "676",
    GRADUATE: "680",
    DIPLOMA: "675",
    TWELTH: "679",
    TENTH: "678",
    BELOW_TENTH: "677",
  },
  IDENTITY_PROOF: {
    MASKED_AADHAR: "Adhr",
    DRIVING_LICENSE: "Driving License",
    PASSPORT: "Passport",
    VOTER_ID: "Voters ID",
    NATIONAL_IDENTITY_CARD: "National Identity Card",
  },
  AGE_PROOF: {
    MASKED_AADHAR: "Adhr",
    DEFENCE_I_CARD: "DEF",
    DRIVING_LICENSE: "DL",
    EMPLOYERS_CERTIFICATE: "EMPCRT",
    GOVERNMENT_EMPLOYEE_ID: "GOVTID",
    PROOF_GSR: "GSR",
    MUNICIPAL_RECORD: "MUN",
    PAN_CARD: "PAN",
    VOTER_ID: "Voters ID",
    NATIONAL_IDENTITY_CARD: "National Identity Card",
    PASSPORT: "PSPT",
    SCHOOL_COLLEGE_RECORD: "SC",
  },
  INSURANCE_REPOSITORY: {
    NO_PREFERENCE: "Not Interested",
    NSDL_DATABASE: "NDML",
    CAMS: "CAMSRep",
    CSDL: "CIRL",
    KIPL: "KARVY",
  },
  MASK: {
    MOBILE: "Mobile",
    EMAIL: "Eamil",
    ACCOUNT_NUMBER: "account_number",
  },
  BOL: "BOL",
  AGENCY: "Agency",
  CR_NML: "1Cr NML",
  PROPRIETARY: "Proprietary",
  LUMP_SUM: "LUMP_SUM",
  INCOME: "INCOME",
  INCOME_S: "income",
  INCREASING_INCOME: "INCREASING_INCOME",
  LUMP_SUM_AND_INCOME: "LUMP_SUM_AND_INCOME",
  ONLINE: "ON",
  OFFLINE: "OF",
  INDUSTRY_TYPE: {
    JEWELLERY: "JEWL",
    SHIPPING: "SHIPPING",
    SCRAP_DEALING: "SCRP",
    STOCK_BROKING: "STOCK",
    IMPORT_EXPORT: "IMPEXP",
    REAL_ESTATE: "REALESTATE",
    MINING: "MINING",
    AGRICULTURE: "AGRI",
    OTHERS: "OTHERS",
  },
  ORGANISATION_TYPE: {
    PUBLIC_LTD: "PUBLIC LTD",
    GOVERNMENT: "GOVT",
    PRIVATE_LTD: "PRIVATE LTD",
    TRUST: "TRST",
    SOCIETY: "SOCIETY",
    PROPREIOTOR: "PROPREITOR",
    PARTNOR: "PARTNER",
    LLP: "LLP",
    NOT_ANSWERED: "NOT ANSWERED",
    OTHERS: "OTHERS",
  },
  NOMINEE_RELATIONSHIP: {
    FATHER: "Father",
    MOTHER: "Mother",
    WIFE: "Wife",
    SON: "Son",
    DAUGHTER: "Daughter",
    BROTHER: "Brother",
    SISTER: "Sister",
    OTHERS: "Other reason",
    HUSBAND: "Husband",
    PARTNER: "Partner",
    SPOUSE: "Spouse",
  },
  FAMILTY_RELATIONSHIP: {
    FATHER: "Father",
    MOTHER: "Mother",
    BROTHER: "Brother",
    SISTER: "Sister",
    GRAND_FATHER: "Grandfather",
    GRAND_MOTHER: "Grandmother",
  },
  NOMINEE_RELATIONSHIP_OTHERS: {
    GRAND_DAUGHTER: "Grand Daughter",
    GRAND_FATHER: "Grand Father",
    GRAND_MOTHER: "Grand Mother",
    GRAND_SON: "Grand Son",
    NEPHEW: "Nephew",
    NIECE: "Niece",
    AUNT: "Aunt",
    BROTHER_IN_LAW: "Brother in law",
    UNCLE: "Uncle",
    SISTER_IN_LAW: "Sister in law",
  },

  NOMINEE_RELATIONSHIP_OTHERS_REASON_UNMARRIED: {
    NEPHEW: "Nephew",
    NIECE: "Niece",
    AUNT: "Aunt",
    BROTHER_IN_LAW: "Brother in law",
    UNCLE: "Uncle",
    SISTER_IN_LAW: "Sister in law",
  },
  NOMINEE_RELATIONSHIP_OTHERS_REASON: {
    NEPHEW: "Nephew",
    NIECE: "Niece",
    AUNT: "Aunt",
    BROTHER_IN_LAW: "Brother in law",
    UNCLE: "Uncle",
    SISTER_IN_LAW: "Sister in law",
    BROTHER: "Brother",
    SISTER: "Sister",
    PARTNER: "Partner",
  },
  NON_BLOOD_RELATION_REASON: {
    DEPENDENT: "Nominee is dependent on the Proposer",
    IMMEDIATE: "Immediate family members of advanced age",
    NO_IMMEDIATE: "No immediate family member present for nomination",
    OTHER: "Other reason",
  },
  APPOINTEE_MALE_RELATIONSHIP: {
    GRAND_FATHER: "Grand Father",
    GRAND_SON: "Grand Son",
    NEPHEW: "Nephew",
    BROTHER: "Brother",
    BROTHER_IN_LAW: "Brother in law",
    UNCLE: "Uncle",
    SON: "Son",
    HUSBAND: "Husband",
    FATHER: "Father",
  },

  APPOINTEE_FEMALE_RELATIONSHIP: {
    GRAND_MOTHER: "Grand Mother",
    GRAND_DAUGHTER: "Grand Daughter",
    NIECE: "Niece",
    SISTER: "Sister",
    AUNT: "Aunt",
    DAUGHTER: "Daughter",
    SISTER_IN_LAW: "Sister in law",
    WIFE: "Wife",
    MOTHER: "Mother",
  },

  MWPA_RELATION: {
    WIFE: "Wife",
    SON: "Son",
    DAUGHTER: "Daughter",
  },
  IWISH_BUYING_FOR: {
    MOTHER: "Mother",
    WIFE: "Wife",
    DAUGHTER: "Daughter",
    SELF: "Self",
  },
  TRUSTEE_TYPE: {
    ENTITY: "Entity",
    INDIVIDUAL: "Individual",
  },
  ACCOUNT_TYPE: {
    CURRENT: "Current Account",
    SAVING: "Savings Account",
  },
  MWPA_ACC_TYPE: {
    CURRENT: "current",
    SAVING: "saving",
  },
  TOBACCO_CONSUMED_AS: {
    BIDI: "bidi",
    CIGARETTES: "cigarettes",
    CIGARS: "cigar",
    PAN: "pan",
    ALL: "All of the above",
  },
  TOBACCO_PER_DAY: {
    LOW: "less_than_5units",
    MID: "6_to_10units",
    HIGH: "greater_than_10units",
  },
  ALCOHOL_CONSUMED_AS: {
    BEER: "Beer(Bottles)",
    LIQUOR: "Liquor(Pegs)",
    WINE: "Wine(Glasses)",
    ALL: "All of the above",
  },
  ALCOHOL_PER_DAY: {
    LOW: "1-2",
    MID: "greater_than_2",
    OCCASIONAL: "Occasional",
  },
  MEDICAL_CONDITION: {
    CURED: "cured",
    UNDER_CONTROL: "under control",
    NOT_CURED: "not cured",
    NOT_CONTROLLED: "not controlled",
  },
  HEALTH_ILLNESS: {
    LIFESTYLE_DISEASE: "Lifestyle Disease",
    CANCER: "Cancer",
    PHYSICAL_DEFORMALITY: "Physical Deformity",
    ORGAN_DISORDER: "Organ Disorders/Failures",
    OTHERS: "Others",
  },
  INCOME_PROOF: {
    FORM_16: "FORM16",
    FORM_16_LATEST_RECOMMENDED: "FORM_16_LATEST_RECOMMENDED",
    FORM_16_RECOMMENDED: "FORM_16_RECOMMENDED",
    FORM_16_LATEST: "FORM_16_LATEST",
    BANK: "NIL",
    BANK_REGULAR: "NIL_R",
    ITR: "ITRETN",
    SALARY: "PAYSLP",
    COMPANY_ID: "COMPANYID",
    APPOINTMENT: "APPOINTMENT",
    COMPANY_FINANCIAL: "COMPANYFINANCIAL",
    ITR_AND_6_MON_BANK: "ITR_AND_6_MON_BANK",
  },
  ACCOUNTS_TYPES: {
    SAVING_ACCOUNT: "saving account",
    CURRENT_ACCOUNT: "current account",
  },
  ADDRESS_PROOF: {
    AADHAR: "Adhr",
    DRIVING_LICENSE: "Driving License",
    PASSPORT: "Passport",
    VOTER_ID: "Voters ID",
    NATIONAL_IDENTITY_CARD: "National Identity Card",
  },
  EIA_PREFERENCE: {
    NO_PREFERENCE: "Not Interested",
    NDML: "NDML",
    CAMSREP: "CAMSRep",
    CIRL: "CIRL",
    KARVY: "KARVY",
    VOTER_ID: "Voters ID",
  },

  TIME_MERIDIAN: {
    AM: "AM",
    PM: "PM",
  },
  COUNTRY_VALUES: {
    INDIA: "India",
    AFGHANISTAN: "Afghanistan",
    UAE: "U.A.E.",
    UAE_FULL: "United Arab Emirates",
  },
  NATIONALITY: {
    INDIAN: "Indian",
    NONINDIAN: "Non_Indian",
  },
  PIO_OCI: {
    PIO_CI: "PIO_OCI",
    FOREIGN: "Foreign_National",
  },
  BANK_ACCOUNT: {
    NRE: "NRE",
    NRO: "NRO",
  },
  ABROADSTAY_PURPOSE: {
    RESIDENT_NATIONAL: "Resident National",
    OCCUPATION: "Occupation",
    STUDENT: "Student",
    DEPENDENT: "Dependent",
    HOUSEWIFE: "Housewife",
  },
  TRAVEL_PURPOSE: {
    BUSINESS: "Business",
    EMPLOYEMENT: "Employment",
    TOURISM: "Tourism",
    VACATION: "Vacation",
    FAMILY: "Family",
  },
  RESIDENCE_TYPE: {
    HOTEL: "Hotel",
    RENTED_HOUSE: "Rentedhouse",
    OWNED_HOUSE: "OwnedHouse",
    GUEST_HOUSE: "GuestHouse",
  },
  WOPList: {
    CRITICAL_ILLNESS: "CRITICAL_ILLNESS",
    ACCIDENTAL: "ACCIDENTAL",
  },
  TRAVEL_MODE: {
    PRIVATE: "Private",
    OWNED: "OwnedVehicle",
    PUBLIC: "Public",
  },
  MONTHS: {
    ZERO_MONTH: "0",
    ONE_MONTH: "1",
    TWO_MONTHS: "2",
    THREE_MONTHS: "3",
    FOUR_MONTHS: "4",
    FIVE_MONTHS: "5",
    SIX_MONTHS: "6",
    SEVEN_MONTHS: "7",
    EIGHT_MONTHS: "8",
    NINE_MONTHS: "9",
    TEN_MONTHS: "10",
    ELEVEN_MONTHS: "11",
  },
  PAYMENT_MONTHS: {
    JANUARY: "January",
    FEBRUARY: "February",
    MARCH: "March",
    APRIL: "April",
    MAY: "May",
    JUNE: "June",
    JULY: "July",
    AUGUST: "August",
    SEPTEMBER: "September",
    OCTOBER: "October",
    NOVEMBER: "November",
    DECEMBER: "December",
  },
  SWP_NOW: "now",
  SWP_LATER: "later",
  BUYING_FOR: {
    SELF: "Self",
    SPOUCE: "Spouse",
    CHILD: "Child",
    GRANDHILD: "Grandchild",
    MOTHER: "Mother",
    FATHER: "Father",
    GRAND_MOTHER: "Grand Mother",
    GRAND_FATHER: "Grand Father",
  },
  ORGANISATION_NAME_OTHERS: "Others",
  PERCENTAGE_VALUES: {
    HUNDRED_PCT: 100,
    SEVENTY_FIVE_PCT: 75,
    FIFTY_PCT: 50,
    TWENTY_FIVE_PCT: 25,
  },
  PNG_ERROR_CODES: {
    EO1: "EO1",
  },
  STORY: {
    PRANEET: "Praneet",
    NITIN: "Nitin",
    SHARMASTORY: "Mr. Sharma’s Story",
    RASTOGISTORY: "Mr & Mrs Rastogi’s Story",
    NAYAKSTORY: "Mrs. Nayak’s Story",
  },
  PENSION_FREQUENCY: {
    MONTHLY: "Monthly",
    HALF_YEARLY: "Half-Yearly",
    YEARLY: "Yearly",
    QUARTERLY: "Quarterly",
  },
  PENSION_FOR: {
    ME: "Me",
    ME_SPOUSE: "Me & spouse",
  },
  ANNUITY: {
    ME: "ME",
    ME_NOMINEE: "ME_NOMINEE",
    ME_JOINT: "ME_JOINT",
    ME_JOINT_NOMINEE: "ME_JOINT_NOMINEE",
  },
  ANNUITY_OPTIONS: {
    ME: ["Single Life Without Return of Premium"],
    ME_NOMINEE: [
      "Single Life With Return of Premium",
      "Increasing Annuity for Single Life with Return of Premium",
      "Single Life With ROP CI/PD",
    ],
    ME_JOINT: ["Joint Life Without Return of Premium", "Joint Life Without Return of Premium WOP"],
    ME_JOINT_NOMINEE: [
      "Joint Life With Return of Premium",
      "Joint Life with Return of Premium WOP",
      "Increasing Annuity for Joint Life with Return of Premium",
      "Increasing Annuity for Joint Life with Return of Premium WOP",
    ],
  },
  ANNUITY_OPTION_RELATION: {
    Spouse: {
      ME_JOINT: ["Joint Life Without Return of Premium"],
      ME_JOINT_NOMINEE: [
        "Joint Life With Return of Premium",
        "Increasing Annuity for Joint Life with Return of Premium",
        "Increasing Annuity for Joint Life with Return of Premium WOP",
      ],
    },
    Other: {
      ME_JOINT: ["Joint Life Without Return of Premium"],
      ME_JOINT_NOMINEE: [
        "Joint Life With Return of Premium",
        "Increasing Annuity for Joint Life with Return of Premium",
        "Increasing Annuity for Joint Life with Return of Premium WOP",
      ],
    },
  },
  ANNUITY_OPTIONS_TOOLTIP: {
    "Single Life Without Return of Premium ME":
      "Annuity will be given for life of the annuitant without any ROP (Return of premium)",
    "Single Life With Return of Premium ME_NOMINEE": "Annuity only for 1 person with the ROP to nominee",
    "Increasing Annuity for Single Life with Return of Premium ME_NOMINEE":
      "Annuity amount increases every year by 5% p.a. of the annuity payable in the first payout year for life with ROP to the nominee",
    "Single Life With ROP CI/PD ME_NOMINEE":
      "Annuity only for 1 person with the (ROP) return of premiums to nominee of your choice in case of diagnosis of Critical Illness (CI) or Permanent Disability due to Accident (PD) or Death",
    "Joint Life Without Return of Premium ME_JOINT":
      "Annuity given to 1st annuitant and continued to 2nd annuitant after him/her",
    "Joint Life Without Return of Premium WOP ME_JOINT":
      "Annuity given to 1st annuitant and continued to 2nd annuitant after him/her. WOP- In case of death of primary annuitant during the premium payment, the future premiums will be paid by us. The annuity will start directly to 2nd annuitant",
    "Joint Life With Return of Premium ME_JOINT_NOMINEE":
      "Annuity given to 1st annuitant and continued to 2nd annuitant after him/her. Also the entire premiums returned to the nominee",
    "Joint Life with Return of Premium WOP ME_JOINT_NOMINEE":
      "Annuity given to 1st annuitant and continued to 2nd annuitant after him/her. WOP- In case of death of primary annuitant during the premium payment, the future premiums will be paid by us. The annuity will start directly to 2nd annuitant. Also the entire premiums returned to the nominee",
    "Increasing Annuity for Joint Life with Return of Premium ME_JOINT_NOMINEE":
      "Annuity amount increases every year by 5% p.a. of the annuity payable in the first payout year Annuity given to 1st annuitant and continued to 2nd annuitant after him/her with ROP to the nominee",
    "Increasing Annuity for Joint Life with Return of Premium WOP ME_JOINT_NOMINEE":
      "Annuity amount increases every year by 5% p.a. of the annuity payable in the first payout year Annuity given to 1st annuitant and continued to 2nd annuitant after him/her with ROP to the nominee. In case of death of the primary annuitant during the premium payment, the future premiums will be paid by us. The annuity will be paid directly to the 2nd annuitant",
  },
  GPP_PAYMENT_TENURE: {
    MONTHLY: "Monthly",
    HALF_YEARLY: "Half-Yearly",
    YEARLY: "Yearly",
    QUARTERLY: "Quarterly",
  },
  GPP_NETCORE_PENSION_FOR: {
    ME: "wantMe",
    ME_NOMINEE: "wantMeNominee",
    ME_JOINT: "wantMejointlife",
    ME_JOINT_NOMINEE: "wantMenominieejointlife",
  },
  ANNUITY_OPTIONS_LABELS: {
    "Single Life Without Return of Premium": "Single Life without Return of Premiums (ROP) to nominee",
    "Joint Life Without Return of Premium": "Joint-life without Return of Premiums (ROP) to nominee",
    "Joint Life Without Return of Premium WOP":
      "Joint-life with Waiver of premium (WOP) benefit and without Return of Premiums (WROP) to nominee",
    "Joint Life With Return of Premium": "Joint-life with Return of premiums (ROP) to nominee",
    "Joint Life with Return of Premium WOP":
      "Joint-life with Return of premiums (ROP) to nominee and with Waiver of premium (WOP) benefit",
    "Increasing Annuity for Joint Life with Return of Premium WOP":
      "Increasing Annuity for Joint Life With Return of Premium and with WOP",
    "Single Life With Return of Premium": "Single Life with Return of premiums (ROP) to nominee",
  },
  GPP_ANNUITY_AMOUNT_LABELS: {
    Monthly: "month",
    Quarterly: "quarter",
    "Half-Yearly": "half year",
    Yearly: "year",
  },
  CI_MODES: {
    COMPREHENSIVE: {
      years: 60,
      name: "Comprehensive",
    },
    CLASSIC: {
      years: 20,
      name: "Classic",
    },
  },
  PREGNANCY_WEEK_OPTIONS: {
    ABOVE_EQUAL_24: ">=24 weeks",
    LESS_THAN_24: "<24 weeks",
  },
  LANGUAGES_TYPE: {
    ENGLISH: "ENG",
    HINDI: "HIN",
    MARATHI: "MAR",
    TAMIL: "TAM",
    TELUGU: "TEL",
    KANNADA: "KAN",
  },
};

export const SMART_KID_OPTION_VALUES = {
  GENDER: {
    MALE_M: "M",
    FEMALE_F: "F",
    MALE: "Male",
    FEMALE: "Female",
  },
  YES_NO: {
    YES: "Yes",
    NO: "No",
    YES_Y: "Y",
    NO_N: "N",
  },
  RETURN_YEARS: {
    ONE_YEAR: 1,
    THREE_YEARS: 3,
    FIVE_YEARS: 5,
    SEVEN_YEARS: 7,
    TEN_YEARS: 10,
  },
  RETURN_YEARS_RSI: {
    RSI: 1,
    THREE_YEARS: 3,
    FIVE_YEARS: 5,
    TEN_YEARS: 10,
  },
  TRANSFER_DATE: {
    FIRST_MONTH: "1",
    FIFTHTEENTH_MONTH: "15",
    FIFTH_MONTH: "5",
  },
  UPLOAD_DOCUMENTS: {
    MASKED_AADHAR: "Adhr",
    BIRTH_CERTIFICATE: "birthCertificate",
    BAPTISM_CERTIFICATE: "baptismCertificate",
    PASSING_CERTIFICATE: "passingCertificate",
    GOVT_ID_PROOF: "govtIdProof",
    SCHOOL_CERTIFICATE: "schoolCertificate",
    COLLEGE_ID: "collegeId",
    PHOTOGRAPH: "photograph",
    PAN: "pan",
    PAYOUT: "payout",
    BIRTH_CERTIFICATE_LA: "birthCertificateLa",
    BAPTISM_CERTIFICATE_LA: "baptismCertificateLa",
    PASSING_CERTIFICATE_LA: "passingCertificateLa",
    GOVT_ID_PROOF_LA: "govtIdProofLa",
    SCHOOL_CERTIFICATE_LA: "schoolCertificateLa",
    COLLEGE_ID_LA: "collegeIdLa",
    PHOTOGRAPH_LA: "photographLa",
    PAN_LA: "panLa",
    PAYOUT_LA: "payoutLa",
    OTHERS_LA: "othersLa",
    IMAGES: {
      CERTIFICATE_LOGO: "/content/dam/aem-sites-react-spa-ssr/smartkid/savings-form/upload-documents/certificate.png",
      FRONT_LOGO: "/content/dam/aem-sites-react-spa-ssr/smartkid/savings-form/upload-documents/front.png",
      BACK_LOGO: "/content/dam/aem-sites-react-spa-ssr/smartkid/savings-form/upload-documents/back.png",
      PHOTOGRAPH_LOGO: "/content/dam/aem-sites-react-spa-ssr/smartkid/savings-form/upload-documents/photograph.png",
      PAN_LOGO: "/content/dam/aem-sites-react-spa-ssr/smartkid/savings-form/upload-documents/pan.png",
      EXAMPLE_PAN_CARD:
        "/content/dam/aem-sites-react-spa-ssr/smartkid/savings-form/upload-documents/examplePancard.png",
      EXAMPLE_CANCELLED_CHEQUE:
        "/content/dam/aem-sites-react-spa-ssr/smartkid/savings-form/upload-documents/exampleCancelCheque.png",
    },
  },
  TOBACCO_AS: {
    BIDI: "bidi",
    CIGARETTES: "cigarettes",
    CIGARS: "cigar",
    PAN: "pan",
    GUTKA: "gutka",
    ALL: "All of the above",
  },
  TOBACCO_AS_GIFT_CITY: {
    BEEDI: "Beedi",
    CIGARETTE: "Cigarette",
    CIGAR: "Cigar",
    PAN: "Pan",
    GUTKA: "Gutka",
    ALL: "All of the above",
  },
  TOBACCO_QUANTITY: {
    LOW: "less_than_5units",
    MID: "6_to_10units",
    HIGH: "greater_than_10units",
  },
  ALCOHOL_AS: {
    BEER: "Beer(Bottles)",
    LIQUOR: "Liquor(Pegs)",
    WINE: "Wine(Glasses)",
    ALL: "All of the above",
  },
  ALCOHOL_AS_GIFT_CITY: {
    BEER: "Beer",
    WINE: "Wine",
    LIQUOR: "Hard Liquor",
    ALL: "All of the above",
  },
  ALCOHOL_QUANTITY: {
    LOW: "1-2",
    MID: "greater_than_2",
    OCCASIONAL: "Occasional",
  },
  ORGANISATION_TYPE: {
    PUBLIC_LTD: "PUBLIC LTD",
    GOVERNMENT: "GOVT",
    PRIVATE_LTD: "PRIVATE LTD",
    TRUST: "TRST",
    SOCIETY: "SOCIETY",
    PROPREIOTOR: "PROPREITOR",
    PARTNER: "PARTNER",
    LLP: "LLP",
    NOT_ANSWERED: "NOT ANSWERED",
    PART: "PART",
    OTHERS: "OTHERS",
    SEC_25: "SEC 25 COMPANY",
  },
  LANGUAGES_TYPE: {
    ENGLISH: "ENG",
    HINDI: "HIN",
    MARATHI: "MAR",
    TAMIL: "TAM",
    TELUGU: "TEL",
    KANNADA: "KAN",
  },
};
export const PRODUCT_FORM_OCCUPATION = {
  [PRODUCT_KEYS.SMARTKID]: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE, name: "options.self_employed" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CA, name: "options.self_employed_ca" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_DOCTOR, name: "options.self_employed_doctor" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_ARCHITECT, name: "options.self_employed_architect" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_BUSINESSMAN, name: "options.self_employed_businessman" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CONSULTANT, name: "options.self_employed_consultant" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_LAWYER, name: "options.self_employed_lawyer" },
    { id: OPTION_VALUES.OCCUPATION.IPRU, name: "options.employee_ipru" },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    { id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST, name: "options.agriculturalist" },
    { id: OPTION_VALUES.OCCUPATION.STUDENT, name: "options.student" },
  ],
  [PRODUCT_KEYS.PNG]: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "Salaried" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CA, name: "Self Employed - CA" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_DOCTOR, name: "Self Employed - Doctor" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_ARCHITECT, name: "Self Employed - Architect" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_BUSINESSMAN, name: "Self Employed - Businessman" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CONSULTANT, name: "Self Employed - Consultant" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_LAWYER, name: "Self Employed - Lawyer" },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "Professional" },
  ],
};

export const SMART_KID_OPTIONS = {
  APP_FORM_GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
  ],
  APP_FORM_GENDER_CAP: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male_cap" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female_cap" },
  ],
  GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
    { id: OPTION_VALUES.GENDER.TRANSGENDER, name: "options.other" },
  ],

  ANNUAL_INCOME: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.TWO_L_FIFTY_K,
      name: "options.up_to4.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.SIX_L_FIFTY_K, name: "options.5l_7.4l" },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.EIGHT_L_SEVENTY_FIVE_K,
      name: "options.7.5l_9.9l",
    },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.TWELVE_L_FIFTY_K,
      name: "options.10l-14.9l",
    },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.SEVENTEEN_L_FIFTY_K,
      name: "options.15l_19.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, name: "options.20l_plus" },
  ],
  OCCUPATION: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE,
      name: "options.self_employed",
    },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    {
      id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST,
      name: "options.agriculturalist",
    },
    { id: OPTION_VALUES.OCCUPATION.STUDENT, name: "options.student" },
  ],
  FEMALE_OCCUPATION: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE,
      name: "options.self_employed",
    },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    {
      id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST,
      name: "options.agriculturalist",
    },
    {
      id: OPTION_VALUES.OCCUPATION.HOUSEWIFE,
      name: "options.house_wife",
    },
    { id: OPTION_VALUES.OCCUPATION.STUDENT, name: "options.student" },
  ],
  RETURN_YEARS_NO_RETURNS: [
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.THREE_YEARS, name: "3Y" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.FIVE_YEARS, name: "5Y" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.TEN_YEARS, name: "10Y" },
  ],
  RETURN_YEARS: [
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.ONE_YEAR, name: "1 Year | 55.97% Returns" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.THREE_YEARS, name: "3 Year | 22.28% Returns" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.FIVE_YEARS, name: "5 Year | 18.57% Returns" },
  ],
  RETURN_YEARS_RSI: [
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.RSI, name: "RSI | 55.97% Returns" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.THREE_YEARS, name: "3 Year | 55.97% Returns" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.FIVE_YEARS, name: "5 Year | 22.28% Returns" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.TEN_YEARS, name: "10 Year | 18.57% Returns" },
  ],
  RETURN_YEARS_MOBILE: [
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.ONE_YEAR, name: "1 Year | 55.97%" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.THREE_YEARS, name: "3 Year | 22.28%" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.FIVE_YEARS, name: "5 Year | 18.57%" },
  ],
  RETURN_YEARS_MOBILE_RSI: [
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.THREE_YEARS, name: "3 Year | 55.97%" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.FIVE_YEARS, name: "5 Year | 22.28%" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS_RSI.TEN_YEARS, name: "10 Year | 18.57%" },
  ],
  PAYMENT_FREQUENCY: [
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.MONTHLY, name: "Monthly" },
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.HALF_YEARLY, name: "Half-Yearly" },
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.YEARLY, name: "Yearly" },
  ],
  INCOME_FREQUENCY: [
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.MONTHLY, name: "Monthly" },
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.YEARLY, name: "Yearly" },
  ],
  PAYMENT_OPTIONS: [
    { id: OPTION_VALUES.PAYMENT_OPTIONS.REGULAR, name: "Regular" },
    { id: OPTION_VALUES.PAYMENT_OPTIONS.LIMITED, name: "Limited" },
    { id: OPTION_VALUES.PAYMENT_OPTIONS.ONE_TIME, name: "One_Time" },
  ],
  TRANSFER_DATE: [
    { id: SMART_KID_OPTION_VALUES.TRANSFER_DATE.FIRST_MONTH, name: "1st of Every Month" },
    { id: SMART_KID_OPTION_VALUES.TRANSFER_DATE.FIFTHTEENTH_MONTH, name: "15th of Every Month" },
  ],
  FUND_ALLOCATION_MASTER: [
    { id: OPTION_VALUES.FUND_ALLOCATE.ONE_YEAR, name: "options.last1yr" },
    { id: OPTION_VALUES.FUND_ALLOCATE.THREE_YEARS, name: "options.last3yr" },
    { id: OPTION_VALUES.FUND_ALLOCATE.FIVE_YEARS, name: "options.last5yr" },
    { id: OPTION_VALUES.FUND_ALLOCATE.SEVEN_YEARS, name: "options.last7yr" },
    { id: OPTION_VALUES.FUND_ALLOCATE.TEN_YEARS, name: "options.last10yr" },
    { id: OPTION_VALUES.FUND_ALLOCATE.INCEPTION, name: "options.returnIncption" },
  ],
  HIGHEST_EDUCATION: [
    { id: OPTION_VALUES.HIGHEST_EDUCATION.PG, name: "options.post_grd" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.GRADUATE, name: "options.graduation" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.DIPLOMA, name: "options.diploma" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.TWELTH, name: "options.12" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.TENTH, name: "options.10" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.BELOW_TENTH, name: "options.below_10" },
  ],
  OCCUPATION_APP_FORM: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CA, name: "options.self_employed_ca" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_DOCTOR, name: "options.self_employed_doctor" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_ARCHITECT, name: "options.self_employed_architect" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_BUSINESSMAN, name: "options.self_employed_businessman" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CONSULTANT, name: "options.self_employed_consultant" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_LAWYER, name: "options.self_employed_lawyer" },
    { id: OPTION_VALUES.OCCUPATION.IPRU, name: "options.employee_ipru" },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    { id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST, name: "options.agriculturalist" },
    { id: OPTION_VALUES.OCCUPATION.STUDENT, name: "options.student" },
  ],
  TOBACCO_AS_OPTIONS: [
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS.BIDI, name: "options.bidi" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS.CIGARETTES, name: "options.cigarettes" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS.CIGARS, name: "options.cigars" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS.PAN, name: "options.paan" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS.ALL, name: "options.all_above" },
  ],

  TOBACCO_AS_OPTIONS_GIFT_CITY: [
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS_GIFT_CITY.CIGAR, name: "Cigar" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS_GIFT_CITY.CIGARETTE, name: "Cigarette" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS_GIFT_CITY.BEEDI, name: "Beedi" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_AS_GIFT_CITY.GUTKA, name: "Gutka" },
  ],

  TOBACCO_QUANTITY_OPTIONS: [
    { id: SMART_KID_OPTION_VALUES.TOBACCO_QUANTITY.LOW, name: "options.less_than_5" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_QUANTITY.MID, name: "options.6_to_10" },
    { id: SMART_KID_OPTION_VALUES.TOBACCO_QUANTITY.HIGH, name: "options.greater_than_10" },
  ],

  ALCOHOL_AS_OPTIONS: [
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_AS.BEER, name: "options.beer" },
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_AS.LIQUOR, name: "options.liquor" },
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_AS.WINE, name: "options.wine" },
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_AS.ALL, name: "options.all_above" },
  ],

  ALCOHOL_AS_OPTIONS_GIFT_CITY: [
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_AS_GIFT_CITY.BEER, name: "Beer" },
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_AS_GIFT_CITY.WINE, name: "Wine" },
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_AS_GIFT_CITY.LIQUOR, name: "Hard Liquor" },
  ],

  ALCOHOL_QUANTITY_OPTIONS: [
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_QUANTITY.LOW, name: "options.1_2_per_day" },
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_QUANTITY.MID, name: "options.greater_2_per_day" },
    { id: SMART_KID_OPTION_VALUES.ALCOHOL_QUANTITY.OCCASIONAL, name: "options.occasional" },
  ],

  ORGANISATION_TYPES: [
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.PUBLIC_LTD, name: "options.public_ltd" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.GOVERNMENT, name: "options.government" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.PRIVATE_LTD, name: "options.private_ltd" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.TRUST, name: "options.trust" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.SOCIETY, name: "options.society" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.NOT_ANSWERED, name: "options.others" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.PROPREIOTOR, name: "options.proprietor" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.SEC_25, name: "options.section_25_co" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.PARTNER, name: "options.partnership" },
    { id: SMART_KID_OPTION_VALUES.ORGANISATION_TYPE.LLP, name: "options.llp" },
  ],
  LANGUAGES: [
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.ENGLISH, name: "options.English" },
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.HINDI, name: "options.Hindi" },
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.MARATHI, name: "options.Marathi" },
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.TAMIL, name: "options.Tamil" },
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.TELUGU, name: "options.Telugu" },
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.KANNADA, name: "options.Kannada" },
  ],
};

export const OPTIONS = {
  GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
    { id: OPTION_VALUES.GENDER.TRANSGENDER, name: "options.transgender" },
  ],
  NRI: [
    { id: OPTION_VALUES.NRI_NO, name: "common.no" },
    { id: OPTION_VALUES.NRI_YES, name: "common.yes" },
  ],
  YES_NO: [
    { id: OPTION_VALUES.NRI_YES, name: OPTION_VALUES.Y_YES },
    { id: OPTION_VALUES.NRI_NO, name: OPTION_VALUES.N_NO },
  ],
  DEP: [
    { id: OPTION_VALUES.DEP_NO, name: OPTION_VALUES.N_NO },
    { id: OPTION_VALUES.DEP_YES, name: OPTION_VALUES.Y_YES },
  ],
  ITR: [
    { id: OPTION_VALUES.NRI_NO, name: OPTION_VALUES.N_NO },
    { id: OPTION_VALUES.NRI_YES, name: OPTION_VALUES.Y_YES },
  ],
  EMPLOYEE: [
    { id: OPTION_VALUES.EMP_YES, name: "common.yes" },
    { id: OPTION_VALUES.EMP_NO, name: "common.no" },
  ],
  ATS: [
    { id: OPTION_VALUES.NRI_YES, name: "common.yes" },
    { id: OPTION_VALUES.NRI_NO, name: "common.no" },
  ],
  TOBACCO_CONSUME: [
    { id: OPTION_VALUES.TOBACCO_CONSUMER_YES, name: "common.yes" },
    { id: OPTION_VALUES.TOBACCO_CONSUMER_NO, name: "common.no" },
  ],
  MARRIED: [
    { id: OPTION_VALUES.MARITAL_STATUS.MARRIED, name: "common.yes" },
    { id: OPTION_VALUES.UNMARRIED, name: "common.no" },
  ],
  HUSBAND_LIFE_COVER: [
    { id: OPTION_VALUES.LIFE_COVER_YES, name: "common.yes" },
    { id: OPTION_VALUES.LIFE_COVER_NO, name: "common.no" },
  ],
  GIFT_PRO: [
    { id: OPTION_VALUES.MONEYBACK_YES, name: "common.yes" },
    { id: OPTION_VALUES.MONEYBACK_NO, name: "common.no" },
  ],

  GIFT_PRO_MONEY_BACK: [
    { id: OPTION_VALUES.LIFE_COVER_YES, name: "common.yes" },
    { id: OPTION_VALUES.LIFE_COVER_NO, name: "common.no" },
  ],
  GET_MONEY_BACK_PERCENTAGE: [
    {
      id: OPTION_VALUES.PERCENTAGE_VALUES.HUNDRED_PCT,
      name: "100%",
    },
    {
      id: OPTION_VALUES.PERCENTAGE_VALUES.SEVENTY_FIVE_PCT,
      name: "75%",
    },
    {
      id: OPTION_VALUES.PERCENTAGE_VALUES.FIFTY_PCT,
      name: "50%",
    },
    {
      id: OPTION_VALUES.PERCENTAGE_VALUES.TWENTY_FIVE_PCT,
      name: "25%",
    },
  ],
  BOOLEAN: [
    { id: true, name: "common.yes" },
    { id: false, name: "common.no" },
  ],

  ANNUAL_INCOME: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.ONE_L_FIFTY_K,
      name: "options.up_to2.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.FOUR_L, name: "options.3l_4.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.SIX_L_FIFTY_K, name: "options.5l_7.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.NINE_L, name: "options.8l_9.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.FIFTEEN_L, name: "options.10l_19.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, name: "options.20l_&_above" },
  ],
  ANNUAL_INCOME_IWISH: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.ONE_L_FIFTY_K,
      name: "options.up_to2.4l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.FOUR_L, name: "options.2.5l_4.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.SIX_L_FIFTY_K, name: "options.5l_7.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.NINE_L, name: "options.8l_9.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.FIFTEEN_L, name: "options.10l_19.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, name: "options.20l_&_above" },
  ],

  ANNUAL_INCOME_NRI: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.ONE_L_FIFTY_K,
      name: "options.up_to2.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.FOUR_L, name: "options.3l_4.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.SIX_L_FIFTY_K, name: "options.5l_7.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.NINE_L, name: "options.8l_9.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.FIFTEEN_L, name: "options.10l_19.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.THERTY_L, name: "options.20l_39.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.FORTY_L, name: "options.40l_&_above" },
  ],

  TRUSTEE_TYPE: [
    { id: OPTION_VALUES.TRUSTEE_TYPE.ENTITY, name: "OPTIONS.ENTITY" },
    { id: OPTION_VALUES.TRUSTEE_TYPE.INDIVIDUAL, name: "OPTIONS.INDIVIDUAL" },
  ],

  ACCOUNT_HOLDER_TYPE: [
    { id: "saving account", name: "OPTIONS.SAVINGS_ACCOUNT" },
    { id: "current account", name: "OPTIONS.CURRENT_ACCOUNT" },
  ],

  NRI_ANNUAL_INCOME: [
    { id: OPTION_VALUES.ANNUAL_INCOME.FIFTEEN_L, name: "options.10l_19.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.THERTY_L, name: "options.20l_39.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.FORTY_L, name: "options.40l_&_above" },
  ],
  OCCUPATION: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE,
      name: "options.self_employed",
    },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
  ],
  LANGUAGE: [
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.ENGLISH, name: "options.english" },
    {
      id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.HINDI,
      name: "options.hindi",
    },
    {
      id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.MARATHI,
      name: "options.marathi",
    },
    { id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.TAMIL, name: "options.tamil" },
    {
      id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.TELUGU,
      name: "options.telugu",
    },
    {
      id: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.KANNADA,
      name: "options.kannada",
    },
  ],

  EDUCATION: [
    { id: OPTION_VALUES.EDUCATION.GRADUATE, name: "options.graduate_&_above" },
    {
      id: OPTION_VALUES.EDUCATION.TWELVE_DIPLOMA,
      name: "options.12th_pass_or_diploma_holder",
    },
    {
      id: OPTION_VALUES.EDUCATION.BELOW_TWELVE,
      name: "options.below_12th_pass",
    },
  ],
  NRI_EDUCATION: [
    { id: OPTION_VALUES.EDUCATION.GRADUATE, name: "options.graduate_&_above" },
    {
      id: OPTION_VALUES.EDUCATION.TWELVE_DIPLOMA,
      name: "options.non_graduate",
    },
  ],
  OTHER_CITY: [{ id: OPTION_VALUES.OTHER_CITY, name: "Others" }],
  PAYMENT_TENURE: [
    { id: OPTION_VALUES.PAYMENT_TENURE.YEARLY, name: "options.YEARLY" },
    { id: OPTION_VALUES.PAYMENT_TENURE.MONTHLY, name: "options.MONTHLY" },
    {
      id: OPTION_VALUES.PAYMENT_TENURE.HALF_YEARLY,
      name: "options.HALF_YEARLY",
    },
  ],
  CI_LIFE_COVER_OPTIONS: [1000000, 1500000, 2500000, 5000000, 10000000, 15000000],
  HOUSEWIFE_CI_LIFE_COVER_OPTIONS: [500000, 700000, 1000000, 1200000, 1500000],
  TIME_MERIDIAN: [
    { id: OPTION_VALUES.TIME_MERIDIAN.AM, name: "AM" },
    { id: OPTION_VALUES.TIME_MERIDIAN.PM, name: "PM" },
  ],
  QUOTE_PLAN_DETAILS: [
    { id: OPTION_VALUES.INCOME, name: "Monthly Income" },
    { id: OPTION_VALUES.INCREASING_INCOME, name: "Increasing Monthly Income" },
    { id: OPTION_VALUES.LUMP_SUM_AND_INCOME, name: "Lump Sum + Monthly Income" },
    { id: OPTION_VALUES.LUMP_SUM, name: "Lump Sum Payout" },
  ],
  IPS_SUPER_TOBACCO_CONSUME: [
    { id: OPTION_VALUES.TOBACCO_CONSUMER_YES, name: "common.yes" },
    { id: OPTION_VALUES.TOBACCO_CONSUMER_NO, name: "common.no" },
  ],
  IPS_SUPER_ITR: [
    { id: OPTION_VALUES.NRI_YES, name: OPTION_VALUES.Y_YES },
    { id: OPTION_VALUES.NRI_NO, name: OPTION_VALUES.N_NO },
  ],
  PREGNANCY_OPTIONS: [
    { id: OPTION_VALUES.PREGNANCY_WEEK_OPTIONS.ABOVE_EQUAL_24, name: ">24 weeks" },
    { id: OPTION_VALUES.PREGNANCY_WEEK_OPTIONS.LESS_THAN_24, name: "<=24 weeks" },
  ],
};
export const SIP_NOMINEE_OPTIONS = {
  MALE_NOMINEE_RELATIONSHIP_SINGLE: [{ id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "options.father" }],
  FEMALE_NOMINEE_RELATIONSHIP_SINGLE: [{ id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "options.mother" }],
  MALE_NOMINEE_RELATIONSHIP_DIVORCED: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "options.father" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "options.son" },
  ],
  FEMALE_NOMINEE_RELATIONSHIP_DIVORCED: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "options.daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "options.mother" },
  ],
};

export const SAVINGS_OPTIONS = {
  FEMALE_NOMINEE_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_DAUGHTER, name: "options.grand_daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_MOTHER, name: "options.grand_mother" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.NIECE, name: "options.niece" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SISTER, name: "options.sister" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.AUNT, name: "options.aunt" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "options.daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "options.mother" },
  ],
  FEMALE_NOMINEE_RELATIONSHIP_MARRIED: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.SISTER_IN_LAW, name: "options.sister_in_law" },
  ],
  FEMALE_NOMINEE_RELATIONSHIP_MALE_MARRIED: [{ id: OPTION_VALUES.NOMINEE_RELATIONSHIP.WIFE, name: "options.wife" }],
  MALE_NOMINEE_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_FATHER, name: "options.grand_father" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_SON, name: "options.grand_son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.NEPHEW, name: "options.nephew" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.BROTHER, name: "options.brother" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "options.son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.UNCLE, name: "options.uncle" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "options.father" },
  ],
  MALE_NOMINEE_RELATIONSHIP_MARRIED: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.BROTHER_IN_LAW, name: "options.brother_in_law" },
  ],
  MALE_NOMINEE_RELATIONSHIP_FEMALE_MARRIED: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.HUSBAND, name: "options.husband" },
  ],
  MALE_NOMINEE_RELATIONSHIP_OTHER_MARRIED: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.PARTNER, name: "options.partner" },
  ],
  MALE_NOMINEE_UNDERAGE_EXCLUDE_IDS: [
    OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_FATHER,
    OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.UNCLE,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.HUSBAND,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.PARTNER,
  ],
  FEMALE_NOMINEE_UNDERAGE_EXCLUDE_IDS: [
    OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.AUNT,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER,
    OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_MOTHER,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.WIFE,
    OPTION_VALUES.NOMINEE_RELATIONSHIP.PARTNER,
  ],
};
export const MARITAL_STATUS = {
  696: "Married",
  697: "Single",
  695: "Divorced",
  694: "Widowed",
};

export const APP_FORM_OPTIONS = {
  MARITAL_STATUS: [
    { id: OPTION_VALUES.MARITAL_STATUS.MARRIED, name: "options.married" },
    { id: OPTION_VALUES.MARITAL_STATUS.SINGLE, name: "options.single" },
    { id: OPTION_VALUES.MARITAL_STATUS.DIVORCED, name: "options.divorced" },
    { id: OPTION_VALUES.MARITAL_STATUS.WIDOWED, name: "options.widowed" },
  ],
  HIGHEST_EDUCATION: [
    { id: OPTION_VALUES.HIGHEST_EDUCATION.PG, name: "options.post_grd" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.GRADUATE, name: "options.graduation" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.DIPLOMA, name: "options.diploma" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.TWELTH, name: "options.12" },
    { id: OPTION_VALUES.HIGHEST_EDUCATION.TENTH, name: "options.10" },
  ],
  BOOLEAN: [
    { id: true, name: "common.yes" },
    { id: false, name: "common.no" },
  ],
  OCCUPATION: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE, name: "appForm.label.self_employed" },
    { id: OPTION_VALUES.OCCUPATION.IPRU, name: "options.employee_ipru" },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },

    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CA, name: "options.self_employed_ca" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_DOCTOR, name: "options.self_employed_doctor" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_ARCHITECT, name: "options.self_employed_architect" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_BUSINESSMAN, name: "options.self_employed_businessman" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CONSULTANT, name: "options.self_employed_consultant" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_LAWYER, name: "options.self_employed_lawyer" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    { id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST, name: "options.agriculturalist" },
    { id: OPTION_VALUES.OCCUPATION.STUDENT, name: "options.student" },
    { id: OPTION_VALUES.OCCUPATION.HOUSEWIFE, name: "options.house_wife" },

    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_OTHERS, name: "OPTIONS.OTHERS" },
    { id: OPTION_VALUES.OCCUPATION.OTHERS, name: "OPTIONS.OTHERS" },
  ],
  IDENTITY_PROOF: [
    { id: OPTION_VALUES.IDENTITY_PROOF.MASKED_AADHAR, name: "options.masked_aadhaar" },
    {
      id: OPTION_VALUES.IDENTITY_PROOF.DRIVING_LICENSE,
      name: "options.license",
    },
    { id: OPTION_VALUES.IDENTITY_PROOF.PASSPORT, name: "options.passport" },
    { id: OPTION_VALUES.IDENTITY_PROOF.VOTER_ID, name: "options.voter_id" },
  ],
  IDENTITY_PROOF_GIFT_CITY: [
    { id: OPTION_VALUES.IDENTITY_PROOF.PASSPORT, name: "Valid Passport" },
    {
      id: OPTION_VALUES.IDENTITY_PROOF.DRIVING_LICENSE,
      name: "Valid Driving License",
    },
    { id: OPTION_VALUES.IDENTITY_PROOF.MASKED_AADHAR, name: "Proof of possession of Aadhar Number, if available" },
    { id: OPTION_VALUES.IDENTITY_PROOF.VOTER_ID, name: "Voter's Identity Card of the foreign country" },
    {
      id: OPTION_VALUES.IDENTITY_PROOF.NATIONAL_IDENTITY_CARD,
      name: "National Identity Card of the foreign country issued",
    },
  ],
  AGE_PROOF: [
    { id: OPTION_VALUES.AGE_PROOF.MASKED_AADHAR, name: "options.masked_aadhaar" },
    { id: OPTION_VALUES.AGE_PROOF.PAN_CARD, name: "options.pan" },
    { id: OPTION_VALUES.AGE_PROOF.PASSPORT, name: "options.passport" },
    { id: OPTION_VALUES.AGE_PROOF.DRIVING_LICENSE, name: "options.license" },
    {
      id: OPTION_VALUES.AGE_PROOF.SCHOOL_COLLEGE_RECORD,
      name: "options.school_college_record",
    },
    {
      id: OPTION_VALUES.AGE_PROOF.GOVERNMENT_EMPLOYEE_ID,
      name: "options.government_employee_id",
    },
    {
      id: OPTION_VALUES.AGE_PROOF.PROOF_GSR,
      name: "options.proof_gsr",
    },
    {
      id: OPTION_VALUES.AGE_PROOF.EMPLOYERS_CERTIFICATE,
      name: "options.employers_certificate",
    },
    {
      id: OPTION_VALUES.AGE_PROOF.DEFENCE_I_CARD,
      name: "options.defence_i_card",
    },
    { id: OPTION_VALUES.AGE_PROOF.MUNICIPAL_RECORD, name: "options.municipal_record" },
  ],
  AGE_PROOF_2: [
    { id: OPTION_VALUES.AGE_PROOF.MASKED_AADHAR, name: "options.masked_aadhaar" },
    {
      id: OPTION_VALUES.AGE_PROOF.DRIVING_LICENSE,
      name: "options.license",
    },
    { id: OPTION_VALUES.AGE_PROOF.PASSPORT, name: "options.passport" },
    { id: OPTION_VALUES.AGE_PROOF.PAN_CARD, name: "options.pan" },
  ],
  AGE_PROOF_GIFT_CITY: [
    { id: OPTION_VALUES.AGE_PROOF.PASSPORT, name: "Valid Passport" },
    {
      id: OPTION_VALUES.AGE_PROOF.DRIVING_LICENSE,
      name: "Valid Driving License",
    },
    { id: OPTION_VALUES.AGE_PROOF.MASKED_AADHAR, name: "Proof of possession of Aadhar Number, if available" },
    { id: OPTION_VALUES.AGE_PROOF.VOTER_ID, name: "Voter's Identity Card of the foreign country" },
    {
      id: OPTION_VALUES.AGE_PROOF.NATIONAL_IDENTITY_CARD,
      name: "National Identity Card of the foreign country issued",
    },
  ],
  INSURANCE_REPOSITORY: [
    {
      id: OPTION_VALUES.INSURANCE_REPOSITORY.NO_PREFERENCE,
      name: "No Preference",
    },
    // {
    //   id: OPTION_VALUES.INSURANCE_REPOSITORY.NSDL_DATABASE,
    //   name: "NSDL Database Management Limited",
    // },
    {
      id: OPTION_VALUES.INSURANCE_REPOSITORY.CAMS,
      name: "CAMS Repository Services Limited",
    },
    {
      id: OPTION_VALUES.INSURANCE_REPOSITORY.CSDL,
      name: "Central Insurance Repository Limited (CSDL Group)",
    },
    {
      id: OPTION_VALUES.INSURANCE_REPOSITORY.KIPL,
      name: "Karvy Insurance Repository limited",
    },
  ],
  INDUSTRY_TYPE: [
    { id: OPTION_VALUES.INDUSTRY_TYPE.JEWELLERY, name: "appForm.industry_type.jewellery" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.SHIPPING, name: "appForm.industry_type.shipping" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.SCRAP_DEALING, name: "appForm.industry_type.scrap_dealing" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.STOCK_BROKING, name: "appForm.industry_type.stock_broking" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.IMPORT_EXPORT, name: "appForm.industry_type.import_export" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.REAL_ESTATE, name: "appForm.industry_type.real_estate" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.MINING, name: "appForm.industry_type.mining" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.AGRICULTURE, name: "appForm.industry_type.agriculture" },
    { id: OPTION_VALUES.INDUSTRY_TYPE.OTHERS, name: "appForm.industry_type.others" },
  ],
  ORGANISATION_TYPE: [
    { id: OPTION_VALUES.ORGANISATION_TYPE.PUBLIC_LTD, name: "options.public_ltd" },
    {
      id: OPTION_VALUES.ORGANISATION_TYPE.PRIVATE_LTD,
      name: "options.private_ltd",
    },
    { id: OPTION_VALUES.ORGANISATION_TYPE.GOVERNMENT, name: "options.government" },
    { id: OPTION_VALUES.ORGANISATION_TYPE.PROPREIOTOR, name: "options.proprietor" },
    { id: OPTION_VALUES.ORGANISATION_TYPE.SOCIETY, name: "options.society" },
    { id: OPTION_VALUES.ORGANISATION_TYPE.TRUST, name: "options.trust" },
    { id: OPTION_VALUES.ORGANISATION_TYPE.PARTNOR, name: "options.partnership" },
    {
      id: OPTION_VALUES.ORGANISATION_TYPE.LLP,
      name: "options.llp",
    },
    { id: OPTION_VALUES.ORGANISATION_TYPE.NOT_ANSWERED, name: "OPTIONS.OTHERS" },
  ],
  SELF_EMPLOYED: [
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CA, name: "options.self_employee_ca" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_DOCTOR, name: "options.self_employee_doctor" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_ARCHITECT, name: "options.self_employee_architect" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_BUSINESSMAN,
      name: "options.self_employee_businessman",
    },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_CONSULTANT,
      name: "options.self_employee_consultant",
    },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE_LAWYER, name: "options.self_employee_lawyer" },
  ],
  MY_PROFESSION: [
    { id: OPTION_VALUES.OCCUPATION.CA, name: "options.self_employee_ca" },
    { id: OPTION_VALUES.OCCUPATION.DOCTOR, name: "options.self_employee_doctor" },
    { id: OPTION_VALUES.OCCUPATION.LAWYER, name: "options.self_employee_lawyer" },
    { id: OPTION_VALUES.OCCUPATION.OTHER, name: "OPTIONS.OTHERS" },
  ],
  OCCUPATION_APP_FORM: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    { id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE, name: "appForm.label.self_employed" },
    { id: OPTION_VALUES.OCCUPATION.IPRU, name: "options.employee_ipru" },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
  ],

  NOMINEE_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SISTER, name: "OPTIONS.SISTER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.BROTHER, name: "OPTIONS.BROTHER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "OPTIONS.SON" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "OPTIONS.DAUGHTER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "OPTIONS.FATHER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "OPTIONS.MOTHER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.OTHERS, name: "OPTIONS.OTHERS" },
  ],

  NOMINEE_RELATIONSHIP_PARTNER: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.HUSBAND, name: "OPTIONS.HUSBAND" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.WIFE, name: "OPTIONS.WIFE" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.PARTNER, name: "Partner" },
  ],
  NOMINEE_BLOOD_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "Son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "Daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "Father" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "Mother" },
  ],

  NOMINEE_RELATIONSHIP_STUDENT: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "OPTIONS.FATHER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "OPTIONS.MOTHER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.OTHERS, name: "OPTIONS.OTHERS" },
  ],

  NOMINEE_RELATIONSHIP_OTHERS: [
    {
      id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_DAUGHTER,
      name: "OPTIONS.GRAND_DAUGHTER",
    },
    {
      id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_FATHER,
      name: "OPTIONS.GRAND_FATHER",
    },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_MOTHER, name: "OPTIONS.GRAND_MOTHER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_SON, name: "OPTIONS.GRAND_SON" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.NEPHEW, name: "OPTIONS.NEPHEW" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.NIECE, name: "OPTIONS.NIECE" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.AUNT, name: "OPTIONS.AUNT" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.UNCLE, name: "OPTIONS.UNCLE" },
  ],

  NOMINEE_RELATIONSHIP_OTHERS_STUDENT: [
    {
      id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_FATHER,
      name: "OPTIONS.GRAND_FATHER",
    },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_MOTHER, name: "OPTIONS.GRAND_MOTHER" },
  ],
  NON_BLOOD_RELATION_REASON: [
    { id: OPTION_VALUES.NON_BLOOD_RELATION_REASON.DEPENDENT, name: "options.nomine_is_dependent" },
    {
      id: OPTION_VALUES.NON_BLOOD_RELATION_REASON.IMMEDIATE,
      name: "options.immediate_family_members",
    },
    {
      id: OPTION_VALUES.NON_BLOOD_RELATION_REASON.NO_IMMEDIATE,
      name: "options.no_immediate_family_members",
    },
    { id: OPTION_VALUES.NON_BLOOD_RELATION_REASON.OTHER, name: "options.other_reason" },
  ],

  APPOINTEE_RELATIONSHIP: [
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.GRAND_FATHER, name: "OPTIONS.GRAND_FATHER" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.GRAND_SON, name: "OPTIONS.GRAND_SON" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.NEPHEW, name: "OPTIONS.NEPHEW" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.BROTHER, name: "OPTIONS.BROTHER" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.BROTHER_IN_LAW, name: "OPTIONS.BROTHER_IN_LAW" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.SON, name: "OPTIONS.SON" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.UNCLE, name: "OPTIONS.UNCLE" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.HUSBAND, name: "OPTIONS.HUSBAND" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.FATHER, name: "OPTIONS.FATHER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.GRAND_MOTHER, name: "OPTIONS.GRAND_MOTHER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.GRAND_DAUGHTER, name: "OPTIONS.GRAND_DAUGHTER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.NIECE, name: "OPTIONS.NIECE" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.SISTER, name: "OPTIONS.SISTER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.AUNT, name: "OPTIONS.AUNT" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.DAUGHTER, name: "OPTIONS.DAUGHTER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.SISTER_IN_LAW, name: "OPTIONS.SISTER_IN_LAW" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.WIFE, name: "OPTIONS.WIFE" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.MOTHER, name: "OPTIONS.MOTHER" },
  ],
  APPOINTEE_MALE_RELATIONSHIP: [
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.GRAND_FATHER, name: "options.GRAND_FATHER" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.GRAND_SON, name: "options.GRAND_SON" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.NEPHEW, name: "options.NEPHEW" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.BROTHER, name: "options.BROTHER" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.BROTHER_IN_LAW, name: "options.BROTHER_IN_LAW" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.SON, name: "options.SON" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.UNCLE, name: "options.UNCLE" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.HUSBAND, name: "options.HUSBAND" },
    { id: OPTION_VALUES.APPOINTEE_MALE_RELATIONSHIP.FATHER, name: "options.FATHER" },
  ],

  APPOINTEE_FEMALE_RELATIONSHIP: [
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.GRAND_MOTHER, name: "OPTIONS.GRAND_MOTHER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.GRAND_DAUGHTER, name: "OPTIONS.GRAND_DAUGHTER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.NIECE, name: "OPTIONS.NIECE" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.SISTER, name: "OPTIONS.SISTER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.AUNT, name: "OPTIONS.AUNT" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.DAUGHTER, name: "OPTIONS.DAUGHTER" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.SISTER_IN_LAW, name: "OPTIONS.SISTER_IN_LAW" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.WIFE, name: "OPTIONS.WIFE" },
    { id: OPTION_VALUES.APPOINTEE_FEMALE_RELATIONSHIP.MOTHER, name: "OPTIONS.MOTHER" },
  ],

  MWPA_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.WIFE, name: "OPTIONS.WIFE" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "OPTIONS.SON" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "OPTIONS.DAUGHTER" },
  ],
  TRUSTEE_TYPE: [
    { id: OPTION_VALUES.TRUSTEE_TYPE.ENTITY, name: "OPTIONS.ENTITY" },
    { id: OPTION_VALUES.TRUSTEE_TYPE.INDIVIDUAL, name: "OPTIONS.INDIVIDUAL" },
  ],
  ACCOUNT_TYPE: [
    { id: OPTION_VALUES.ACCOUNT_TYPE.CURRENT, name: "options.CURRENT_ACCOUNT" },
    { id: OPTION_VALUES.ACCOUNT_TYPE.SAVING, name: "options.SAVINGS_ACCOUNT" },
  ],
  MWPA_ACCOUNT_TYPE: [
    { id: OPTION_VALUES.MWPA_ACC_TYPE.CURRENT, name: "options.CURRENT_ACCOUNT" },
    { id: OPTION_VALUES.MWPA_ACC_TYPE.SAVING, name: "options.SAVINGS_ACCOUNT" },
  ],
  TOBACCO_CONSUMED_AS: [
    { id: OPTION_VALUES.TOBACCO_CONSUMED_AS.BIDI, name: "OPTIONS.BIDI" },
    { id: OPTION_VALUES.TOBACCO_CONSUMED_AS.CIGARETTES, name: "OPTIONS.CIGARETTES" },
    { id: OPTION_VALUES.TOBACCO_CONSUMED_AS.CIGARS, name: "OPTIONS.CIGARS" },
    { id: OPTION_VALUES.TOBACCO_CONSUMED_AS.PAN, name: "OPTIONS.PAN" },
    { id: OPTION_VALUES.TOBACCO_CONSUMED_AS.ALL, name: "OPTIONS.ALL_ABOVE" },
  ],
  TOBACCO_PER_DAY: [
    { id: OPTION_VALUES.TOBACCO_PER_DAY.LOW, name: "OPTIONS.LESS_THAN_5" },
    { id: OPTION_VALUES.TOBACCO_PER_DAY.MID, name: "OPTIONS.6_TO_10" },
    { id: OPTION_VALUES.TOBACCO_PER_DAY.HIGH, name: "OPTIONS.GREATER_THAN_10" },
  ],
  ALCOHOL_CONSUMED_AS: [
    { id: OPTION_VALUES.ALCOHOL_CONSUMED_AS.BEER, name: "OPTIONS.BEER" },
    { id: OPTION_VALUES.ALCOHOL_CONSUMED_AS.LIQUOR, name: "OPTIONS.LIQUOR" },
    { id: OPTION_VALUES.ALCOHOL_CONSUMED_AS.WINE, name: "OPTIONS.WINE" },
    { id: OPTION_VALUES.ALCOHOL_CONSUMED_AS.ALL, name: "OPTIONS.ALL_ABOVE" },
  ],
  ALCOHOL_PER_DAY: [
    { id: OPTION_VALUES.ALCOHOL_PER_DAY.LOW, name: "OPTIONS.1_2_PER_DAY" },
    { id: OPTION_VALUES.ALCOHOL_PER_DAY.MID, name: "OPTIONS.GREATER_2_PER_DAY" },
    { id: OPTION_VALUES.ALCOHOL_PER_DAY.OCCASIONAL, name: "OPTIONS.OCCASIONAL" },
  ],
  MEDICAL_CONDITION: [
    { id: OPTION_VALUES.MEDICAL_CONDITION.CURED, name: "OPTIONS.CURED" },
    { id: OPTION_VALUES.MEDICAL_CONDITION.UNDER_CONTROL, name: "OPTIONS.UNDER_CONTROL" },
    { id: OPTION_VALUES.MEDICAL_CONDITION.NOT_CURED, name: "OPTIONS.NOT_CURED" },
    { id: OPTION_VALUES.MEDICAL_CONDITION.NOT_CONTROLLED, name: "OPTIONS.NOT_CONTROLLED" },
  ],
  HEALTH_ILLNESS: [
    { id: OPTION_VALUES.HEALTH_ILLNESS.LIFESTYLE_DISEASE, name: "options.LIFESTYLE_DISEASE" },
    { id: OPTION_VALUES.HEALTH_ILLNESS.CANCER, name: "options.CANCER" },
    { id: OPTION_VALUES.HEALTH_ILLNESS.PHYSICAL_DEFORMALITY, name: "options.PHYSICAL_DEFORMITY" },
    { id: OPTION_VALUES.HEALTH_ILLNESS.ORGAN_DISORDER, name: "options.ORGAN_DISORDER" },
    { id: OPTION_VALUES.HEALTH_ILLNESS.OTHERS, name: "options.OTHERS" },
  ],
  POLICY_COMPANIES: [
    { id: "Life Insurance Corporation of India", name: "LIC of India" },
    { id: "ICICI Life Insurance Co. Ltd,", name: "ICICI Life" },
    { id: "HDFC Standard Life Insurance", name: "HDFC Life" },
    { id: "Max New York Life Insurance", name: "Max New York Life" },
    { id: "SBI Life Insurance", name: "SBI Life Insurance" },
    { id: "Others", name: "Others" },
  ],
  OTHERS_POLICY_COMPANIES: [
    { id: "Aviva Life Insurance", name: "Aviva Life" },
    {
      id: "Acko General Insurance Limited",
      name: "Acko General Insurance Limited",
    },
    {
      id: "Aditya Birla Health Insurance Co. Ltd.",
      name: "Aditya Birla Health",
    },
    {
      id: "Aditya Birla SunLife Insurance Co. Ltd.",
      name: "Aditya Birla SunLife",
    },
    { id: "Birla Sun Life Insurance", name: "Birla Sun Life" },
    {
      id: "Aegon Life Insurance Company Limited",
      name: "Aegon Life Insurance",
    },
    {
      id: "Aegon Religare Life Insurance Company Limited",
      name: "Aegon Religare Life",
    },
    {
      id: "Ageas Federal Life Insurance Company Limited",
      name: "Ageas Federal Life",
    },
    {
      id: "Agriculture Insurance Company of India Ltd.",
      name: "Agriculture Insurance Company",
    },
    {
      id: "Bajaj Allianz General Insurance Company Limited",
      name: "Bajaj Allianz General",
    },
    { id: "Bajaj Allianz Life Insurance", name: "Bajaj Allianz Life" },
    { id: "Bharti Axa General Insurance Co. Ltd.", name: "Bharti Axa General" },
    { id: "Bharti AXA Life Insurance", name: "Bharti AXA Life" },
    {
      id: "Canara HSBC Oriental Bank of Commerce Life Insurance Company Limited",
      name: "Canara HSBC OBC",
    },
    {
      id: "Canara HSBC Oriental Bank of Commerce Life Insurance Company Ltd",
      name: "Canara HSBC OBC Life",
    },
    {
      id: "Care Health Insurance Ltd(formerly known as Religare Health Insurance Co. Ltd.)",
      name: "Care Health Insurance",
    },
    {
      id: "Cholamandalam MS General Insurance Co Ltd",
      name: "Cholamandalam MSG Insurance",
    },
    {
      id: "DLF Pramerica Life Insurance Co. Ltde",
      name: "DHFL Pramerica Life",
    },
    { id: "ECGC Limited", name: "ECGC Limited" },
    { id: "Edelweiss General Insurance Co. Ltd.", name: "Edelweiss General" },
    {
      id: "Edelwiess Tokio Life Insurance Co. Ltd",
      name: "Edelwiess Tokio Life",
    },
    { id: "Exide Life Insurance Co. Ltd.", name: "Exide Life" },
    {
      id: "Future Generali India Insurance Co Ltd",
      name: "Future Generali Insurance",
    },
    {
      id: "Future Generali India Life Insurance Company Limited",
      name: "Future Generali Life",
    },
    { id: "Go Digit General Insurance Limited", name: "Go Digit General" },
    { id: "HDFC ERGO General Insurance Co.Ltd.", name: "HDFC ERGO General" },
    {
      id: "ICICI LOMBARD General Insurance Co. Ltd.",
      name: "ICICI LOMBARD General",
    },
    {
      id: "ICICI Life Insurance Co. Ltd,",
      name: "ICICI Life",
    },
    { id: "IDBI Fortis Life Insurance Company Ltd", name: "IDBI Fortis Life" },
    {
      id: "IFFCO TOKIO General Insurance Co. Ltd.",
      name: "IFFCO TOKIO General",
    },
    { id: "India First Life Insurance", name: "India First Life" },
    { id: "ING Vysya Life", name: "ING Vysya Life" },
    { id: "Kotak Life Insurance", name: "Kotak Life Insurance" },
    {
      id: "Kotak Mahindra General Insurance Company Limited",
      name: "Kotak Mahindra General",
    },
    {
      id: "Kotak Mahindra Life Insurance Co. Ltd.",
      name: "Kotak Mahindra Life",
    },
    { id: "Liberty General Insurance Ltd.", name: "Liberty General" },
    { id: "Magma HDI General Insurance Co. Ltd.", name: "Magma HDI General" },
    {
      id: "Manipal Cigna Health Insurance Company Limited",
      name: "Manipal Cigna Health",
    },
    { id: "Max Life Insurance Co. Ltd.", name: "Max Life Insurance" },
    { id: "MetLife India Insurance", name: "MetLife India Insurance" },
    { id: "National Insurance Co. Ltd.", name: "National Insurance" },
    { id: "Navi General Insurance Limited", name: "Navi General" },
    { id: "The New India Assurance Co. Ltd", name: "New India Assurance" },
    { id: "Niva Bupa Health Insurance Co Ltd.", name: "Niva Bupa Health" },
    {
      id: "The Oriental Insurance Company Limited",
      name: "Oriental Insurance",
    },
    { id: "PNB MetLife India Insurance Co. Ltd.", name: "PNB MetLife India" },
    { id: "Postal Life Insurance", name: "Postal Life" },
    { id: "Pramerica Life Insurance Co. Ltd.", name: "Pramerica Life" },
    { id: "Raheja QBE General Insurance Co. Ltd.", name: "Raheja QBE General" },
    {
      id: "Reliance General Insurance Co.Ltd",
      name: "Reliance General Insurance",
    },
    {
      id: "Reliance Nippon Life Insurance Company",
      name: "Reliance Nippon Life",
    },
    { id: "Reliance Life Insurance", name: "Reliance Life" },
    {
      id: "Religare Health Insurance Co. Ltd.",
      name: "Religare Health Insurance",
    },
    {
      id: "Royal Sundaram General Insurance Co. Ltd.",
      name: "Royal Sundaram General",
    },
    { id: "SAHARA INDIA Life Insurance", name: "Sahara Life" },
    {
      id: "SBI General Insurance Company Limited",
      name: "SBI General Insurance",
    },
    {
      id: "Shriram General Insurance Company Limited",
      name: "Shriram General",
    },
    { id: "Shriram Life Insurance", name: "Shriram Life" },
    {
      id: "Star Health & Allied Insurance Co.Ltd.",
      name: "Star Health & Allied",
    },
    {
      id: "Star Union Dai-ichi Life Insurance Co Ltd",
      name: "Star Union Dai-ichi Life",
    },
    { id: "Tata AIG General Insurance Co. Ltd.", name: "Tata AIG General" },
    { id: "Tata AIA Life Insurance", name: "Tata AIA Life" },
    { id: "Tata AIG Life Insurance", name: "Tata AIG Life" },
    { id: "Unit Trust Of India", name: "Unit Trust of India" },
    {
      id: "United India Insurance Company Limited",
      name: "United India Insurance",
    },
    {
      id: "Universal Sompo General Insurance Co. Ltd.",
      name: "Universal Sompo General",
    },
  ],
  INCOME_PROOF: [
    { id: OPTION_VALUES.INCOME_PROOF.FORM_16, name: "verification_modal.form_130" },
    { id: OPTION_VALUES.INCOME_PROOF.FORM_16_LATEST, name: "verification_modal.latest_form_131" },
    { id: OPTION_VALUES.INCOME_PROOF.FORM_16_RECOMMENDED, name: "verification_modal.form_130_recommended" },
    {
      id: OPTION_VALUES.INCOME_PROOF.FORM_16_LATEST_RECOMMENDED,
      name: "verification_modal.latest_form_130_recommended",
    },
    { id: OPTION_VALUES.INCOME_PROOF.BANK, name: "verification_modal.bank_statement_salary_3m" },
    { id: OPTION_VALUES.INCOME_PROOF.BANK_REGULAR, name: "verification_modal.bank_statement_regular_6m" },
    { id: OPTION_VALUES.INCOME_PROOF.ITR, name: "verification_modal.itr_3_years" },
    {
      id: OPTION_VALUES.INCOME_PROOF.COMPANY_FINANCIAL,
      name: "verification_modal.company_financial_3_years",
    },
    {
      id: OPTION_VALUES.INCOME_PROOF.ITR_AND_6_MON_BANK,
      name: "verification_modal.itr_and_bank_6m",
    },
    {
      id: OPTION_VALUES.INCOME_PROOF.SALARY,
      name: "verification_modal.salary_and_bank",
    },
    { id: OPTION_VALUES.INCOME_PROOF.COMPANY_ID, name: "verification_modal.company_id_card" },
    {
      id: OPTION_VALUES.INCOME_PROOF.APPOINTMENT,
      name: "verification_modal.appointment_letter_salary",
    },
  ],
  INCOME_PROOF_ORGANISATION: [
    { id: OPTION_VALUES.INCOME_PROOF.COMPANY_ID, name: "Company ID card+Last month's salary slip" },
  ],
  ADDRESS_PROOF: [
    { id: OPTION_VALUES.ADDRESS_PROOF.AADHAR, name: "options.masked_aadhaar" },
    { id: OPTION_VALUES.ADDRESS_PROOF.DRIVING_LICENSE, name: "options.license" },
    { id: OPTION_VALUES.ADDRESS_PROOF.PASSPORT, name: "options.passport" },
    { id: OPTION_VALUES.ADDRESS_PROOF.VOTER_ID, name: "options.voter_id" },
  ],
  BENEFICIARY_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.WIFE, name: "OPTIONS.WIFE" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "OPTIONS.DAUGHTER" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "OPTIONS.SON" },
  ],
  SMART_KID_NOMINEE_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_DAUGHTER, name: "Grand Daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_SON, name: "Grand Son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "Son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "Daughter" },
  ],
  EIA_PREFERENCE: [
    { id: OPTION_VALUES.EIA_PREFERENCE.NO_PREFERENCE, name: "No preference" },
    // { id: OPTION_VALUES.EIA_PREFERENCE.NDML, name: "NSDL Database Management Limited" },
    { id: OPTION_VALUES.EIA_PREFERENCE.CAMSREP, name: "CAMS Repository Services Limited" },
    { id: OPTION_VALUES.EIA_PREFERENCE.CIRL, name: "Central Insurance Repository Limited (CDSL Group)" },
    { id: OPTION_VALUES.EIA_PREFERENCE.KARVY, name: "Karvy Insurance Repository limited" },
  ],
  MALE_NOMINEE_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_SON, name: "Grand Son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "Son" },
  ],
  FEMALE_NOMINEE_RELATIONSHIP: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP_OTHERS.GRAND_DAUGHTER, name: "Grand Daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "Daughter" },
  ],
  NATIONALITY: [
    { id: OPTION_VALUES.NATIONALITY.INDIAN, name: "Indian" },
    { id: OPTION_VALUES.NATIONALITY.NONINDIAN, name: "Non Indian" },
  ],
  PIO_OCI: [
    { id: OPTION_VALUES.PIO_OCI.PIO_CI, name: "PIO/OCI" },
    { id: OPTION_VALUES.PIO_OCI.FOREIGN, name: "Foreign National" },
  ],
  BANK_ACCOUNT: [
    { id: OPTION_VALUES.BANK_ACCOUNT.NRE, name: "NRE" },
    { id: OPTION_VALUES.BANK_ACCOUNT.NRO, name: "NRO" },
  ],
  BANK_ACCOUNT_FULL: [
    { id: OPTION_VALUES.BANK_ACCOUNT.NRE, name: "NRE account" },
    { id: OPTION_VALUES.BANK_ACCOUNT.NRO, name: "NRO account" },
  ],

  ABROADSTAY_PURPOSE: [
    { id: OPTION_VALUES.ABROADSTAY_PURPOSE.RESIDENT_NATIONAL, name: "Resident National" },
    { id: OPTION_VALUES.ABROADSTAY_PURPOSE.OCCUPATION, name: "Occupation" },
    { id: OPTION_VALUES.ABROADSTAY_PURPOSE.STUDENT, name: "Student" },
    { id: OPTION_VALUES.ABROADSTAY_PURPOSE.DEPENDENT, name: "Dependent" },
    { id: OPTION_VALUES.ABROADSTAY_PURPOSE.HOUSEWIFE, name: "Housewife" },
  ],
  TRAVEL_PURPOSE: [
    { id: OPTION_VALUES.TRAVEL_PURPOSE.BUSINESS, name: "Business" },
    { id: OPTION_VALUES.TRAVEL_PURPOSE.EMPLOYEMENT, name: "Employment" },
    { id: OPTION_VALUES.TRAVEL_PURPOSE.TOURISM, name: "Tourism" },
    { id: OPTION_VALUES.TRAVEL_PURPOSE.VACATION, name: "Vacation" },
    { id: OPTION_VALUES.TRAVEL_PURPOSE.FAMILY, name: "Family" },
  ],
  RESIDENCE_TYPE: [
    { id: OPTION_VALUES.RESIDENCE_TYPE.HOTEL, name: "Hotel" },
    { id: OPTION_VALUES.RESIDENCE_TYPE.RENTED_HOUSE, name: "Rented House" },
    { id: OPTION_VALUES.RESIDENCE_TYPE.OWNED_HOUSE, name: "Owned House" },
    { id: OPTION_VALUES.RESIDENCE_TYPE.GUEST_HOUSE, name: "Guest House" },
  ],
  TRAVEL_MODE: [
    { id: OPTION_VALUES.TRAVEL_MODE.PRIVATE, name: "Private" },
    { id: OPTION_VALUES.TRAVEL_MODE.OWNED, name: "Owned Vehicle" },
    { id: OPTION_VALUES.TRAVEL_MODE.PUBLIC, name: "Public" },
  ],
  MONTH: [
    { id: OPTION_VALUES.MONTHS.ZERO_MONTH, name: "0 Month" },
    { id: OPTION_VALUES.MONTHS.ONE_MONTH, name: "1 Month" },
    { id: OPTION_VALUES.MONTHS.TWO_MONTHS, name: "2 Months" },
    { id: OPTION_VALUES.MONTHS.THREE_MONTHS, name: "3 Months" },
    { id: OPTION_VALUES.MONTHS.FOUR_MONTHS, name: "4 Months" },
    { id: OPTION_VALUES.MONTHS.FIVE_MONTHS, name: "5 Months" },
    { id: OPTION_VALUES.MONTHS.SIX_MONTHS, name: "6 Months" },
    { id: OPTION_VALUES.MONTHS.SEVEN_MONTHS, name: "7 Months" },
    { id: OPTION_VALUES.MONTHS.EIGHT_MONTHS, name: "8 Months" },
    { id: OPTION_VALUES.MONTHS.NINE_MONTHS, name: "9 Months" },
    { id: OPTION_VALUES.MONTHS.TEN_MONTHS, name: "10 Months" },
    { id: OPTION_VALUES.MONTHS.ELEVEN_MONTHS, name: "11 Months" },
  ],
  COUNTRIES_INDIA_ONLY: [{ id: "India", name: "India" }],
};

export const SIGANTURE_ULIP_CHECKS = {
  SUITABILITY: {
    GOLAS_RETIREMENT: "Retirement",
    SATGE_MARRIED_AND_CHILD: "marriedChildren",
    SATGE_RETIREMENT: "nearlyRetirement",
  },
  STARTING_INVESTMENT_RETIREMENT: 5000,
  STARTING_INVESTMENT_DEFAULT: 2500,
};

export const PROTECT_GAIN_OPTIONS = {
  GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
  ],
  ANNUAL_INCOME: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.TWO_L_FIFTY_K,
      name: "options.upto2.9l",
    },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.FOUR_L,
      name: "options.3l_4.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.SIX_L_FIFTY_K, name: "options.5l_7.9l" },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.NINE_L,
      name: "options.8l_9.9l",
    },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.FIFTEEN_L,
      name: "options.10l_19.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, name: "options.20l_plus" },
  ],
};

export const SARAL_PENSION_OPTIONS = {
  GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
  ],
  PENSION_FREQUENCY: [
    { id: OPTION_VALUES.PENSION_FREQUENCY.MONTHLY, name: "Monthly" },
    { id: OPTION_VALUES.PENSION_FREQUENCY.QUARTERLY, name: "Quarterly" },
    { id: OPTION_VALUES.PENSION_FREQUENCY.HALF_YEARLY, name: "Half Yearly" },
    { id: OPTION_VALUES.PENSION_FREQUENCY.YEARLY, name: "Yearly" },
  ],
  PENSION_FOR: [
    { id: OPTION_VALUES.PENSION_FOR.ME, name: "Me" },
    { id: OPTION_VALUES.PENSION_FOR.ME_SPOUSE, name: "Me and spouse" },
  ],
  JOINT_LIFE_RELATION: [
    { id: OPTION_VALUES.GENDER.MALE, name: "Husband" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "Wife" },
  ],
};

export const GPP_FLEXI_OPTIONS = {
  GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
    { id: OPTION_VALUES.GENDER.TRANSGENDER, name: "options.other" },
  ],
  MARITAL_STATUS: [
    { id: OPTION_VALUES.MARITAL_STATUS.MARRIED, name: "Married" },
    { id: OPTION_VALUES.MARITAL_STATUS.SINGLE, name: "Single" },
    { id: OPTION_VALUES.MARITAL_STATUS.DIVORCED, name: "Divorced" },
    { id: OPTION_VALUES.MARITAL_STATUS.WIDOWED, name: "Widowed" },
  ],
  ANNUITY_OPTIONS: [
    { id: OPTION_VALUES.ANNUITY.ME, name: "Me" },
    { id: OPTION_VALUES.ANNUITY.ME_NOMINEE, name: "Me & Nominee" },
    { id: OPTION_VALUES.ANNUITY.ME_JOINT, name: "Me & Joint life" },
    { id: OPTION_VALUES.ANNUITY.ME_JOINT_NOMINEE, name: "Me, Joint life & Nominee" },
  ],
  JOINT_LIFE_RELATION: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "Father" }, // ask for the name in 1619
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "Mother" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.WIFE, name: "Wife" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "Son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "Daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.BROTHER, name: "Brother" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SISTER, name: "Sister" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.HUSBAND, name: "Husband" },
  ],
  JOINT_LIFE_RELATION_FEMALE: [
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.FATHER, name: "Father" }, // ask for the name in 1619
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.MOTHER, name: "Mother" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.HUSBAND, name: "Husband" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SON, name: "Son" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.DAUGHTER, name: "Daughter" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.BROTHER, name: "Brother" },
    { id: OPTION_VALUES.NOMINEE_RELATIONSHIP.SISTER, name: "Sister" },
  ],
  PAYMENT_FREQUENCY: [
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.MONTHLY, name: "Monthly" },
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.HALF_YEARLY, name: "Half-Yearly" },
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.YEARLY, name: "Yearly" },
  ],
  ANNUITY_FREQUENCY: [
    { id: OPTION_VALUES.GPP_PAYMENT_TENURE.MONTHLY, name: "Monthly" },
    { id: OPTION_VALUES.GPP_PAYMENT_TENURE.QUARTERLY, name: "Quarterly" },
    { id: OPTION_VALUES.GPP_PAYMENT_TENURE.HALF_YEARLY, name: "Half-Yearly" },
    { id: OPTION_VALUES.GPP_PAYMENT_TENURE.YEARLY, name: "Yearly" },
  ],
  BUYING_FOR: [
    {
      id: OPTION_VALUES.BUYING_FOR.SELF,
      name: "options.self",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/SelfButton.8b8665f718d692236ad9b62adee5d240.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.SPOUCE,
      name: "options.spouse",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/Spouse.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.CHILD,
      name: "options.child",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/Child.svg`,
    },
    {
      id: OPTION_VALUES.OCCUPATION.OTHER,
      name: "options.other",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/GrandChild.svg`,
    },
  ],
  OCCUPATION: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE,
      name: "options.self_employed",
    },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    {
      id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST,
      name: "options.agriculturalist",
    },
  ],
  OCCUPATION_FEMALE: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE,
      name: "options.self_employed",
    },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    { id: OPTION_VALUES.OCCUPATION.HOUSEWIFE, name: "options.house_wife" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    {
      id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST,
      name: "options.agriculturalist",
    },
  ],
};

export const SIP_PLUS_OPTIONS = {
  ANNUAL_INCOME: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.TWO_L_FIFTY_K,
      name: "options.upto4.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.SEVEN_L_FIFTY_K, name: "options.5l_9.9l" },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.TWELVE_L_FIFTY_K,
      name: "options.10l-14.9l",
    },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.SEVENTEEN_L_FIFTY_K,
      name: "options.15l_19.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, name: "options.20l_plus" },
  ],
};

export const SIGANTURE_ULIP_OPTIONS = {
  BUYING_FOR: [
    {
      id: OPTION_VALUES.BUYING_FOR.SELF,
      name: "options.self",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/SelfButton.8b8665f718d692236ad9b62adee5d240.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.SPOUCE,
      name: "options.spouse",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/Spouse.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.CHILD,
      name: "options.child",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/Child.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.GRANDHILD,
      name: "options.grandchild",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/GrandChild.svg`,
    },
  ],
  BUYING_FOR_RELATION: [
    {
      id: OPTION_VALUES.BUYING_FOR.SELF,
      name: "options.self",
    },
    {
      id: OPTION_VALUES.BUYING_FOR.SPOUCE,
      name: "options.spouse",
    },
    {
      id: OPTION_VALUES.BUYING_FOR.CHILD,
      name: "options.child",
    },
    {
      id: OPTION_VALUES.BUYING_FOR.GRANDHILD,
      name: "options.grandchild",
    },
    {
      id: OPTION_VALUES.BUYING_FOR.FATHER,
      name: "options.father",
    },
    {
      id: OPTION_VALUES.BUYING_FOR.MOTHER,
      name: "options.mother",
    },
    {
      id: OPTION_VALUES.BUYING_FOR.GRAND_FATHER,
      name: "options.grandfather",
    },
    {
      id: OPTION_VALUES.BUYING_FOR.GRAND_MOTHER,
      name: "options.grandmother",
    },
  ],
  BUYING_FOR_RETIREMENT: [
    {
      id: OPTION_VALUES.BUYING_FOR.SELF,
      name: "options.self",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/SelfButton.8b8665f718d692236ad9b62adee5d240.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.SPOUCE,
      name: "options.spouse",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/Spouse.svg`,
    },
  ],
  BUYING_FOR_CHILD: [
    {
      id: OPTION_VALUES.BUYING_FOR.SELF,
      name: "options.self",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/SelfButton.8b8665f718d692236ad9b62adee5d240.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.CHILD,
      name: "options.child",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/Child.svg`,
    },
    {
      id: OPTION_VALUES.BUYING_FOR.GRANDHILD,
      name: "options.grandchild",
      icon: `${process.env.REACT_APP_ASSET_PATH}/signature-ulip/landing-page/GrandChild.svg`,
    },
  ],
  GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
    { id: OPTION_VALUES.GENDER.TRANSGENDER, name: "options.other" },
  ],
  GENDERWITHOUTOTHER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
  ],
  ANNUAL_INCOME: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.TWO_L_FIFTY_K,
      name: "options.upto4.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.SIX_L_FIFTY_K, name: "options.5l_7.4l" },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.EIGHT_L_SEVENTY_FIVE_K,
      name: "options.7.5l_9.9l",
    },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.TWELVE_L_FIFTY_K,
      name: "options.10l-14.9l",
    },
    {
      id: OPTION_VALUES.ANNUAL_INCOME.SEVENTEEN_L_FIFTY_K,
      name: "options.15l_19.9l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, name: "options.20l_plus" },
  ],
  EDUCATION: [
    {
      id: OPTION_VALUES.EDUCATION.BELOW_TWELVE,
      name: "options.signature_below_12th_pass",
    },
    {
      id: OPTION_VALUES.EDUCATION.TWELVE_DIPLOMA,
      name: "options.signature_12th_pass_or_diploma_holder",
    },
    { id: OPTION_VALUES.EDUCATION.GRADUATE, name: "options.graduate_&_above" },
  ],
  OCCUPATION: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE,
      name: "options.self_employed",
    },
    { id: OPTION_VALUES.OCCUPATION.HOUSEWIFE, name: "options.housewife" },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    {
      id: OPTION_VALUES.OCCUPATION.AGRICULTURALIST,
      name: "options.agriculturalist",
    },
    { id: OPTION_VALUES.OCCUPATION.STUDENT, name: "options.student" },
  ],
  NRI: [
    { id: OPTION_VALUES.NRI_YES, name: OPTION_VALUES.Y_YES },
    { id: OPTION_VALUES.NRI_NO, name: OPTION_VALUES.N_NO },
  ],
  ASSURE_YOUNGSTER_NEED_TO_KNOW: [
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.ONE_YEAR, name: "1 Year" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.THREE_YEARS, name: "3 Years" },
    { id: SMART_KID_OPTION_VALUES.RETURN_YEARS.FIVE_YEARS, name: "5 Years" },
  ],
  SWP: [
    { id: "Retirement", name: "fund.fundAllocation.regularPayout" },
    { id: "Do It Yourself", name: "fund.fundAllocation.doItYourself" },
  ],
  SWP_DOITYOURSELF: [{ id: "Do It Yourself", name: "fund.fundAllocation.doItYourself" }],
};

export const DEFAULT = {
  ips_calculator: {
    nri: OPTION_VALUES.NRI_NO,
    tobbacco: OPTION_VALUES.TOBACCO_CONSUMER_NO,
    married: OPTION_VALUES.UNMARRIED,
    occupation: OPTION_VALUES.OCCUPATION.SALARIED,
    staff: OPTION_VALUES.STAFF_N,
    education: OPTION_VALUES.EDUCATION.GRADUATE,
    gender: OPTION_VALUES.GENDER.MALE,
    emp_discount: 19,
    itr: OPTION_VALUES.Y_YES,
  },
  smart_kid_calculator: {
    gender: OPTION_VALUES.GENDER.MALE,
    languages: SMART_KID_OPTION_VALUES.LANGUAGES_TYPE.ENGLISH,
  },
  i_wish: {
    gender: OPTION_VALUES.GENDER.FEMALE,
  },
  signature_ulip: {
    gender: OPTION_VALUES.GENDER.MALE,
    education: OPTION_VALUES.EDUCATION.GRADUATE,
    relation: OPTION_VALUES.BUYING_FOR.SELF,
    propGender: OPTION_VALUES.GENDER.MALE,
    nri: OPTION_VALUES.NRI_NO,
    occupation: OPTION_VALUES.OCCUPATION.SALARIED,
    maritalStatus: OPTION_VALUES.MARITAL_STATUS.MARRIED,
  },
};

export const EbiPaymentOptionName = {
  WL: "Whole life",
  WLLP: "Limited Whole life",
  SP: "Single Pay",
  RP: "Regular Pay",
  LP: "Limited Pay",
  LP5: "Limited Pay",
  LP7: "Limited Pay",
  LP10: "Limited Pay",
  LP15: "Limited Pay",
  LPT5: "Limited Pay Term",
  LP60: "Limited Pay 60",
  WLLP10: "Limited Whole Life 10",
  WLLP60: "Limited Whole Life",
  WLRP: "Regular Whole life",
};

export const PAYMENT_OPTIONS = {
  [OPTION_VALUES.SP]: {
    type: OPTION_VALUES.SP,
    titleKey: "options.sp",
    years: "",
  },
  [OPTION_VALUES.RP]: {
    type: OPTION_VALUES.RP,
    titleKey: "options.rp",
    years: "",
  },
  [OPTION_VALUES.LP]: {
    type: OPTION_VALUES.LP,
    titleKey: "options.lp",
    years: "",
  },
  [OPTION_VALUES.LP5]: {
    type: OPTION_VALUES.LP,
    titleKey: "options.lp",
    years: "5",
  },
  [OPTION_VALUES.LP7]: {
    type: OPTION_VALUES.LP,
    titleKey: "options.lp",
    years: "7",
  },
  [OPTION_VALUES.LP10]: {
    type: OPTION_VALUES.LP,
    titleKey: "options.lp",
    years: "10",
  },
  [OPTION_VALUES.LP15]: {
    type: OPTION_VALUES.LP,
    titleKey: "options.lp",
    years: "15",
  },
  [OPTION_VALUES.LPT5]: {
    type: OPTION_VALUES.LP,
    titleKey: "options.lp",
    years: "",
  },
  [OPTION_VALUES.LP60]: {
    type: OPTION_VALUES.LP,
    titleKey: "options.lp",
    years: "60",
  },
  [OPTION_VALUES.WLLP10]: {
    type: OPTION_VALUES.WLLP,
    titleKey: "options.lp",
    years: "10",
  },
  [OPTION_VALUES.WLLP60]: {
    type: OPTION_VALUES.WLLP,
    titleKey: "options.lp",
    years: "60",
  },
  [OPTION_VALUES.WLRP]: {
    type: OPTION_VALUES.WL,
    titleKey: "options.rp",
    years: "",
  },
};

export const PREMIUM_MULTIPLE_FACTOR = {
  18: 35,
  31: 30,
  36: 25,
  41: 20,
  46: 15,
  51: 10,
  56: 5,
};

export const PNG_PREMIUM_MULTIPLE_FACTOR = {
  18: 25,
  41: 20,
  46: 15,
};

export const PERSONA_URL_PARAMS = "personaa";

export const PERSONA_PAGES = {
  WORKING_WOMEN: "Working_Women",
  ALL_IN_ONE: "All_in_One",
  MONTHLY_INCOME: "monthlyincome",
  LIMITED_PAY: "Limited_Pay",
  SMART_EXIT: "smartexit",
  JOINT_LIFE: "jointlife",
  PARTNER_PERSONA: "partnerpersona",
  EMPLOYEE_PERSONA: "employee",
  ONE_CRORE: "buy-1-crore-term",
  SKY_360: "sky360",
  INFORMAL: "informal",
};
export const ONE_CRORE_TERM = "buy-1-crore-term-insurance";
export const BOOK_AN_APPOINTMENT = "book-an-appointment";

export const EMPLOYEE_PERSONA_PAGES = ["jointlife", "partnerpersona", "employee"];

export const non_directional_UIDs = [
  40438, 40438, 40446, 40437, 40428, 40429, 40430, 40431, 40432, 40433, 40434, 40435, 40436, 40440, 40441, 40442, 40443,
  40444, 40445, 40447, 40448, 40449, 40450, 40451, 40452, 40453, 40454, 40455, 40456, 40457, 40458, 40459, 40460, 40461,
  40462, 40463, 40464, 40465, 40466, 40467, 40468, 40439,
];

export const IPS_PERSONA_DEFAULT_VALUES = {
  [PERSONA_PAGES.WORKING_WOMEN]: {
    gender: OPTION_VALUES.GENDER.FEMALE,
  },
};
export const getMaritalStatusCode = () => {
  const status = OPTION_VALUES.MARITAL_STATUS;
  return {
    M: status.MARRIED,
    S: status.SINGLE,
    D: status.DIVORCED,
    W: status.MARRIED,
  };
};

export const QuoteOption = {
  [OPTION_VALUES.LUMP_SUM]: "Lump-Sum",
  [OPTION_VALUES.INCOME]: "Income",
  [OPTION_VALUES.INCREASING_INCOME]: "Increasing Income",
  [OPTION_VALUES.LUMP_SUM_AND_INCOME]: "Lump-Sum-Income",
};

export const IPS_RIDER = {
  ADB: "ADBW",
  ADBV: "ADBV",
  CI: "CIRIDER",
  CICL: "CICL",
  CICM: "CICM",
  ATPD: "ATPD",
  WOP: "WOP",
  WOPH: "WOPH",
  WOPHC: "WOPHC",
};

export const SMART_KID_UPLOAD_FILE_NAMES = {
  AGE_PROOF: "AgeProof",
  ADDRESS_PROOF: "AddressProof",
  PHOTO_ID_PROOF: "PhotoIdProof",
  PAN: "PAN",
  INCOME_PROOF: "IncomeProof",
  PAYOUT_PROOF: "Payout_Mandate",
  SCANNED_PHOTO_ID: "ScannedPhotograph",
};

export const SIGNATURE_UPLOAD_FILE_LA_NAMES = {
  AGE_PROOF: "LifeAssured_AgeProof",
  ADDRESS_PROOF: "LifeAssured_AddressProof",
  PHOTO_ID_PROOF: "LifeAssured_PhotoIdProof",
  PAN: "LifeAssured_PAN",
  INCOME_PROOF: "LifeAssured_IncomeProof",
  PAYOUT_PROOF: "LifeAssured_Payout_Mandate",
  SCANNED_PHOTO_ID: "LifeAssured_ScannedPhotograph",
  OTHERS_PROOF: "LifeAssured_Others",
};

export const SMART_KID_UPLOAD_ITEMS = [
  {
    id: "age",
    heading: "savingsAppForm.doc_upload_section.age_proof",
    subHeading: "savingsAppForm.doc_upload_section.age_proof_desc",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.MASKED_AADHAR]: [
        {
          label: "savingsAppForm.doc_upload_section.masked_aadhaar",
          id: "maskedAdhr",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BIRTH_CERTIFICATE]: [
        {
          label: "savingsAppForm.doc_upload_section.birth_certificate",
          id: "birthCert",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BAPTISM_CERTIFICATE]: [
        {
          label: "savingsAppForm.doc_upload_section.baptism_certificate",
          id: "baptismCert",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PASSING_CERTIFICATE]: [
        {
          label: "savingsAppForm.doc_upload_section.passing_certificate",
          id: "passingCert",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.GOVT_ID_PROOF]: [
        {
          label: "savingsAppForm.doc_upload_section.govt_id_proof",
          id: "govId",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.SCHOOL_CERTIFICATE]: [
        {
          label: "savingsAppForm.doc_upload_section.school_college_certificate",
          id: "schoolCert",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.COLLEGE_ID]: [
        {
          label: "savingsAppForm.doc_upload_section.college_id",
          id: "collegeId",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.AGE_PROOF,
        },
      ],
    },
    options: [
      {
        name: "savingsAppForm.doc_upload_section.masked_aadhaar",
        id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.MASKED_AADHAR,
      },
      {
        name: "savingsAppForm.doc_upload_section.birth_certificate",
        id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BIRTH_CERTIFICATE,
      },
      {
        name: "savingsAppForm.doc_upload_section.baptism_certificate",
        id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BAPTISM_CERTIFICATE,
      },
      {
        name: "savingsAppForm.doc_upload_section.passing_certificate",
        id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PASSING_CERTIFICATE,
      },
      {
        name: "savingsAppForm.doc_upload_section.govt_id_proof",
        id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.GOVT_ID_PROOF,
      },
      {
        name: "savingsAppForm.doc_upload_section.school_college_certificate",
        id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.SCHOOL_CERTIFICATE,
      },
      { name: "savingsAppForm.doc_upload_section.college_id", id: "collegeId" },
    ],
    optionsType: "select",
    // added for addhar/pan kyc upload mark
    isAadharKycDoc: true,
    isPanKycDoc: true,
  },
  {
    id: "address",
    subHeading: "savingsAppForm.doc_upload_section.address_proof_desc",
    heading: "savingsAppForm.doc_upload_section.id_and_address_proof",
    title: {
      [OPTION_VALUES.IDENTITY_PROOF.MASKED_AADHAR]: [
        {
          label: "savingsAppForm.doc_upload_section.front",
          id: "aadhaarFront",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.FRONT_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.ADDRESS_PROOF,
        },
        {
          label: "savingsAppForm.doc_upload_section.back",
          id: "aadhaarBack",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.BACK_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.ADDRESS_PROOF,
        },
      ],
      [OPTION_VALUES.IDENTITY_PROOF.PASSPORT]: [
        {
          label: "savingsAppForm.doc_upload_section.front",
          id: "passFirst",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.FRONT_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.ADDRESS_PROOF,
        },
        {
          label: "savingsAppForm.doc_upload_section.back",
          id: "passLast",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.BACK_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.ADDRESS_PROOF,
        },
      ],
      [OPTION_VALUES.IDENTITY_PROOF.DRIVING_LICENSE]: [
        {
          label: "savingsAppForm.doc_upload_section.front",
          id: "License",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.FRONT_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.ADDRESS_PROOF,
        },
      ],
    },
    optionsType: "button",
    options: [
      { id: OPTION_VALUES.IDENTITY_PROOF.MASKED_AADHAR, name: "savingsAppForm.doc_upload_section.masked_aadhar" },
      {
        id: OPTION_VALUES.IDENTITY_PROOF.DRIVING_LICENSE,
        name: "savingsAppForm.doc_upload_section.driving_license",
      },
      { id: OPTION_VALUES.IDENTITY_PROOF.PASSPORT, name: "savingsAppForm.doc_upload_section.passport" },
    ],
    subHeadingLink: "https://eaadhaar.uidai.gov.in/",

    isAadharKycDoc: true,
    isPanKycDoc: true,
  },
  {
    id: "photograph",
    heading: "savingsAppForm.doc_upload_section.photograph",
    subHeading: "savingsAppForm.doc_upload_section.select_your_photo_or_click_selfie",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PHOTOGRAPH]: [
        {
          label: "",
          id: "profile",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.PHOTOGRAPH_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.PHOTO_ID_PROOF,
        },
      ],
    },
    isAadharKycDoc: true,
    isPanKycDoc: false,
  },
  {
    id: "pan",
    heading: "savingsAppForm.doc_upload_section.pan",
    subHeading: "savingsAppForm.doc_upload_section.pan_desc",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PAN]: [
        {
          label: "",
          id: "panCard",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.PAN_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.PAN,
        },
      ],
    },
    example: {
      heading: "savingsAppForm.doc_upload_section.pan_card",
      subHeading: "savingsAppForm.doc_upload_section.front",
      image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.EXAMPLE_PAN_CARD,
      content: "savingsAppForm.doc_upload_section.name_should_match_with_pan",
    },
  },
  {
    id: "income",
    heading: "savingsAppForm.doc_upload_section.income_proof",
    subHeading: "savingsAppForm.doc_upload_section.income_proof_desc",
    title: {
      [OPTION_VALUES.INCOME_PROOF.FORM_16]: [
        {
          label: "savingsAppForm.doc_upload_section.upload_form_16",
          id: "form16",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
      ],
      [OPTION_VALUES.INCOME_PROOF.BANK]: [
        {
          label: "savingsAppForm.doc_upload_section.upload_bank_statement",
          id: "Bank-statement",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
      ],
      [OPTION_VALUES.INCOME_PROOF.ITR]: [
        {
          label: "savingsAppForm.doc_upload_section.upload_itr_1",
          id: "taxReturns1",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
        {
          label: "savingsAppForm.doc_upload_section.upload_itr_2",
          id: "taxReturns2",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
        {
          label: "savingsAppForm.doc_upload_section.upload_itr_3",
          id: "taxReturns3",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
      ],
      [OPTION_VALUES.INCOME_PROOF.SALARY]: [
        {
          label: "savingsAppForm.doc_upload_section.upload_salary_slip1",
          id: "salarySlip1",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
        {
          label: "savingsAppForm.doc_upload_section.upload_salary_slip2",
          id: "salarySlip2",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
        {
          label: "savingsAppForm.doc_upload_section.upload_salary_slip3",
          id: "salarySlip3",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
      ],
      [OPTION_VALUES.INCOME_PROOF.COMPANY_ID]: [
        {
          label: "savingsAppForm.doc_upload_section.upload_company_id",
          id: "companyId",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.INCOME_PROOF,
        },
      ],
    },
    optionsType: "button",
    options: [
      { id: OPTION_VALUES.INCOME_PROOF.FORM_16, name: "savingsAppForm.doc_upload_section.form_16" },
      {
        id: OPTION_VALUES.INCOME_PROOF.SALARY,
        name: "savingsAppForm.doc_upload_section.last_3_months_salary_statement",
      },
      { id: OPTION_VALUES.INCOME_PROOF.ITR, name: "savingsAppForm.doc_upload_section.last_3_year_itr" },
      {
        id: OPTION_VALUES.INCOME_PROOF.BANK,
        name: "savingsAppForm.doc_upload_section.last_6_month_bank_statement",
      },
      {
        id: OPTION_VALUES.INCOME_PROOF.COMPANY_ID,
        name: "savingsAppForm.doc_upload_section.company_id",
      },
    ],
    isAadharKycDoc: false,
    isPanKycDoc: false,
  },
  {
    id: "payout",
    subHeading: "savingsAppForm.doc_upload_section.cancelled_check_desc",
    heading: "savingsAppForm.doc_upload_section.payout_details",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PAYOUT]: [
        {
          label: "",
          id: "payoutDetails",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SMART_KID_UPLOAD_FILE_NAMES?.PAYOUT_PROOF,
        },
      ],
    },
    example: {
      heading: "savingsAppForm.doc_upload_section.cancelled_check",
      image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.EXAMPLE_CANCELLED_CHEQUE,
      content: "savingsAppForm.doc_upload_section.make_sure_name_and_ac_no",
    },
  },
];

export const SIGNATURE_UPLOAD_ITEMS_LA = [
  {
    id: "photographLa",
    heading: "Photograph",
    subHeading: "Select your photograph or click a picture/ selfie",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PHOTOGRAPH_LA]: [
        {
          label: "",
          id: "profileLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.PHOTOGRAPH_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.PHOTO_ID_PROOF,
        },
      ],
    },
    isAadharKycDoc: true,
    isPanKycDoc: false,
  },
  {
    id: "addressLa",
    subHeading:
      "Please mask/ cover/ cross-out the first 8 digits of your Aadhaar number before uploading or download your masked Aadhaar copy from ",
    heading: "Address Proof / ID Proof ",
    title: {
      [OPTION_VALUES.IDENTITY_PROOF.MASKED_AADHAR]: [
        {
          label: "Front",
          id: "aadhaarFrontLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.FRONT_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.ADDRESS_PROOF,
        },
        {
          label: "Back",
          id: "aadhaarBackLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.BACK_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.ADDRESS_PROOF,
        },
      ],
      [OPTION_VALUES.IDENTITY_PROOF.PASSPORT]: [
        {
          label: "Front",
          id: "passFirstLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.FRONT_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.ADDRESS_PROOF,
        },
        {
          label: "Back",
          id: "passLastLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.BACK_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.ADDRESS_PROOF,
        },
      ],
      [OPTION_VALUES.IDENTITY_PROOF.DRIVING_LICENSE]: [
        {
          label: "Front",
          id: "LicenseLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.FRONT_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.ADDRESS_PROOF,
        },
      ],
    },
    optionsType: "button",
    options: [
      { id: OPTION_VALUES.IDENTITY_PROOF.MASKED_AADHAR, name: "Masked Aadhaar" },
      {
        id: OPTION_VALUES.IDENTITY_PROOF.DRIVING_LICENSE,
        name: "Driving License",
      },
      { id: OPTION_VALUES.IDENTITY_PROOF.PASSPORT, name: "Passport" },
    ],
    subHeadingLink: "https://eaadhaar.uidai.gov.in/",

    isAadharKycDoc: true,
    isPanKycDoc: true,
  },
  {
    id: "incomeLa",
    heading: "Income Proof(require any one)",
    subHeading:
      "Your income proof should match with your declared annual income. For salaried: Last 3 month's salary slip/ Form 130/ Last 3 years ITR/ Last 6 months' bank statement where salary gets credited. For non-salaried: Last 3 years ITR with computation of income",
    title: {
      [OPTION_VALUES.INCOME_PROOF.FORM_16]: [
        {
          label: "Upload Form 130",
          id: "form16La",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
      ],
      [OPTION_VALUES.INCOME_PROOF.BANK]: [
        {
          label: "Upload Bank Statement",
          id: "Bank-statementLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
      ],
      [OPTION_VALUES.INCOME_PROOF.ITR]: [
        {
          label: "Upload ITR 1",
          id: "taxReturns1La",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
        {
          label: "Upload ITR 2",
          id: "taxReturns2La",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
        {
          label: "Upload ITR 3",
          id: "taxReturns3La",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
      ],
      [OPTION_VALUES.INCOME_PROOF.SALARY]: [
        {
          label: "Upload Salary Slip 1",
          id: "salarySlip1La",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
        {
          label: "Upload Salary Slip 2",
          id: "salarySlip2La",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
        {
          label: "Upload Salary Slip 3",
          id: "salarySlip3La",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.INCOME_PROOF,
        },
      ],
    },
    optionsType: "button",
    options: [
      { id: OPTION_VALUES.INCOME_PROOF.FORM_16, name: "Form 130" },
      { id: OPTION_VALUES.INCOME_PROOF.SALARY, name: "Last 3 months salary statement" },
      { id: OPTION_VALUES.INCOME_PROOF.ITR, name: "Last 3 years ITR" },
      {
        id: OPTION_VALUES.INCOME_PROOF.BANK,
        name: "Last 6 months bank statement showing salary/income",
      },
    ],
    isAadharKycDoc: false,
    isPanKycDoc: false,
  },
  {
    id: "ageLa",
    heading: "Age Proof",
    subHeading: "Birth date in the document should match with the one you've filled in the application form",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BIRTH_CERTIFICATE_LA]: [
        {
          label: "Birth Certificate",
          id: "birthCertLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BAPTISM_CERTIFICATE_LA]: [
        {
          label: "Baptism Certificate",
          id: "baptismCertLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PASSING_CERTIFICATE_LA]: [
        {
          label: "Passing Certificate",
          id: "passingCertLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.GOVT_ID_PROOF_LA]: [
        {
          label: "Government ID proof",
          id: "govIdLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.SCHOOL_CERTIFICATE_LA]: [
        {
          label: "School/College Certificate",
          id: "schoolCertLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.AGE_PROOF,
        },
      ],
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.COLLEGE_ID_LA]: [
        {
          label: "College Id",
          id: "collegeIdLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.AGE_PROOF,
        },
      ],
    },
    options: [
      { name: "Birth Certificate", id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BIRTH_CERTIFICATE_LA },
      { name: "Baptism Certificate", id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.BAPTISM_CERTIFICATE_LA },
      { name: "Passing Certificate", id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PASSING_CERTIFICATE_LA },
      { name: "Government ID proof", id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.GOVT_ID_PROOF_LA },
      { name: "School/College Certificate", id: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.SCHOOL_CERTIFICATE_LA },
      { name: "College Id", id: "collegeIdLa" },
    ],
    optionsType: "select",
    // added for addhar/pan kyc upload mark
    isAadharKycDoc: true,
    isPanKycDoc: true,
  },
  // {
  //   id: "payoutLa",
  //   subHeading:
  //     "Cancelled Cheque of the account where you want the maturity/claims amount to get deposited.You can update this account later at any point as well",
  //   heading: "Payout Details",
  //   title: {
  //     [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PAYOUT_LA]: [
  //       {
  //         label: "",
  //         id: "payoutDetailsLa",
  //         image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
  //         uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.PAYOUT_PROOF,
  //       },
  //     ],
  //   },
  //   example: {
  //     heading: "CANCELLED CHEQUE",
  //     image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.EXAMPLE_CANCELLED_CHEQUE,
  //     content: "Make sure your name and account number are printed on the cancelled cheque",
  //   },
  // },
  {
    id: "othersLa",
    subHeading: "",
    heading: "Others",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.OTHERS_LA]: [
        {
          label: "",
          id: "othersDetailLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.CERTIFICATE_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.OTHERS_PROOF,
        },
      ],
    },
  },
  {
    id: "panLa",
    heading: "PAN (Optional)",
    subHeading:
      "Provide this document only if your name on the PAN card is not the same as the one you have entered in application form.",
    title: {
      [SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.PAN_LA]: [
        {
          label: "",
          id: "panCardLa",
          image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.PAN_LOGO,
          uploadName: SIGNATURE_UPLOAD_FILE_LA_NAMES?.PAN,
        },
      ],
    },
    example: {
      heading: "PAN CARD",
      subHeading: "Front",
      image: SMART_KID_OPTION_VALUES.UPLOAD_DOCUMENTS.IMAGES.EXAMPLE_PAN_CARD,
      content: "Your name mentioned in the application form should match as per your PAN card",
    },
  },
];

export const SALARY_RANGE = {
  "smart-kid": {
    250000: { min: 0, max: 490000 },
    650000: { min: 500000, max: 740000 },
    875000: { min: 800000, max: 990000 },
    1250000: { min: 1000000, max: 1490000 },
    1750000: { min: 1500000, max: 1990000 },
    2000000: { min: 2000000, max: Infinity },
  },
  default: {
    250000: { min: 0, max: 490000 },
    650000: { min: 500000, max: 740000 },
    875000: { min: 800000, max: 990000 },
    1250000: { min: 1000000, max: 1490000 },
    1750000: { min: 1500000, max: 1990000 },
    2000000: { min: 2000000, max: Infinity },
  },
};

export const COUNTRY_TYPES = {
  COMMERTIALLY_IMPORTANT: "commerciallyImportant",
  STANDARD: "standard",
  SUB_STANDARD: "subStandard",
  VMER: "vmer",
  DECLINED: "declined",
};

export const PaymentOptionName = {
  WL: "Whole_Life",
  WLLP: "Limited_Whole_Life",
  SP: "Single_Pay",
  RP: "Regular_Pay",
  LP: "Limited_Pay",
  LP5: "Limited_Pay_5",
  LP7: "Limited_Pay_7",
  LP10: "Limited_Pay_10",
  LP15: "Limited_Pay_15",
  LPT5: "Limited_Pay_Term",
  LP60: "Limited_Pay_60",
  WLLP10: "Limited_Whole_Life_10",
  WLLP60: "Limited_Whole_Life_6",
  WLRP: "Regular_Whole_Life",
  L_P: "Limited Pay",
  S_P: "Single Pay",
  R_P: "Regular Pay",
};
export const ALLOCATION_OPTIONS = {
  PAYMENT_MODE: [
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.MONTHLY, name: "options.MONTHLY" },
    { id: OPTION_VALUES.PAYMENT_FREQUENCY.YEARLY, name: "options.YEARLY" },
  ],
  PAYMENT_DATE: [
    { id: SMART_KID_OPTION_VALUES.TRANSFER_DATE.FIFTH_MONTH, name: "options.every5month" },
    { id: SMART_KID_OPTION_VALUES.TRANSFER_DATE.FIFTHTEENTH_MONTH, name: "options.every10month" },
  ],
  SWP: [
    { id: OPTION_VALUES.NRI_YES, name: "options.now" },
    { id: OPTION_VALUES.NRI_NO, name: "options.later" },
  ],
};

export const PAYMENT_MONTHS = [
  { id: OPTION_VALUES.PAYMENT_MONTHS.JANUARY, name: "January" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.FEBRUARY, name: "February" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.MARCH, name: "March" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.APRIL, name: "April" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.MAY, name: "May" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.JUNE, name: "June" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.JULY, name: "July" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.AUGUST, name: "August" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.SEPTEMBER, name: "September" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.OCTOBER, name: "October" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.NOVEMBER, name: "November" },
  { id: OPTION_VALUES.PAYMENT_MONTHS.DECEMBER, name: "December" },
];

export const PAYMENT_MONTHS_NUMBERS = [
  { id: 1, name: "years.january" },
  { id: 2, name: "years.february" },
  { id: 3, name: "years.march" },
  { id: 4, name: "years.april" },
  { id: 5, name: "years.may" },
  { id: 6, name: "years.june" },
  { id: 7, name: "years.july" },
  { id: 8, name: "years.august" },
  { id: 9, name: "years.september" },
  { id: 10, name: "years.october" },
  { id: 11, name: "years.november" },
  { id: 12, name: "years.december" },
];

export const PAYOUT_DATES = [
  ...Array.from({ length: 31 }, (_, index) => ({
    id: index + 1,
    name: (index + 1).toString(),
  })),
];

export const PAYOUT_PERCENTAGES = [
  ...Array.from({ length: 7 }, (_, index) => {
    const percentage = index + 4;
    return { id: percentage, name: `${percentage}%` };
  }),
];

export const INPUT_TYPES = {
  INPUT: "input",
  DROPDOWN: "dropdown",
  SEARCH_INPUT: "searchInput",
  MASKED_INPUT: "masked_input",
  PAN_DISCLAIMER: "panDisclaimer",
  TEXTAREA: "textarea",
  TOGGLE_SWITCH: "toogleSwitch",
  DOB: "dob",
  MASKED_FIELD: "maskedField",
  RADIO: "radio",
  BUTTON: "button",
  MULTI: "multi",
  ADD_REMOVE: "addRemove",
  CUSTOM: "custom",
};

export const SECTION_TYPE = {
  CONTAINER: "container",
  LABEL_CONTAINER: "labelContainer",
  TOGGLE: "toggle",
  NAVIGATOR: "navigator",
  CUSTOM: "custom",
  COMBINEDFIELDS: "combinedFields",
  ICON_TEXT: "iconText",
  ACCORDION: "accordion",
  POLICY_SECTION: "polciySection",
};

export const FIELDS_TYPE = {
  CONTAINER: "container",
  MULTI_FIELDS: "multiField",
  ROW_FIELDS: "rowFields",
  COLUMN_FIELD: "columnField",
  CENTER_ROW: "centerRow",
  COLUMN_FIELDS: "columnFields",
  CUSTOM_MULTI_FIELDS: "customMultiFields",
};

export const PREVIEW_TYPE = {
  INTERNAL: "internal", // merge all the childs
  EXTERNAL: "external", // title diff then all childs merged
};

export const PAY_FOR_GIFT_PRO = [
  { id: 5, name: "5 Years", minAge: 8 },
  { id: 6, name: "6 Years", minAge: 7 },
  { id: 7, name: "7 Years", minAge: 6 },
  { id: 8, name: "8 Years", minAge: 5 },
  { id: 9, name: "9 Years", minAge: 4 },
  { id: 10, name: "10 Years", minAge: 3 },
  { id: 11, name: "11 Years", minAge: 2 },
  { id: 12, name: "12 Years", minAge: 1 },
];

export const GET_INCOME_FOR_GIFT_PRO = [
  { id: 5, name: "5 Years" },
  { id: 7, name: "7 Years" },
  { id: 10, name: "10 Years" },
  { id: 12, name: "12 Years" },
  { id: 15, name: "15 Years" },
  { id: 20, name: "20 Years" },
  { id: 25, name: "25 Years" },
  { id: 30, name: "30 Years" },
];

export const POLICY_TERM_GIFT_PRO = [
  { id: 8, name: "8 Years" },
  { id: 9, name: "9 Years" },
  { id: 10, name: "10 Years" },
  { id: 11, name: "11 Years" },
  { id: 12, name: "12 Years" },
  { id: 13, name: "13 Years" },
  { id: 14, name: "14 Years" },
  { id: 15, name: "15 Years" },
  { id: 16, name: "16 Years" },
  { id: 17, name: "17 Years" },
];

export const INCOME_STARTS_FROM_GIFT_PRO = [
  { id: 9, name: "9th Year" },
  { id: 10, name: "10th Year" },
  { id: 11, name: "11th Year" },
  { id: 12, name: "12th Year" },
  { id: 13, name: "13th Year" },
  { id: 14, name: "14th Year" },
  { id: 15, name: "15th Year" },
  { id: 16, name: "16th Year" },
  { id: 17, name: "17th Year" },
  { id: 18, name: "18th Year" },
];

export const INCOME_CUSTOMISE = {
  LEVEL: "Level",
  INCREASING: "Increasing",
};

export const INCOME_BOOSTER = {
  BASE: "Base",
  LCB: "LCB",
};

export const PAYFOR_VALUES = {
  PPT_5: 5,
  PPT_6: 6,
  PPT_7: 7,
  PPT_8: 8,
  PPT_9: 9,
  PPT_10: 10,
  PPT_11: 11,
  PPT_12: 12,
};

export const occupationMapper = {
  PROF: "PROF",
  HSWF: "HSWF",
  Agriculturalist: "AGRI",
  "Self-employed - Consultant": "BSEM",
  SPVT: "SPVT",
  "ICICI Group Employee": "SPVT",
  STDN: "STDN",
  RETD: "RETD",
  "Self-employed - CA": "BSEM",
  Agriculturist: "AGRI",
  Salaried: "SPVT",
  "House-wife": "HSWF",
  Housewife: "HSWF",
  "Self-employed - Lawyer": "BSEM",
  Retired: "RETD",
  Student: "STDN",
  BSEM: "BSEM",
  AGRI: "AGRI",
  Engineer: "SPVT",
  "Self-employed - Architect": "BSEM",
  "Self-employed - Businessman": "BSEM",
  "Self-employed": "BSEM",
  "Not Applicable": "SPVT",
  "Self Employed": "BSEM",
  Professional: "PROF",
  "Self-employed - Doctor": "BSEM",
};

export const educationMapper = {
  Illiterate: "677",
  "Below 10th": "677",
  "Non Graduate": "678",
  "Below 12th": "678",
  "Below 12th pass": "678",
  676: "676",
  675: "675",
  "Graduate or above": "680",
  678: "678",
  "12th pass / Diploma": "679",
  "10th": "678",
  680: "680",
  "Post Graduate": "676",
  679: "679",
  "12th pass/diploma holder": "679",
  Diploma: "675",
  "Graduate & above": "680",
  "10th pass / 12th pass / Diploma": "678",
  "12th": "679",
  Graduate: "680",
  "Non-Graduate": "679",
};

export const INDUSTRY_TYPE_OCCUPATION = [OPTION_VALUES.OCCUPATION.SALARIED];

export const SIGNATURE_ASSURED_PERSONA = {
  ASSURE_YOUNGSTER: "Sig-Youngsters",
};

export const PENSION_TITLE_VALUES = Object.freeze({
  [OPTION_VALUES.PENSION_FOR.ME]: {
    title: "Life Annuity with Return of 100% of Purchase Price (ROP)",
    description: "I get pension for life and after me, the Purchase Price will be returned to my nominee.",
  },
  [OPTION_VALUES.PENSION_FOR.ME_SPOUSE]: {
    title: "Joint life Last Survivor Annuity with Return of 100% of Purchase Price (ROP) on death of the last survivor",
    description:
      "I get pension for my entire life. After my death, the secondary annuitant continues to receive same amount of pension till his/her death. On death of the secondary annuitant, the Purchase Price is returned to my nominee and no further benefits would be payable.",
  },
});

const INVEST_TYPES = {
  YOUR_CHOICE: "yourChoice",
  YOUR_AGE: "yourAge",
  STRATEGY_ONE: "strategyOne",
  STRATEGY_TWO: "strategyTwo",
};

const FundTabs = {
  AS_PER_YOUR_CHOICE: "As per your choice",
  AS_PER_YOUR_AGE: "As per your age",
  TARGET_ASSET_STRATEGY: "Target asset strategy",
  TRIGGER_PORTFOLIO_STRATEGY: "Trigger portfolio strategy 2",
};

export const INVEST_TYPE_TO_FUND_TAB_MAP = {
  [INVEST_TYPES.YOUR_CHOICE]: FundTabs.AS_PER_YOUR_CHOICE,
  [INVEST_TYPES.YOUR_AGE]: FundTabs.AS_PER_YOUR_AGE,
  [INVEST_TYPES.STRATEGY_ONE]: FundTabs.TARGET_ASSET_STRATEGY,
  [INVEST_TYPES.STRATEGY_TWO]: FundTabs.TRIGGER_PORTFOLIO_STRATEGY,
};

export const FUND_TAB_TO_INVEST_TYPE_MAP = {
  [FundTabs.AS_PER_YOUR_CHOICE]: INVEST_TYPES.YOUR_CHOICE,
  [FundTabs.AS_PER_YOUR_AGE]: INVEST_TYPES.YOUR_AGE,
  [FundTabs.TARGET_ASSET_STRATEGY]: INVEST_TYPES.STRATEGY_ONE,
  [FundTabs.TRIGGER_PORTFOLIO_STRATEGY]: INVEST_TYPES.STRATEGY_TWO,
};
export const I_WISH_OPTION_VALUES = {
  OCCUPATION: [
    { id: OPTION_VALUES.OCCUPATION.SALARIED, name: "options.salaried" },
    { id: OPTION_VALUES.OCCUPATION.PROFESSIONAL, name: "options.professional" },
    {
      id: OPTION_VALUES.OCCUPATION.SELF_EMPLOYEE,
      name: "options.self_employed",
    },
    { id: OPTION_VALUES.OCCUPATION.RETIRED, name: "options.retired" },
    { id: OPTION_VALUES.OCCUPATION.STUDENT, name: "options.student" },
  ],
  ANNUAL_INCOME: [
    {
      id: OPTION_VALUES.ANNUAL_INCOME.ONE_L_TWENTY_K,
      name: "options.up_to2.4l",
    },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWO_L_FIFTY_K, name: "options.2.5l_4.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.FIVE_L, name: "options.5l_7.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.EIGHT_L, name: "options.8l_9.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.TEN_L, name: "options.10l_19.9l" },
    { id: OPTION_VALUES.ANNUAL_INCOME.TWENTY_L, name: "options.20l_&_above" },
  ],
  BUYING_PLANS_FOR: [
    { id: OPTION_VALUES.IWISH_BUYING_FOR.SELF, name: "Self" },
    // { id: OPTION_VALUES.IWISH_BUYING_FOR.MOTHER, name: "Mother" },
    { id: OPTION_VALUES.IWISH_BUYING_FOR.WIFE, name: "Wife" },
    { id: OPTION_VALUES.IWISH_BUYING_FOR.DAUGHTER, name: "Daughter" },
  ],
  GENDER: [
    { id: OPTION_VALUES.GENDER.MALE, name: "options.male" },
    { id: OPTION_VALUES.GENDER.FEMALE, name: "options.female" },
    { id: OPTION_VALUES.GENDER.TRANSGENDER, name: "options.other" },
  ],
};

export const IWISH = {
  IWISH_DEPENDENT_VALUE: {
    [OPTION_VALUES.IWISH_BUYING_FOR.SELF]: "",
    [OPTION_VALUES.IWISH_BUYING_FOR.MOTHER]: "Mother",
    [OPTION_VALUES.IWISH_BUYING_FOR.WIFE]: "Wife",
    [OPTION_VALUES.IWISH_BUYING_FOR.DAUGHTER]: "Daughter",
  },
  ANNUAL_INCOME_ZERO: [
    OPTION_VALUES.OCCUPATION.RETIRED,
    OPTION_VALUES.OCCUPATION.STUDENT,
    OPTION_VALUES.OCCUPATION.HOUSEWIFE,
  ],
  IWISH_LEADWS_VALUE: {
    [OPTION_VALUES.IWISH_BUYING_FOR.MOTHER]: "Mother",
    [OPTION_VALUES.IWISH_BUYING_FOR.WIFE]: "Spouse",
    [OPTION_VALUES.IWISH_BUYING_FOR.DAUGHTER]: "Daughter",
  },
};

export const EXISTCUST = {
  existCustYes: "ExistCust_Yes",
  existCustNo: "ExistCust_No",
};

export const SIGNATURE_ASSURED = {
  MARITAL_STATUS: [
    { id: OPTION_VALUES.MARITAL_STATUS.MARRIED, name: "Married" },
    { id: OPTION_VALUES.MARITAL_STATUS.SINGLE, name: "Single" },
    { id: OPTION_VALUES.MARITAL_STATUS.DIVORCED, name: "Divorced" },
    { id: OPTION_VALUES.MARITAL_STATUS.WIDOWED, name: "Widowed" },
  ],
};
// for Non Indian

//---Gift City Mapper Starts---
// Base mapping of proof types to their internal codes
export const BASE_PROOF_CODE = {
  AADHAR: "GPAD",
  PASSPORT: "GPPS",
  DRIVING_LICENSE: "GPDL",
  VOTER_ID: "GPVI",
  NATIONAL_IDENTITY_CARD: "GPNI",
};

// Map all variations of proof keys (including masked versions) to base codes
// This ensures any alias (like MASKED_AADHAR) points to the same code
const PROOF_KEYS = {
  AADHAR: BASE_PROOF_CODE.AADHAR,
  MASKED_AADHAR: BASE_PROOF_CODE.AADHAR, // Alias for masked version
  PASSPORT: BASE_PROOF_CODE.PASSPORT,
  DRIVING_LICENSE: BASE_PROOF_CODE.DRIVING_LICENSE,
  VOTER_ID: BASE_PROOF_CODE.VOTER_ID,
  NATIONAL_IDENTITY_CARD: BASE_PROOF_CODE.NATIONAL_IDENTITY_CARD,
};

const buildProofCodeMap = (sections) => {
  const result = {};
  // Iterate over each section (proof category)
  sections.forEach((section) => {
    Object.entries(section).forEach(([key, value]) => {
      if (PROOF_KEYS?.[key]) {
        // Choose only those fields that are available in PROOF_KEYS
        result[value] = PROOF_KEYS[key];
      }
    });
  });
  return result;
};

// Combines ADDRESS_PROOF, AGE_PROOF, and IDENTITY_PROOF into one object
export const ADDRESS_PROOF_CODE = buildProofCodeMap([
  OPTION_VALUES.ADDRESS_PROOF,
  OPTION_VALUES.AGE_PROOF,
  OPTION_VALUES.IDENTITY_PROOF,
]);

//---Gift City Mapper ENDS---

export const GIFT_CITY_OPTIONS = {
  PORTFOLIO_OPTIONS: [
    { id: "As per your choice", name: "As Per Your Choice" },
    { id: "As per your age", name: "As Per Your Age" },
  ],
};

export const HEALTH_QUESTIONS_OPTIONS_VALUES = {
  YES: "Yes",
  NO: "No",
  OCCUPATION_ACTIVITY: {
    AF: "Armed Forces",
    OP: "Oil, Rig And Natural Gas/Petrochemical",
    MI: "Mine Industry",
    RD: "Radiation",
    PL: "Pilot",
    FR: "Fireman",
    MM: "Merchant Marine",
    OT: "Any Other Industry Type, Please Specify",
  },
  ARMED_FORCES: {
    DIVING: "Diving",
    PARA_TROOPING: "Para Trooping",
    PARACHUTING: "Parachuting",
    COMMANDO_ACTIVITIES: "Commando Activities",
  },
  OIL_GAS_PETROCHEMICAL: {
    IWCROL: "In Workshop Or Control Room Only",
    OES: "On Exploration Site, On Drilling Site",
    OTP: "On Transport Or Pipelines Installation",
    IRP: "In Refinery Or Petrochemical Site",
    ICTR: "In Chemistry, Scientific And Technical Research",
    OTHERS: "Others",
  },
  MINING_TYPE: {
    PLACER_MINE: "Placer Mine",
    HYDRAULIC_MINE: "Hydraulic Mine",
    HARD_ROCK_MINING: "Hard Rock Mining",
    OPEN_PIT_MINING: "Open Pit Mining/Open Cast Mining",
    OTHERS: "Any Other",
  },
  AVIATION_LICENSE: {
    PRIVATE: "Private",
    COMMERCIAL: "Commercial",
    FLIGHT_INSTRUCTOR: "Flight Instructor",
    OTHERS: "Any Other",
  },
  PRIVATE_JETS: {
    PRIVATE_OR_CLUB_FLYING_FOR_PLEASURE: "Private Or Club Flying For Pleasure",
    PRIVATE_FLYING_FOR_BUSINESS: "Private Flying For Business",
    PRIVATE_FLYING_FOR_OTHER_PURPOSES: "Private Flying For Other Purposes",
  },
  FLYING_TYPE: {
    EXPERIMENTAL: "Experimental (for non-commercial, recreational purposes such as education or personal use)",
    TEST_FLYING: "Test Flying (for routine fitness check of the aircraft or for prototype testing)",
    FLIGHT_INSTRUCTOR: "As A Flight Instructor (commercial, elementary or advanced level)",
  },
  FLYING_COMPETITION: {
    ANY_FORM_OF_AEROBATICS: "Any Form Of Aerobatics",
    AIR_SHOWS: "Air Shows (flying exhibition)",
    PROTOTYPE_TESTING: "Prototype Testing (flight testing done before actual flight)",
    AIR_RACING: "Air-Racing (sport of racing airplanes)",
    STUNT_FLYING: "Stunt Flying (any stunt performed in an aircraft)",
  },
  FIREMAN_ROLE: {
    VOLUNTEER: "Volunteer",
    PROFESSIONAL: "Professional",
    ADMINISTRATIVE: "Administrative Staff Only",
  },
  FIREMAN_INTERVENTION: {
    FOREST_FIRE: "Forest Fire Operations",
    UNDERWATER_OPERATIONS: "Underwater Operations",
    CLIMBING: "Climbing Operations (Except mountain rescue)",
    MOUNTAIN_RESUE: "Mountain Rescue Including Helicopter And/Or Technical Climbing",
    AIRCRAFT: "Aircraft Or Helicopter Operations",
    SPELEOLOGICAL: "Speleological (cave) Operations",
    LANDMINE: "Landmine Or Explosive Removal",
  },
  TOBACCO_OPTIONS: {
    CIGAR: "Cigar",
    CIGARETTE: "Cigarette",
    BEEDI: "Beedi",
    GUTKA: "Gutka",
  },
  ALCOHOL_OPTIONS: {
    BEER: "Beer",
    WINE: "Wine",
    LIQUOR: "Hard Liquor",
  },
  CANCER_TRETMENT_OPTION: {
    CHEMOTHERAPY: "Chemotherapy",
    RADIOTHERAPY: "Radiotherapy",
    HORMONALTHERAPY: "Hormonal Therapy",
    SURGERY: "Surgery",
  },
  HYPERTENSION_MEDICAL_OPTION: {
    ELEVATEDBP: "Elevated BP/Hypertension",
    ELEVATEDCHOLESTEROL: "Elevated Cholesterol",
  },
  DURATION: {
    LT_1YR: "Less Than 1 Yr",
    YR_1_TO_5: "1-5 Yrs",
    YR_5_TO_10: "5-10 Yrs",
    GT_10YR: "More Than 10 Yrs",
  },
  TREATMENT_TYPE: {
    ORAL_MEDICATIONS: "Oral Medications",
    INSULIN: "Insulin",
    DIET_LIFESTYLE: "Diet And Lifestyle Modifications",
    AYURVEDIC: "Ayurvedic/Homeopathic Medications",
    NO_TREATMENT: "No Treatment Taken",
  },
  HEART_SURGERY: {
    ANGIOPLASTY: "Angioplasty",
    BYPASS: "Bypass",
    PACEMAKER_IMPLANT: "Pacemaker Implant",
    VALVE_REPLACEMENT: "Valve Replacement",
    CONGENITAL_HEART_DEFECT: "Congenital Heart Defect (ASD/VSD)",
    OTHER_HEART_SURGERY: "Any Other Heart Surgery",
  },
  LIMB_AFFECTED: {
    ONE_LIMB: "One Limb",
    TWO_LIMBS: "Two Limbs",
    MORE_THAN_TWO_LIMBS: "More Than Two Limbs",
    VERTEBRAL_SPINE: "Vertebral Spine",
  },
  CONDITION_TYPE: {
    ACQUIRED:
      "Acquired (Secondary to accident/disease, Exposure to medicines/chemicals/other toxic substances, Side effect of surgery/past hospitalization etc)",
    CONGENITAL: "Congenital (since birth)",
  },
  SUPPORT_TYPE: {
    CRUTCHES_STICK: "Crutches/Stick",
    CALLIPERS: "Callipers",
    WHEELCHAIR: "Wheel Chair",
    ANY_OTHER: "Any Other",
  },
  DISABILITY_CAUSE: {
    OLD_POLIO: "Old Polio/PPRP (post-polio residual paralysis)",
    POST_TRAUMATIC: "Post-Traumatic",
    POST_NEUROLOGICAL: "Post Neurological Disorder/Disease e.g. Stroke",
  },

  AVOCATION_OPTIONS: {
    PARAGLIDING: "Paragliding",
    PARACHUTING_SKYDIVING: "Parachuting/Skydiving",
    MOUNTAINEERING: "Mountaineering",
    DEEP_SEA_DIVING_SCUBA_DIVING: "Deep Sea Diving/Scuba Diving",
    MOTORCYCLE_RACING: "Motorcycle Racing",
    MOTOR_CAR_RACING: "Motor Car Racing",
    OTHER_EXTREME_AVOATION: "Other Extreme Avocation",
  },
  MAX_DIVE_DEPTH_OPTIONS: {
    LTE_40M: "Less Than Or Equal To 40 m",
    _41_TO_60M: "41-60 m",
    _61_TO_75M: "61-75 m",
    GT_75M: "Greater Than 75 m",
  },
  DIVING_TYPE_OPTIONS: {
    ONE_OFF_OR_HOLIDAY_TRY_DIVE: "One Off Or Holiday Try Dive",
    RECREATIONAL_DIVING: "Recreational Diving",
    FREE_DIVING: "Free Diving",
    TECHNICAL_DIVING: "Technical Diving",
  },
  MOTOR_CAR_OPTIONS: {
    DRAG_RACING: "Drag Racing",
    RALLY: "Rally",
    VETERAN_VINTAGE_HISTORIC: "Veteran/Vintage/Historic",
    HILL_CLIMBS: "Hill Climbs",
    RALLYING: "Rallying",
    SHORT_CIRCUIT: "Short Circuit",
    LONG_CIRCUIT: "Long Circuit",
    ANY_OTHER: "Any Other",
  },
  MOTOR_CAR_TYPE_OPTIONS: {
    SINGLE_SEATER: "Single Seater",
    CLASSICSPORTSCAR: "Classic Sports Car",
    OTHER_SPORTS_CAR: "Other Sports Car",
    KARTING: "Karting",
    SALOON: "Saloon",
    ANY_OTHER: "Any Other",
  },
  MOTOR_RACING_ACTIVITY_TYPE_OPTIONS: {
    AMATEUR: "Amateur",
    PROFESSIONAL: "Professional",
    KART_RACING: "Kart Racing",
  },
  MOTOR_CYCLE_OPTIONS: {
    DRAG_RACING_AND_SPRINTS: "Drag Racing And Sprints",
    ICE_RACING: "Ice Racing",
    SPEEDWAY: "Speedway",
    ANY_OTHER: "Any Other",
  },
  CYLINDER_CAPACITY: {
    LT125CC: "Less Than 125 cc",
    TO500CC: "150-500 cc",
    GT500CC: "Greater Than 500 cc",
  },
  MOUNTAINEERING_ROLE: {
    HIKING_MARKED: "Hiking On Marked Trails",
    HIKING_OFF_MARKED: "Hiking Off Marked Trails And Mountaineering",
    ROCK_CLIMBING: "Rock Climbing",
    COMPETITIVE_CLIMBING: "Competitive Climbing",
    SPEED_CLIMBING: "Speed Climbing",
    ANY_OTHER: "Any Other",
  },
  MOUNTAINEERING_LEVEL: {
    HIGH_ALTITUDE_3000: "High-Altitude Mountain Tours 3000 Meter (including glacier)",
    EXTREME_ALTITUDE_5500: "Extreme-Altitude Mountain Tours  5500 Meter",
    INDOOR_OUTDOOR_UPTO_7_UIAA: "Indoor Or Outdoor Climbing Park Up To 7 UIAA",
    INDOOR_OUTDOOR_ABOVE_8_UIAA: "Indoor Or Outdoor Climbing Park Above 8 UIAA",
    ALPINE_STYLE_UPTO_6_UIAA: "Alpine-Style Climbing Up To 6UIAA",
    ALPINE_STYLE_ABOVE_7_UIAA: "Alpine-Style Climbing Above 7 UIAA",
  },
  MOUNTAIN_RANGE: {
    HIMALAYA: "Himalaya",
    KARAKORAM: "Karakoram",
    EASTERN_RIFT: "Eastern Rift Mountain",
    ANDES: "Andes",
    ALASKA: "Alaska",
    ANY_OTHER: "Any Other",
  },
  TREKKING_DURATION: {
    LESS_THAN_A_DAY: "Less Than 1 Day",
    BETWEEN_1_DAY_TO_1_WEEK: "Between 1 Day To 1 Week",
    MORE_THAN_1_WEEK: "More Than 1 Week",
  },
  ADVENTURE_ACTIVITY: {
    TREKKING: "Trekking",
    MOUNTAIN_HIKING: "Mountain Hiking",
    CLIMBING: "Climbing",
    ICE_CLIMBING: "Ice Climbing (Waterfalls/dry tooling)",
    BOULDERING: "Bouldering",
    COASTEERING: "Coasteering",
    HILLWALKING: "Hillwalking",
    FREE_SOLO: "Free Solo Climbing/Soloing/Buildering",
  },
  SKYDIVING_JUMPS: {
    LT_5: "Less Than 5 Jumps",
    GT_5: "Greater Than 5 Jumps",
  },
  ACTIVITY_FREQUENCY: {
    LTE_10: "Less Than Or Equal To 10 Times Per Year",
    GT_10: "Greater Than 10 Times Per Year",
  },
  ADVENTURE_SPORTS: {
    SKIING: "Skiing",
    JUMPING: "Jumping",
    HOT_AIR_BALLOON: "Hot Air Balloon Riding",
    SNOW_MOTORCYCLING: "Snow Motorcycling",
    CAVING_POTHOLING: "Caving And Potholing",
    ZORBING: "Zorbing",
    ANY_OTHER: "Any Other",
  },
  SKIING_DETAILS: {
    PLEASURE_ONLY: "Pleasure Only",
    CROSS_COUNTRY: "Cross Country",
    BIATHLON: "Biathlon",
    SNOWBOARDING: "Snowboarding",
    SNOWMOBILING: "Snowmobiling",
    WITHOUT_COMPETITION: "Without Competition",
    WITH_COMPETITION: "With Competition",
    PROFESSIONAL: "Professional",
    EXTREME_SKIING: "Extreme Skiing",
    ALL_OTHER_EVENTS: "All Other Events",
  },
  JUMPING_DETAILS: {
    JUMPING_FROM_HEIGHT: "Jumping From Height",
    BUNGEE_JUMPING: "Bungee Jumping",
    ROCKET_JUMPING: "Rocket Jumping",
    SCAD_JUMPING: "Scad Jumping",
    SNOW_JUMPING: "Snow Jumping",
    BARREL_JUMPING: "Barrel Jumping",
  },
  FLYING_DETAILS: {
    RECORD_ATTEMPT: "Record Attempt",
    EQUIPMENT_TESTING: "Equipment Testing",
    TETHERED_BALLOONS: "Tethered Balloons",
    COMPETITION_FLYING: "Competition Flying",
    INSTRUCTOR: "Instructor",
    MOTORISED_BALLONS: "Dirigible/Motorised Balloons",
    FREE_FLYING_BALLOONS: "Free-Flying Balloons",
    ANY_OTHER: "Any Other",
  },
  RACING_DETAILS: {
    ENDURANCE_RAIDS: "Endurance-Raids",
    TRACK_SPEED: "Track Speed",
    CIRCUIT_CROSS: "Circuit Cross",
    MOUNTAIN_RACING: "Mountain Racing",
    DRAGSTER: "Dragster",
    SINGLE_SEATER_RACING: "Single Seater Vehicle",
    ASPHALT_ROADS_RACING: "Asphalt Roads Racing",
    TWO_SEATER_VEHICLE_4_WHEELS: "Two Seater Vehicle (4 wheels)",
  },
  CAVING_DETAILS: {
    CAVE_GRADES_1_TO_3: "Cave Grades 1 to 3",
    CAVE_GRADES_4_AND_ABOVE: "Cave Grades 4 And Above",
    EXPEDITION_CAVING: "Expedition Caving",
    INTERNATIONAL_ACTIVITY: "International Activity",
    CAVING_INSTRUCTORS: "Caving Instructors",
    ACTIVE_CAVE_RESCUE_PERSONNEL: "Active Cave Rescue Personnel",
  },
  ACTIVITY_TYPE: {
    RECREATIONAL_OR_ONE_OFF: "Recreational Or One-Off Activity Only",
    INSTRUCTOR_LEVEL: "Instructor Level",
    INTEGRAL_PART_OF_JOB: "Whether Integral Part Of An Individuals Job Function",
  },
  FREE_FALL_JUMPS: {
    LT_25: "Less Than 25 Jumps Per Annum",
    RANGE_26_TO_75: "26-75 Jumps Per Annum",
    RANGE_76_TO_125: "76-125 Jumps Per Annum",
    GT_125: "Greater Than 125 Jumps Per Annum",
  },
  STANDARD_JUMPS: {
    LT_5: "Less Than 5 Jumps Per Annum",
    GT_5: "Greater Than 5 Jumps Per Annum",
  },
  PARACHUTING_DETAILS: {
    HIGH_PERFORMANCE_TURNS: "High Performance Turns",
    DISPLAY_JUMPS: "Display Jumps",
    ACCURACY_LANDING: "Accuracy Landing",
    INDIVIDUAL_STYLE_JUMP: "Individual Style Jump",
    FREE_FLY: "Free Fly",
    SWOOPING: "Swooping",
    PARASCENDING_PARASAILING: "Parascending/Parasailing",
    ANY_OTHER: "Any Other",
  },
  CANOPY_PILOT: {
    NO_CANOPY_PILOT_TRAINING: "No Canopy Pilot Training",
    TOWED_FROM_GROUND: "Towed From The Ground",
    HOLDER_OF_TRAINING: "Holder Of A Canopy Pilot Training",
    TOWED_FROM_WATER: "Towed From Water",
    NONE_OF_ABOVE: "None Of The Above",
  },
  SKYDIVING_DETAILS: {
    STATIC_LINE_TANDEM: "Static Line/Automatic Chute Opening/Tandem Only",
    FREE_FALL_SKYDIVING: "Free Fall/Skydiving",
    INSTRUCTOR: "Instructor",
    RECORD_ATTEMPT_COMPETITION: "Record Attempts Or Competitions",
    PARASCENDING_PARASAILING: "Parascending/Parasailing",
    BASE_JUMPING: "Base Jumping",
    SKY_BOARDING: "Sky Boarding",
    SKY_COMMANDO: "Sky Commando",
    EQUIPMENT_TESTING: "Equipment Testing",
  },
  FLIGHT_FREQUENCY: {
    LT_25: "Less Than 25 Flights Per Annum",
    RANGE_26_TO_50: "26-50 Flights Per Annum",
    GT_50: "Greater Than 50 Flights Per Annum",
  },
  FLIGHT_JUMPS: {
    LT_50: "Less Than Or Equal To 50 Jumps Per Annum",
    RANGE_51_TO_100: "51-100 Jumps Per Annum",
    GT_100: "Greater Than 100 Jumps Per Annum",
  },
  FLYING_HOURS: {
    LT_100: "Less Than 100 Hours",
    GT_100: "More Than 100 Hours",
  },
  GLIDING_DETAILS: {
    SINGLE_LINE_KITE: "Single Line Kite",
    ACROBATIC_KITE: "Acrobatic Kite",
    TOWING_KITE_POWER_KITE: "Towing Kite (Power kite)",
    ULTRALIGHT_GLIDER_NO_ENGINE: "Ultralight Glider, With No Engine",
    PARAGLIDING_NO_ENGINE: "Paraglider, With No Engine",
    HANG_GLIDER: "Hang Glider",
    THREE_AXIS_GLIDER: "3-Axis Glider",
    ANY_OTHER: "Any Other",
  },
  PARAGLIDING_DETAILS: {
    PLEASURE_ONLY: "Pleasure Only",
    INSTRUCTOR: "Instructor",
    RECORD_ATTEMPT_COMPETITION: "Record Attempt Or Competition Flying",
    TESTING_PROTOTYPES: "Testing Prototypes Or Repaired/Modified Canopies",
    PILOT: "Pilot",
  },
  HOT_AIR_FLYING_HOURS: {
    LESS_THAN_50: "Less Than 50 Hours Flying Per Year",
    FROM_50_TO_100: "50-100 Hours Flying Per Year",
    FROM_100_TO_200: "100-200 Hours Flying Per Year",
    MORE_THAN_200: "Greater Than 200 Hours Flying Per Year",
  },
  ENGINE_CAPACITY: {
    LTE_400CC: "Less Than Or Equal To 400cc",
    GT_400CC: "Greater Than 400cc",
  },
  CAVING_FREQUENCY: {
    LTE_25_TRIPS: "Less Than Or Equal To 25 Caving Trips Per Year",
    GT_25_TRIPS: "Greater Than 25 Caving Trips Per Year",
  },
  CLUB_MEMBERS: {
    BCA_MEM: "British Cave Association Members",
    NON_BCA_MEM: "Non British Cave Association Members",
  },
  TB_ORGANS: {
    LUNGS: "Lungs",
    INTESTINE: "Intestine",
    BRAIN: "Brain",
    SPINAL_CORD: "Spinal Cord",
    BONES: "Bones",
    LYMPH_NODES: "Lymph Nodes",
    ANY_OTHER: "Any Other",
  },
  TUBERCULOSIS_TREATMENT_DURATION: {
    LT_3_MONTHS: "Less Than 3 Months",
    SIX_MONTHS: "6 Months",
    NINE_MONTHS: "9 Months",
    TWELVE_MONTHS: "12 Months",
    GT_12_MONTHS: "More Than 12 Months",
    NO_TREATMENT: "No Treatment Taken",
  },
  RESPIRATORY_DISORDERS: {
    ASTHMA: "Asthma",
    CHRONIC_COUGH: "Chronic Cough",
    CHRONIC_BRONCHITIS: "Chronic Bronchitis",
    COPD: "COPD",
    PNEUMONIA: "Pneumonia",
    EMPHYSEMA: "Emphysema",
    SARCOIDOSIS: "Sarcoidosis",
    ANY_OTHER: "Any Other",
  },
  SYMPTOM_FREQUENCY: {
    DAILY: "Daily",
    WEEKLY: "Weekly",
    MONTHLY: "Monthly",
    SEASONAL: "Seasonal",
  },
  RESPIRATORY_TREATMENT_TYPES: {
    INHALER: "Treatment With Inhaler",
    ORAL_MEDICATIONS: "Treatment With Oral Medications",
    INJECTABLES: "Treatment With Injectables",
  },
  GENITOURINARY_CONDITIONS: {
    TUMOUR: "Tumour",
    URETHRITIS: "Urethritis",
    KIDNEY_STONES: "Kidney Stones",
    RENAL_CYST: "Renal Cyst",
    ENLARGED_PROSTATE: "Enlarged Prostate",
  },
  GYNAECOLOGICAL_CONDITIONS: {
    CANCER_BREAST_CERVIX: "Cancer Of Breast/Cervix/Ovaries/Uterus",
    DYSMENORRHEA: "Dysmenorrhea",
    ENDOMETRIOSIS: "Endometriosis",
    PCOD: "PCOD",
    UTERINE_FIBROIDS: "Uterine Fibroids",
    BREAST_LUMP: "Breast Lump",
    ANY_OTHER: "Any Other",
  },
  GYNAECOLOGICAL_TESTS: {
    HISTOPATHOLOGY: "Histopathology",
    BIOPSY: "Biopsy",
    PAP_SMEAR: "PAP Smear",
    ULTRASOUND: "Ultrasound",
    MAMMOGRAM: "Mammogram",
  },
  GASTRO_INTESTINAL_CONDITIONS: {
    PANCREATITIS: "Pancreatitis",
    ULCERATIVE_COLITIS: "Ulcerative Colitis",
    CROHNS_DISEASE: "Crohns Disease",
    ULCER: "Ulcer",
    GASTRITIS: "Gastritis",
    ANY_OTHER: "Any Other",
  },
  LIVER_DISORDERS: {
    LIVER_CANCER: "Liver Cancer",
    CIRRHOSIS: "Cirrhosis Of Liver",
    JAUNDICE: "Jaundice",
    HEPATITIS_B: "Hepatitis B",
    HEPATITIS_C: "Hepatitis C",
    FATTY_LIVER: "Fatty Liver",
    ANY_OTHER: "Any Other",
  },
  HEALTH_ISSUE: {
    TUBERCULOSIS: "Tuberculosis",
    FUNGAL_INFECTIONS: "Fungal Infections",
    GASTRIC_ISSUES: "Gastric Issues",
    ANY_OTHER: "Any Other",
  },
  MUSCULOSKELETAL: {
    HERNIATED_DISC: "Herniated Intervertebral Disc",
    OSTEOARTHRITIS: "Osteoarthritis",
    RHEUMATOID_ARTHRITIS: "Rheumatoid Arthritis",
    ANKYLOSING_SPONDYLITIS: "Ankylosing Spondylitis",
    ANY_OTHER: "Any Other",
  },
  TREATMENT_TYPE_DRUGS: {
    DRUGS: "Drugs",
    PHYSIOTHERAPY: "Physiotherapy",
    CHIROPRACTIC: "Chiropractic",
    SURGERY: "Surgery",
    HOSPITAL_STAYS: "Hospital Stays",
  },
  WRECK_DIVING_TYPE: {
    WRECKDRIVING: "Wreck Diving, Open Cave, Pothole And Ice Diving",
    UNTRAINEDDIVES: "Untrained Dives, Diving In Closed Caves, Depth Record Attempts, Unaccompanied Dives",
  },
  EPILEPSY_COMPLICATIONS: {
    POST_TRAUMATIC:
      "Post Traumatic Epilepsy/Seizures (recurrent and unprovoked seizures that occur after a brain injury)",
    STATUS_EPILEPTICUS: "Status Epilepticus (continuous seizure for 5 or more than 5 minutes)",
  },
  NUMBER: Object.fromEntries(Array.from({ length: 40 }, (_, i) => [i + 1, i + 1])),
};

export const HEALTH_QUESTIONS_OPTIONS = {
  OCCUPATION_ACTIVITY: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.AF, name: "north_star.options.occupationActivity.af" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.OP, name: "north_star.options.occupationActivity.op" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.MI, name: "north_star.options.occupationActivity.mi" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.RD, name: "north_star.options.occupationActivity.rd" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.PL, name: "north_star.options.occupationActivity.pl" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.FR, name: "north_star.options.occupationActivity.fr" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.MM, name: "north_star.options.occupationActivity.mm" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.OCCUPATION_ACTIVITY.OT, name: "north_star.options.occupationActivity.ot" },
  ],
  ARMED_FORCES: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.ARMED_FORCES.DIVING, name: "north_star.options.armedForces.diving" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ARMED_FORCES.PARA_TROOPING,
      name: "north_star.options.armedForces.paraTrooping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ARMED_FORCES.PARACHUTING,
      name: "north_star.options.armedForces.parachuting",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ARMED_FORCES.COMMANDO_ACTIVITIES,
      name: "north_star.options.armedForces.commandoActivities",
    },
  ],
  OIL_GAS_PETROCHEMICAL: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.OIL_GAS_PETROCHEMICAL.IWCROL,
      name: "north_star.options.oilGasPetrochemical.iwcrol",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.OIL_GAS_PETROCHEMICAL.OES,
      name: "north_star.options.oilGasPetrochemical.oes",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.OIL_GAS_PETROCHEMICAL.OTP,
      name: "north_star.options.oilGasPetrochemical.otp",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.OIL_GAS_PETROCHEMICAL.IRP,
      name: "north_star.options.oilGasPetrochemical.irp",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.OIL_GAS_PETROCHEMICAL.ICTR,
      name: "north_star.options.oilGasPetrochemical.ictr",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.OIL_GAS_PETROCHEMICAL.OTHERS,
      name: "north_star.options.oilGasPetrochemical.others",
    },
  ],
  MINING_TYPE: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.MINING_TYPE.PLACER_MINE, name: "north_star.options.miningType.placerMine" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MINING_TYPE.HYDRAULIC_MINE,
      name: "north_star.options.miningType.hydraulicMine",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MINING_TYPE.HARD_ROCK_MINING,
      name: "north_star.options.miningType.hardRockMining",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MINING_TYPE.OPEN_PIT_MINING,
      name: "north_star.options.miningType.openPitMining",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.MINING_TYPE.OTHERS, name: "north_star.options.miningType.others" },
  ],
  AVIATION_LICENSE: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVIATION_LICENSE.PRIVATE,
      name: "north_star.options.aviationLicense.private",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVIATION_LICENSE.COMMERCIAL,
      name: "north_star.options.aviationLicense.commercial",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVIATION_LICENSE.FLIGHT_INSTRUCTOR,
      name: "north_star.options.aviationLicense.flightInstructor",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVIATION_LICENSE.OTHERS, name: "north_star.options.aviationLicense.others" },
  ],
  PRIVATE_JETS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PRIVATE_JETS.PRIVATE_OR_CLUB_FLYING_FOR_PLEASURE,
      name: "north_star.options.privateJets.privateOrClubFlyingForPleasure",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PRIVATE_JETS.PRIVATE_FLYING_FOR_BUSINESS,
      name: "north_star.options.privateJets.privateFlyingForBusiness",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PRIVATE_JETS.PRIVATE_FLYING_FOR_OTHER_PURPOSES,
      name: "north_star.options.privateJets.privateFlyingForOtherPurposes",
    },
  ],
  FLYING_TYPE: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_TYPE.EXPERIMENTAL,
      name: "north_star.options.flyingType.experimental",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_TYPE.TEST_FLYING, name: "north_star.options.flyingType.testFlying" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_TYPE.FLIGHT_INSTRUCTOR,
      name: "north_star.options.flyingType.flightInstructor",
    },
  ],
  FLYING_COMPETITION: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_COMPETITION.ANY_FORM_OF_AEROBATICS,
      name: "north_star.options.flyingCompetition.anyFormOfAerobatics",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_COMPETITION.AIR_SHOWS,
      name: "north_star.options.flyingCompetition.airShows",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_COMPETITION.PROTOTYPE_TESTING,
      name: "north_star.options.flyingCompetition.prototypeTesting",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_COMPETITION.AIR_RACING,
      name: "north_star.options.flyingCompetition.airRacing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_COMPETITION.STUNT_FLYING,
      name: "north_star.options.flyingCompetition.stuntFlying",
    },
  ],
  FIREMAN_ROLE: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_ROLE.VOLUNTEER, name: "north_star.options.firemanRole.volunteer" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_ROLE.PROFESSIONAL,
      name: "north_star.options.firemanRole.professional",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_ROLE.ADMINISTRATIVE,
      name: "north_star.options.firemanRole.administrative",
    },
  ],
  FIREMAN_INTERVENTION: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_INTERVENTION.FOREST_FIRE,
      name: "north_star.options.firemanIntervention.forestFire",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_INTERVENTION.UNDERWATER_OPERATIONS,
      name: "north_star.options.firemanIntervention.underwaterOperations",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_INTERVENTION.MOUNTAIN_RESUE,
      name: "north_star.options.firemanIntervention.mountainResue",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_INTERVENTION.AIRCRAFT,
      name: "north_star.options.firemanIntervention.aircraft",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_INTERVENTION.CLIMBING,
      name: "north_star.options.firemanIntervention.climbing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_INTERVENTION.SPELEOLOGICAL,
      name: "north_star.options.firemanIntervention.speleological",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FIREMAN_INTERVENTION.LANDMINE,
      name: "north_star.options.firemanIntervention.landmine",
    },
  ],
  TOBACCO_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TOBACCO_OPTIONS.CIGAR, name: "north_star.options.tobaccoOptions.cigar" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TOBACCO_OPTIONS.CIGARETTE,
      name: "north_star.options.tobaccoOptions.cigarette",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TOBACCO_OPTIONS.BEEDI, name: "north_star.options.tobaccoOptions.beedi" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TOBACCO_OPTIONS.GUTKA, name: "north_star.options.tobaccoOptions.gutka" },
  ],
  ALCOHOL_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.ALCOHOL_OPTIONS.BEER, name: "north_star.options.alcoholOptions.beer" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.ALCOHOL_OPTIONS.WINE, name: "north_star.options.alcoholOptions.wine" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.ALCOHOL_OPTIONS.LIQUOR, name: "north_star.options.alcoholOptions.liquor" },
  ],
  HEIGHT_FT: Array.from({ length: 8 }, (_, i) => ({
    id: `${i + 1}`,
    name: `${i + 1} Ft`,
  })),

  HEIGHT_INCH: Array.from({ length: 12 }, (_, i) => ({
    id: `${i}`,
    name: `${i} In`,
  })),
  NOMINEE_RELATIONSHIP: () =>
    Object.entries({
      ...OPTION_VALUES.FAMILTY_RELATIONSHIP,
      // ...(isFemale ? { WIFE: "Wife" } : { HUSBAND: "Husband" }),
    }).map(([key, value]) => ({
      id: value,
      name: t(`options.${key}`),
    })),

  CANCER_TRETMENT_OPTION: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANCER_TRETMENT_OPTION.CHEMOTHERAPY,
      name: "north_star.options.cancerTretmentOption.chemotherapy",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANCER_TRETMENT_OPTION.RADIOTHERAPY,
      name: "north_star.options.cancerTretmentOption.radiotherapy",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANCER_TRETMENT_OPTION.HORMONALTHERAPY,
      name: "north_star.options.cancerTretmentOption.hormonaltherapy",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANCER_TRETMENT_OPTION.SURGERY,
      name: "north_star.options.cancerTretmentOption.surgery",
    },
  ],
  HYPERTENSION_MEDICAL_OPTION: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HYPERTENSION_MEDICAL_OPTION.ELEVATEDBP,
      name: "north_star.options.hypertensionMedicalOption.elevatedbp",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HYPERTENSION_MEDICAL_OPTION.ELEVATEDCHOLESTEROL,
      name: "north_star.options.hypertensionMedicalOption.elevatedcholesterol",
    },
  ],
  HYPERTENSION_DURATION_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DURATION.LT_1YR,
      name: "north_star.options.hypertensionDurationOptions.lt1yr",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DURATION.YR_1_TO_5,
      name: "north_star.options.hypertensionDurationOptions.yr1To5",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DURATION.YR_5_TO_10,
      name: "north_star.options.hypertensionDurationOptions.yr5To10",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DURATION.GT_10YR,
      name: "north_star.options.hypertensionDurationOptions.gt10yr",
    },
  ],
  HYPERTENSION_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.ORAL_MEDICATIONS,
      name: "north_star.options.hypertensionTypeOptions.oralMedications",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.DIET_LIFESTYLE,
      name: "north_star.options.hypertensionTypeOptions.dietLifestyle",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.AYURVEDIC,
      name: "north_star.options.hypertensionTypeOptions.ayurvedic",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.NO_TREATMENT,
      name: "north_star.options.hypertensionTypeOptions.noTreatment",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.INSULIN,
      name: "north_star.options.hypertensionTypeOptions.insulin",
    },
  ],
  DIBETIC_HYPERTENSION_SUGER_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.ORAL_MEDICATIONS,
      name: "north_star.options.dibeticHypertensionSugerOptions.oralMedications",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.DIET_LIFESTYLE,
      name: "north_star.options.dibeticHypertensionSugerOptions.dietLifestyle",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.AYURVEDIC,
      name: "north_star.options.dibeticHypertensionSugerOptions.ayurvedic",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE.NO_TREATMENT,
      name: "north_star.options.dibeticHypertensionSugerOptions.noTreatment",
    },
  ],
  HEART_SURGERY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEART_SURGERY.ANGIOPLASTY,
      name: "north_star.options.heartSurgeryOptions.angioplasty",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEART_SURGERY.BYPASS, name: "north_star.options.heartSurgeryOptions.bypass" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEART_SURGERY.PACEMAKER_IMPLANT,
      name: "north_star.options.heartSurgeryOptions.pacemakerImplant",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEART_SURGERY.VALVE_REPLACEMENT,
      name: "north_star.options.heartSurgeryOptions.valveReplacement",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEART_SURGERY.CONGENITAL_HEART_DEFECT,
      name: "north_star.options.heartSurgeryOptions.congenitalHeartDefect",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEART_SURGERY.OTHER_HEART_SURGERY,
      name: "north_star.options.heartSurgeryOptions.otherHeartSurgery",
    },
  ],
  HEALTH_RELATED_CONDTION: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Hypertension/ High BP/ high cholesterol",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Chest Pain/Heart disease/attacks",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Angioplasty/bypass heart surgery",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Diabetes/High Blood Sugar/Sugar in urine",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Asthma/ Tuberculosis/ other respiratory disorders",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Nervous disorder/stroke epilepsy/spinal issues",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Gastrointestinal disorders / Colitis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Liver disorders/Jaundice/ Hepatitis B or C",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Kidney Prostate Urinary Disorders",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Cancer, Tumor, Growth or any kinf of Cysts",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Sexually transmitted diseases/attacks/ HIV/ AIDS",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Anemia/ thalassemia/ any blood related disorder",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Psychiatric illness such as anxiety, depression or any other",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "Any others not mentioned",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "None of the above applied to me",
    },
  ],
  LIMB_AFFECTED_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.ONE_LIMB,
      name: "north_star.options.limbAffectedOptions.oneLimb",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.TWO_LIMBS,
      name: "north_star.options.limbAffectedOptions.twoLimbs",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.MORE_THAN_TWO_LIMBS,
      name: "north_star.options.limbAffectedOptions.moreThanTwoLimbs",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIMB_AFFECTED.VERTEBRAL_SPINE,
      name: "north_star.options.limbAffectedOptions.vertebralSpine",
    },
  ],
  CONDITION_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CONDITION_TYPE.ACQUIRED,
      name: "north_star.options.conditionTypeOptions.acquired",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CONDITION_TYPE.CONGENITAL,
      name: "north_star.options.conditionTypeOptions.congenital",
    },
  ],
  SUPPORT_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SUPPORT_TYPE.CRUTCHES_STICK,
      name: "north_star.options.supportTypeOptions.crutchesStick",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SUPPORT_TYPE.CALLIPERS,
      name: "north_star.options.supportTypeOptions.callipers",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SUPPORT_TYPE.WHEELCHAIR,
      name: "north_star.options.supportTypeOptions.wheelchair",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SUPPORT_TYPE.ANY_OTHER,
      name: "north_star.options.supportTypeOptions.anyOther",
    },
  ],
  DISABILITY_CAUSE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DISABILITY_CAUSE.OLD_POLIO,
      name: "north_star.options.disabilityCauseOptions.oldPolio",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DISABILITY_CAUSE.POST_TRAUMATIC,
      name: "north_star.options.disabilityCauseOptions.postTraumatic",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DISABILITY_CAUSE.POST_NEUROLOGICAL,
      name: "north_star.options.disabilityCauseOptions.postNeurological",
    },
  ],
  AVOCATION_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVOCATION_OPTIONS.PARAGLIDING,
      name: "north_star.options.avocationOptions.paragliding",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVOCATION_OPTIONS.PARACHUTING_SKYDIVING,
      name: "north_star.options.avocationOptions.parachutingSkydiving",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVOCATION_OPTIONS.MOUNTAINEERING,
      name: "north_star.options.avocationOptions.mountaineering",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVOCATION_OPTIONS.DEEP_SEA_DIVING_SCUBA_DIVING,
      name: "north_star.options.avocationOptions.deepSeaDivingScubaDiving",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVOCATION_OPTIONS.MOTORCYCLE_RACING,
      name: "north_star.options.avocationOptions.motorcycleRacing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVOCATION_OPTIONS.MOTOR_CAR_RACING,
      name: "north_star.options.avocationOptions.motorCarRacing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.AVOCATION_OPTIONS.OTHER_EXTREME_AVOATION,
      name: "north_star.options.avocationOptions.otherExtremeAvoation",
    },
  ],
  MAX_DIVE_DEPTH_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MAX_DIVE_DEPTH_OPTIONS.LTE_40M,
      name: "north_star.options.maxDiveDepthOptions.lte40m",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MAX_DIVE_DEPTH_OPTIONS._41_TO_60M,
      name: "north_star.options.maxDiveDepthOptions.41To60m",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MAX_DIVE_DEPTH_OPTIONS._61_TO_75M,
      name: "north_star.options.maxDiveDepthOptions.61To75m",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MAX_DIVE_DEPTH_OPTIONS.GT_75M,
      name: "north_star.options.maxDiveDepthOptions.gt75m",
    },
  ],
  DIVING_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DIVING_TYPE_OPTIONS.ONE_OFF_OR_HOLIDAY_TRY_DIVE,
      name: "north_star.options.divingTypeOptions.oneOffOrHolidayTryDive",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DIVING_TYPE_OPTIONS.RECREATIONAL_DIVING,
      name: "north_star.options.divingTypeOptions.recreationalDiving",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DIVING_TYPE_OPTIONS.FREE_DIVING,
      name: "north_star.options.divingTypeOptions.freeDiving",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.DIVING_TYPE_OPTIONS.TECHNICAL_DIVING,
      name: "north_star.options.divingTypeOptions.technicalDiving",
    },
  ],
  MOTOR_CAR_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.DRAG_RACING,
      name: "north_star.options.motorCarOptions.dragRacing",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.RALLY, name: "north_star.options.motorCarOptions.rally" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.HILL_CLIMBS,
      name: "north_star.options.motorCarOptions.hillClimbs",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.VETERAN_VINTAGE_HISTORIC,
      name: "north_star.options.motorCarOptions.veteranVintageHistoric",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.ANY_OTHER,
      name: "north_star.options.motorCarOptions.anyOther",
    },
  ],
  PROFESSIONAL_SUB_TYPE: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.RALLYING,
      name: "north_star.options.professionalSubType.rallying",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.ANY_OTHER,
      name: "north_star.options.professionalSubType.anyOther",
    },
  ],
  KART_SUB_TYPE: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.SHORT_CIRCUIT,
      name: "north_star.options.kartSubType.shortCircuit",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_OPTIONS.LONG_CIRCUIT,
      name: "north_star.options.kartSubType.longCircuit",
    },
  ],
  MOTOR_CAR_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_TYPE_OPTIONS.SINGLE_SEATER,
      name: "north_star.options.motorCarTypeOptions.singleSeater",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_TYPE_OPTIONS.CLASSICSPORTSCAR,
      name: "north_star.options.motorCarTypeOptions.classicsportscar",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_TYPE_OPTIONS.OTHER_SPORTS_CAR,
      name: "north_star.options.motorCarTypeOptions.otherSportsCar",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_TYPE_OPTIONS.KARTING,
      name: "north_star.options.motorCarTypeOptions.karting",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_TYPE_OPTIONS.SALOON,
      name: "north_star.options.motorCarTypeOptions.saloon",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CAR_TYPE_OPTIONS.ANY_OTHER,
      name: "north_star.options.motorCarTypeOptions.anyOther",
    },
  ],
  MOTOR_RACING_ACTIVITY_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_RACING_ACTIVITY_TYPE_OPTIONS.AMATEUR,
      name: "north_star.options.motorRacingActivityTypeOptions.amateur",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_RACING_ACTIVITY_TYPE_OPTIONS.PROFESSIONAL,
      name: "north_star.options.motorRacingActivityTypeOptions.professional",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_RACING_ACTIVITY_TYPE_OPTIONS.KART_RACING,
      name: "north_star.options.motorRacingActivityTypeOptions.kartRacing",
    },
  ],
  MOTOR_CYCLE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CYCLE_OPTIONS.DRAG_RACING_AND_SPRINTS,
      name: "north_star.options.motorCycleOptions.dragRacingAndSprints",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CYCLE_OPTIONS.ICE_RACING,
      name: "north_star.options.motorCycleOptions.iceRacing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CYCLE_OPTIONS.SPEEDWAY,
      name: "north_star.options.motorCycleOptions.speedway",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_CYCLE_OPTIONS.ANY_OTHER,
      name: "north_star.options.motorCycleOptions.anyOther",
    },
  ],
  CYLINDER_CYCLE_OPTION: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CYLINDER_CAPACITY.LT125CC,
      name: "north_star.options.cylinderCycleOption.lt125cc",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CYLINDER_CAPACITY.TO500CC,
      name: "north_star.options.cylinderCycleOption.to500cc",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CYLINDER_CAPACITY.GT500CC,
      name: "north_star.options.cylinderCycleOption.gt500cc",
    },
  ],
  MOTOR_CYCLE_RACING_ACTIVITY_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_RACING_ACTIVITY_TYPE_OPTIONS.AMATEUR,
      name: "north_star.options.motorCycleRacingActivityTypeOptions.amateur",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOTOR_RACING_ACTIVITY_TYPE_OPTIONS.PROFESSIONAL,
      name: "north_star.options.motorCycleRacingActivityTypeOptions.professional",
    },
  ],
  MOUNTAINEERING_ROLE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_ROLE.HIKING_MARKED,
      name: "north_star.options.mountaineeringRoleOptions.hikingMarked",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_ROLE.HIKING_OFF_MARKED,
      name: "north_star.options.mountaineeringRoleOptions.hikingOffMarked",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_ROLE.ROCK_CLIMBING,
      name: "north_star.options.mountaineeringRoleOptions.rockClimbing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_ROLE.COMPETITIVE_CLIMBING,
      name: "north_star.options.mountaineeringRoleOptions.competitiveClimbing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_ROLE.SPEED_CLIMBING,
      name: "north_star.options.mountaineeringRoleOptions.speedClimbing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_ROLE.ANY_OTHER,
      name: "north_star.options.mountaineeringRoleOptions.anyOther",
    },
  ],
  MOUNTAINEERING_LEVEL_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_LEVEL.HIGH_ALTITUDE_3000,
      name: "north_star.options.mountaineeringLevelOptions.highAltitude3000",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_LEVEL.EXTREME_ALTITUDE_5500,
      name: "north_star.options.mountaineeringLevelOptions.extremeAltitude5500",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_LEVEL.INDOOR_OUTDOOR_UPTO_7_UIAA,
      name: "north_star.options.mountaineeringLevelOptions.indoorOutdoorUpto7Uiaa",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_LEVEL.INDOOR_OUTDOOR_ABOVE_8_UIAA,
      name: "north_star.options.mountaineeringLevelOptions.indoorOutdoorAbove8Uiaa",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_LEVEL.ALPINE_STYLE_UPTO_6_UIAA,
      name: "north_star.options.mountaineeringLevelOptions.alpineStyleUpto6Uiaa",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAINEERING_LEVEL.ALPINE_STYLE_ABOVE_7_UIAA,
      name: "north_star.options.mountaineeringLevelOptions.alpineStyleAbove7Uiaa",
    },
  ],
  MOUNTAIN_RANGE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAIN_RANGE.HIMALAYA,
      name: "north_star.options.mountainRangeOptions.himalaya",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAIN_RANGE.KARAKORAM,
      name: "north_star.options.mountainRangeOptions.karakoram",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAIN_RANGE.EASTERN_RIFT,
      name: "north_star.options.mountainRangeOptions.easternRift",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAIN_RANGE.ANDES, name: "north_star.options.mountainRangeOptions.andes" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAIN_RANGE.ALASKA,
      name: "north_star.options.mountainRangeOptions.alaska",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MOUNTAIN_RANGE.ANY_OTHER,
      name: "north_star.options.mountainRangeOptions.anyOther",
    },
  ],
  TREKKING_DURATION_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREKKING_DURATION.LESS_THAN_A_DAY,
      name: "north_star.options.trekkingDurationOptions.lessThanADay",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREKKING_DURATION.BETWEEN_1_DAY_TO_1_WEEK,
      name: "north_star.options.trekkingDurationOptions.between1DayTo1Week",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREKKING_DURATION.MORE_THAN_1_WEEK,
      name: "north_star.options.trekkingDurationOptions.moreThan1Week",
    },
  ],
  ADVENTURE_ACTIVITY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.TREKKING,
      name: "north_star.options.adventureActivityOptions.trekking",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.MOUNTAIN_HIKING,
      name: "north_star.options.adventureActivityOptions.mountainHiking",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.CLIMBING,
      name: "north_star.options.adventureActivityOptions.climbing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.ICE_CLIMBING,
      name: "north_star.options.adventureActivityOptions.iceClimbing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.BOULDERING,
      name: "north_star.options.adventureActivityOptions.bouldering",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.COASTEERING,
      name: "north_star.options.adventureActivityOptions.coasteering",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.HILLWALKING,
      name: "north_star.options.adventureActivityOptions.hillwalking",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_ACTIVITY.FREE_SOLO,
      name: "north_star.options.adventureActivityOptions.freeSolo",
    },
  ],
  SKYDIVING_JUMPS_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_JUMPS.LT_5, name: "north_star.options.skydivingJumpsOptions.lt5" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_JUMPS.GT_5, name: "north_star.options.skydivingJumpsOptions.gt5" },
  ],
  ACTIVITY_FREQUENCY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ACTIVITY_FREQUENCY.LTE_10,
      name: "north_star.options.activityFrequencyOptions.lte10",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ACTIVITY_FREQUENCY.GT_10,
      name: "north_star.options.activityFrequencyOptions.gt10",
    },
  ],
  ENGINE_CAPACITY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ENGINE_CAPACITY.LTE_400CC,
      name: "north_star.options.engineCapacityOptions.lte400cc",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ENGINE_CAPACITY.GT_400CC,
      name: "north_star.options.engineCapacityOptions.gt400cc",
    },
  ],
  CAVING_FREQUENCY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_FREQUENCY.LTE_25_TRIPS,
      name: "north_star.options.cavingFrequencyOptions.lte25Trips",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_FREQUENCY.GT_25_TRIPS,
      name: "north_star.options.cavingFrequencyOptions.gt25Trips",
    },
  ],
  CLUB_MEMBER_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.CLUB_MEMBERS.BCA_MEM, name: "north_star.options.clubMemberOptions.bcaMem" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CLUB_MEMBERS.NON_BCA_MEM,
      name: "north_star.options.clubMemberOptions.nonBcaMem",
    },
  ],
  ACTIVITY_HOT_AIR_FREQUENCY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HOT_AIR_FLYING_HOURS.LESS_THAN_50,
      name: "north_star.options.activityHotAirFrequencyOptions.lessThan50",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HOT_AIR_FLYING_HOURS.FROM_50_TO_100,
      name: "north_star.options.activityHotAirFrequencyOptions.from50To100",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HOT_AIR_FLYING_HOURS.FROM_100_TO_200,
      name: "north_star.options.activityHotAirFrequencyOptions.from100To200",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HOT_AIR_FLYING_HOURS.MORE_THAN_200,
      name: "north_star.options.activityHotAirFrequencyOptions.moreThan200",
    },
  ],
  ADVENTURE_SPORTS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_SPORTS.SKIING,
      name: "north_star.options.adventureSportsOptions.skiing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_SPORTS.JUMPING,
      name: "north_star.options.adventureSportsOptions.jumping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_SPORTS.HOT_AIR_BALLOON,
      name: "north_star.options.adventureSportsOptions.hotAirBalloon",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_SPORTS.SNOW_MOTORCYCLING,
      name: "north_star.options.adventureSportsOptions.snowMotorcycling",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_SPORTS.CAVING_POTHOLING,
      name: "north_star.options.adventureSportsOptions.cavingPotholing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_SPORTS.ZORBING,
      name: "north_star.options.adventureSportsOptions.zorbing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ADVENTURE_SPORTS.ANY_OTHER,
      name: "north_star.options.adventureSportsOptions.anyOther",
    },
  ],
  SKIING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.PLEASURE_ONLY,
      name: "north_star.options.skiingDetailsOptions.pleasureOnly",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.CROSS_COUNTRY,
      name: "north_star.options.skiingDetailsOptions.crossCountry",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.BIATHLON,
      name: "north_star.options.skiingDetailsOptions.biathlon",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.SNOWBOARDING,
      name: "north_star.options.skiingDetailsOptions.snowboarding",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.SNOWMOBILING,
      name: "north_star.options.skiingDetailsOptions.snowmobiling",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.WITHOUT_COMPETITION,
      name: "north_star.options.skiingDetailsOptions.withoutCompetition",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.WITH_COMPETITION,
      name: "north_star.options.skiingDetailsOptions.withCompetition",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.PROFESSIONAL,
      name: "north_star.options.skiingDetailsOptions.professional",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.EXTREME_SKIING,
      name: "north_star.options.skiingDetailsOptions.extremeSkiing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKIING_DETAILS.ALL_OTHER_EVENTS,
      name: "north_star.options.skiingDetailsOptions.allOtherEvents",
    },
  ],
  JUMPING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.JUMPING_DETAILS.JUMPING_FROM_HEIGHT,
      name: "north_star.options.jumpingDetailsOptions.jumpingFromHeight",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.JUMPING_DETAILS.BUNGEE_JUMPING,
      name: "north_star.options.jumpingDetailsOptions.bungeeJumping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.JUMPING_DETAILS.ROCKET_JUMPING,
      name: "north_star.options.jumpingDetailsOptions.rocketJumping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.JUMPING_DETAILS.SCAD_JUMPING,
      name: "north_star.options.jumpingDetailsOptions.scadJumping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.JUMPING_DETAILS.SNOW_JUMPING,
      name: "north_star.options.jumpingDetailsOptions.snowJumping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.JUMPING_DETAILS.BARREL_JUMPING,
      name: "north_star.options.jumpingDetailsOptions.barrelJumping",
    },
  ],
  FLYING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_DETAILS.RECORD_ATTEMPT,
      name: "north_star.options.flyingDetailsOptions.recordAttempt",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_DETAILS.EQUIPMENT_TESTING,
      name: "north_star.options.flyingDetailsOptions.equipmentTesting",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_DETAILS.TETHERED_BALLOONS,
      name: "north_star.options.flyingDetailsOptions.tetheredBalloons",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_DETAILS.COMPETITION_FLYING,
      name: "north_star.options.flyingDetailsOptions.competitionFlying",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_DETAILS.INSTRUCTOR,
      name: "north_star.options.flyingDetailsOptions.instructor",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_DETAILS.MOTORISED_BALLONS,
      name: "north_star.options.flyingDetailsOptions.motorisedBallons",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_DETAILS.FREE_FLYING_BALLOONS,
      name: "north_star.options.flyingDetailsOptions.freeFlyingBalloons",
    },
  ],
  RACING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.ENDURANCE_RAIDS,
      name: "north_star.options.racingDetailsOptions.enduranceRaids",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.TRACK_SPEED,
      name: "north_star.options.racingDetailsOptions.trackSpeed",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.CIRCUIT_CROSS,
      name: "north_star.options.racingDetailsOptions.circuitCross",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.MOUNTAIN_RACING,
      name: "north_star.options.racingDetailsOptions.mountainRacing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.DRAGSTER,
      name: "north_star.options.racingDetailsOptions.dragster",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.ASPHALT_ROADS_RACING,
      name: "north_star.options.racingDetailsOptions.asphaltRoadsRacing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.SINGLE_SEATER_RACING,
      name: "north_star.options.racingDetailsOptions.singleSeaterRacing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RACING_DETAILS.TWO_SEATER_VEHICLE_4_WHEELS,
      name: "north_star.options.racingDetailsOptions.twoSeaterVehicle4Wheels",
    },
  ],
  CAVING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_DETAILS.CAVE_GRADES_1_TO_3,
      name: "north_star.options.cavingDetailsOptions.caveGrades1To3",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_DETAILS.CAVE_GRADES_4_AND_ABOVE,
      name: "north_star.options.cavingDetailsOptions.caveGrades4AndAbove",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_DETAILS.EXPEDITION_CAVING,
      name: "north_star.options.cavingDetailsOptions.expeditionCaving",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_DETAILS.INTERNATIONAL_ACTIVITY,
      name: "north_star.options.cavingDetailsOptions.internationalActivity",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_DETAILS.CAVING_INSTRUCTORS,
      name: "north_star.options.cavingDetailsOptions.cavingInstructors",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CAVING_DETAILS.ACTIVE_CAVE_RESCUE_PERSONNEL,
      name: "north_star.options.cavingDetailsOptions.activeCaveRescuePersonnel",
    },
  ],
  ACTIVITY_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ACTIVITY_TYPE.RECREATIONAL_OR_ONE_OFF,
      name: "north_star.options.activityTypeOptions.recreationalOrOneOff",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ACTIVITY_TYPE.INSTRUCTOR_LEVEL,
      name: "north_star.options.activityTypeOptions.instructorLevel",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.ACTIVITY_TYPE.INTEGRAL_PART_OF_JOB,
      name: "north_star.options.activityTypeOptions.integralPartOfJob",
    },
  ],
  STANDARD_JUMPS_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.STANDARD_JUMPS.LT_5, name: "north_star.options.standardJumpsOptions.lt5" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.STANDARD_JUMPS.GT_5, name: "north_star.options.standardJumpsOptions.gt5" },
  ],
  FREE_FALL_JUMPS_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.FREE_FALL_JUMPS.LT_25, name: "north_star.options.freeFallJumpsOptions.lt25" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FREE_FALL_JUMPS.RANGE_26_TO_75,
      name: "north_star.options.freeFallJumpsOptions.range26To75",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FREE_FALL_JUMPS.RANGE_76_TO_125,
      name: "north_star.options.freeFallJumpsOptions.range76To125",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FREE_FALL_JUMPS.GT_125,
      name: "north_star.options.freeFallJumpsOptions.gt125",
    },
  ],
  PARACHUTING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.HIGH_PERFORMANCE_TURNS,
      name: "north_star.options.parachutingDetailsOptions.highPerformanceTurns",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.DISPLAY_JUMPS,
      name: "north_star.options.parachutingDetailsOptions.displayJumps",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.ACCURACY_LANDING,
      name: "north_star.options.parachutingDetailsOptions.accuracyLanding",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.INDIVIDUAL_STYLE_JUMP,
      name: "north_star.options.parachutingDetailsOptions.individualStyleJump",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.FREE_FLY,
      name: "north_star.options.parachutingDetailsOptions.freeFly",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.SWOOPING,
      name: "north_star.options.parachutingDetailsOptions.swooping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.PARASCENDING_PARASAILING,
      name: "north_star.options.parachutingDetailsOptions.parascendingParasailing",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARACHUTING_DETAILS.ANY_OTHER,
      name: "north_star.options.parachutingDetailsOptions.anyOther",
    },
  ],
  CANOPY_PILOT_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANOPY_PILOT.NO_CANOPY_PILOT_TRAINING,
      name: "north_star.options.canopyPilotOptions.noCanopyPilotTraining",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANOPY_PILOT.HOLDER_OF_TRAINING,
      name: "north_star.options.canopyPilotOptions.holderOfTraining",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANOPY_PILOT.TOWED_FROM_GROUND,
      name: "north_star.options.canopyPilotOptions.towedFromGround",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANOPY_PILOT.TOWED_FROM_WATER,
      name: "north_star.options.canopyPilotOptions.towedFromWater",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.CANOPY_PILOT.NONE_OF_ABOVE,
      name: "north_star.options.canopyPilotOptions.noneOfAbove",
    },
  ],
  SKYDIVING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.STATIC_LINE_TANDEM,
      name: "north_star.options.skydivingDetailsOptions.staticLineTandem",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.FREE_FALL_SKYDIVING,
      name: "north_star.options.skydivingDetailsOptions.freeFallSkydiving",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.INSTRUCTOR,
      name: "north_star.options.skydivingDetailsOptions.instructor",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.RECORD_ATTEMPT_COMPETITION,
      name: "north_star.options.skydivingDetailsOptions.recordAttemptCompetition",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.BASE_JUMPING,
      name: "north_star.options.skydivingDetailsOptions.baseJumping",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.SKY_BOARDING,
      name: "north_star.options.skydivingDetailsOptions.skyBoarding",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.SKY_COMMANDO,
      name: "north_star.options.skydivingDetailsOptions.skyCommando",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.EQUIPMENT_TESTING,
      name: "north_star.options.skydivingDetailsOptions.equipmentTesting",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SKYDIVING_DETAILS.PARASCENDING_PARASAILING,
      name: "north_star.options.skydivingDetailsOptions.parascendingParasailing",
    },
  ],
  FLIGHT_FREQUENCY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLIGHT_FREQUENCY.LT_25,
      name: "north_star.options.flightFrequencyOptions.lt25",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLIGHT_FREQUENCY.RANGE_26_TO_50,
      name: "north_star.options.flightFrequencyOptions.range26To50",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLIGHT_FREQUENCY.GT_50,
      name: "north_star.options.flightFrequencyOptions.gt50",
    },
  ],
  FLIGHT_NO_OF_JUMPS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLIGHT_JUMPS.LT_50, name: "north_star.options.flightNoOfJumps.lt50" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLIGHT_JUMPS.RANGE_51_TO_100,
      name: "north_star.options.flightNoOfJumps.range51To100",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLIGHT_JUMPS.GT_100, name: "north_star.options.flightNoOfJumps.gt100" },
  ],
  FLYING_HOURS_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_HOURS.LT_100, name: "north_star.options.flyingHoursOptions.lt100" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.FLYING_HOURS.GT_100, name: "north_star.options.flyingHoursOptions.gt100" },
  ],
  GLIDING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.SINGLE_LINE_KITE,
      name: "north_star.options.glidingDetailsOptions.singleLineKite",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.ACROBATIC_KITE,
      name: "north_star.options.glidingDetailsOptions.acrobaticKite",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.TOWING_KITE_POWER_KITE,
      name: "north_star.options.glidingDetailsOptions.towingKitePowerKite",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.ULTRALIGHT_GLIDER_NO_ENGINE,
      name: "north_star.options.glidingDetailsOptions.ultralightGliderNoEngine",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.PARAGLIDING_NO_ENGINE,
      name: "north_star.options.glidingDetailsOptions.paraglidingNoEngine",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.HANG_GLIDER,
      name: "north_star.options.glidingDetailsOptions.hangGlider",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.THREE_AXIS_GLIDER,
      name: "north_star.options.glidingDetailsOptions.threeAxisGlider",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GLIDING_DETAILS.ANY_OTHER,
      name: "north_star.options.glidingDetailsOptions.anyOther",
    },
  ],
  PARAGLIDING_DETAILS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARAGLIDING_DETAILS.PLEASURE_ONLY,
      name: "north_star.options.paraglidingDetailsOptions.pleasureOnly",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARAGLIDING_DETAILS.INSTRUCTOR,
      name: "north_star.options.paraglidingDetailsOptions.instructor",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARAGLIDING_DETAILS.RECORD_ATTEMPT_COMPETITION,
      name: "north_star.options.paraglidingDetailsOptions.recordAttemptCompetition",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARAGLIDING_DETAILS.TESTING_PROTOTYPES,
      name: "north_star.options.paraglidingDetailsOptions.testingPrototypes",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.PARAGLIDING_DETAILS.PILOT,
      name: "north_star.options.paraglidingDetailsOptions.pilot",
    },
  ],
  YES_NO_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.YES, name: "north_star.options.yesNoOptions.yes" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.NO, name: "north_star.options.yesNoOptions.no" },
  ],
  TB_ORGANS_OPTIONS: [
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TB_ORGANS.LUNGS, name: "north_star.options.tbOrgansOptions.lungs" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TB_ORGANS.INTESTINE, name: "north_star.options.tbOrgansOptions.intestine" },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TB_ORGANS.BRAIN, name: "north_star.options.tbOrgansOptions.brain" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TB_ORGANS.SPINAL_CORD,
      name: "north_star.options.tbOrgansOptions.spinalCord",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TB_ORGANS.BONES, name: "north_star.options.tbOrgansOptions.bones" },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TB_ORGANS.LYMPH_NODES,
      name: "north_star.options.tbOrgansOptions.lymphNodes",
    },
    { id: HEALTH_QUESTIONS_OPTIONS_VALUES.TB_ORGANS.ANY_OTHER, name: "north_star.options.tbOrgansOptions.anyOther" },
  ],
  TUBERCULOSIS_TREATMENT_DURATION_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TUBERCULOSIS_TREATMENT_DURATION.LT_3_MONTHS,
      name: "north_star.options.tuberculosisTreatmentDurationOptions.lt3Months",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TUBERCULOSIS_TREATMENT_DURATION.SIX_MONTHS,
      name: "north_star.options.tuberculosisTreatmentDurationOptions.sixMonths",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TUBERCULOSIS_TREATMENT_DURATION.NINE_MONTHS,
      name: "north_star.options.tuberculosisTreatmentDurationOptions.nineMonths",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TUBERCULOSIS_TREATMENT_DURATION.TWELVE_MONTHS,
      name: "north_star.options.tuberculosisTreatmentDurationOptions.twelveMonths",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TUBERCULOSIS_TREATMENT_DURATION.GT_12_MONTHS,
      name: "north_star.options.tuberculosisTreatmentDurationOptions.gt12Months",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TUBERCULOSIS_TREATMENT_DURATION.NO_TREATMENT,
      name: "north_star.options.tuberculosisTreatmentDurationOptions.noTreatment",
    },
  ],
  RESPIRATORY_DISORDERS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.ASTHMA,
      name: "north_star.options.respiratoryDisordersOptions.asthma",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.CHRONIC_COUGH,
      name: "north_star.options.respiratoryDisordersOptions.chronicCough",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.CHRONIC_BRONCHITIS,
      name: "north_star.options.respiratoryDisordersOptions.chronicBronchitis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.PNEUMONIA,
      name: "north_star.options.respiratoryDisordersOptions.pneumonia",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.EMPHYSEMA,
      name: "north_star.options.respiratoryDisordersOptions.emphysema",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.SARCOIDOSIS,
      name: "north_star.options.respiratoryDisordersOptions.sarcoidosis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.COPD,
      name: "north_star.options.respiratoryDisordersOptions.copd",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_DISORDERS.ANY_OTHER,
      name: "north_star.options.respiratoryDisordersOptions.anyOther",
    },
  ],
  SYMPTOM_FREQUENCY_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SYMPTOM_FREQUENCY.DAILY,
      name: "north_star.options.symptomFrequencyOptions.daily",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SYMPTOM_FREQUENCY.WEEKLY,
      name: "north_star.options.symptomFrequencyOptions.weekly",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SYMPTOM_FREQUENCY.MONTHLY,
      name: "north_star.options.symptomFrequencyOptions.monthly",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.SYMPTOM_FREQUENCY.SEASONAL,
      name: "north_star.options.symptomFrequencyOptions.seasonal",
    },
  ],
  RESPIRATORY_TREATMENT_TYPES_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_TREATMENT_TYPES.INHALER,
      name: "north_star.options.respiratoryTreatmentTypesOptions.inhaler",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_TREATMENT_TYPES.ORAL_MEDICATIONS,
      name: "north_star.options.respiratoryTreatmentTypesOptions.oralMedications",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.RESPIRATORY_TREATMENT_TYPES.INJECTABLES,
      name: "north_star.options.respiratoryTreatmentTypesOptions.injectables",
    },
  ],
  GENITOURINARY_CONDITIONS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GENITOURINARY_CONDITIONS.TUMOUR,
      name: "north_star.options.genitourinaryConditionsOptions.tumour",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GENITOURINARY_CONDITIONS.URETHRITIS,
      name: "north_star.options.genitourinaryConditionsOptions.urethritis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GENITOURINARY_CONDITIONS.KIDNEY_STONES,
      name: "north_star.options.genitourinaryConditionsOptions.kidneyStones",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GENITOURINARY_CONDITIONS.RENAL_CYST,
      name: "north_star.options.genitourinaryConditionsOptions.renalCyst",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GENITOURINARY_CONDITIONS.ENLARGED_PROSTATE,
      name: "north_star.options.genitourinaryConditionsOptions.enlargedProstate",
    },
  ],
  GYNAECOLOGICAL_CONDITIONS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_CONDITIONS.CANCER_BREAST_CERVIX,
      name: "north_star.options.gynaecologicalConditionsOptions.cancerBreastCervix",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_CONDITIONS.DYSMENORRHEA,
      name: "north_star.options.gynaecologicalConditionsOptions.dysmenorrhea",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_CONDITIONS.ENDOMETRIOSIS,
      name: "north_star.options.gynaecologicalConditionsOptions.endometriosis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_CONDITIONS.PCOD,
      name: "north_star.options.gynaecologicalConditionsOptions.pcod",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_CONDITIONS.UTERINE_FIBROIDS,
      name: "north_star.options.gynaecologicalConditionsOptions.uterineFibroids",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_CONDITIONS.BREAST_LUMP,
      name: "north_star.options.gynaecologicalConditionsOptions.breastLump",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_CONDITIONS.ANY_OTHER,
      name: "north_star.options.gynaecologicalConditionsOptions.anyOther",
    },
  ],
  GYNAECOLOGICAL_TESTS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_TESTS.HISTOPATHOLOGY,
      name: "north_star.options.gynaecologicalTestsOptions.histopathology",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_TESTS.BIOPSY,
      name: "north_star.options.gynaecologicalTestsOptions.biopsy",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_TESTS.PAP_SMEAR,
      name: "north_star.options.gynaecologicalTestsOptions.papSmear",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_TESTS.ULTRASOUND,
      name: "north_star.options.gynaecologicalTestsOptions.ultrasound",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GYNAECOLOGICAL_TESTS.MAMMOGRAM,
      name: "north_star.options.gynaecologicalTestsOptions.mammogram",
    },
  ],
  GASTRO_INTESTINAL_CONDITIONS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GASTRO_INTESTINAL_CONDITIONS.PANCREATITIS,
      name: "north_star.options.gastroIntestinalConditionsOptions.pancreatitis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GASTRO_INTESTINAL_CONDITIONS.ULCERATIVE_COLITIS,
      name: "north_star.options.gastroIntestinalConditionsOptions.ulcerativeColitis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GASTRO_INTESTINAL_CONDITIONS.CROHNS_DISEASE,
      name: "north_star.options.gastroIntestinalConditionsOptions.crohnsDisease",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GASTRO_INTESTINAL_CONDITIONS.ULCER,
      name: "north_star.options.gastroIntestinalConditionsOptions.ulcer",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GASTRO_INTESTINAL_CONDITIONS.GASTRITIS,
      name: "north_star.options.gastroIntestinalConditionsOptions.gastritis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.GASTRO_INTESTINAL_CONDITIONS.ANY_OTHER,
      name: "north_star.options.gastroIntestinalConditionsOptions.anyOther",
    },
  ],
  LIVER_DISORDERS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIVER_DISORDERS.LIVER_CANCER,
      name: "north_star.options.liverDisordersOptions.liverCancer",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIVER_DISORDERS.CIRRHOSIS,
      name: "north_star.options.liverDisordersOptions.cirrhosis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIVER_DISORDERS.JAUNDICE,
      name: "north_star.options.liverDisordersOptions.jaundice",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIVER_DISORDERS.HEPATITIS_B,
      name: "north_star.options.liverDisordersOptions.hepatitisB",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIVER_DISORDERS.HEPATITIS_C,
      name: "north_star.options.liverDisordersOptions.hepatitisC",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIVER_DISORDERS.FATTY_LIVER,
      name: "north_star.options.liverDisordersOptions.fattyLiver",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.LIVER_DISORDERS.ANY_OTHER,
      name: "north_star.options.liverDisordersOptions.anyOther",
    },
  ],
  HEALTH_ISSUE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEALTH_ISSUE.TUBERCULOSIS,
      name: "north_star.options.healthIssueOptions.tuberculosis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEALTH_ISSUE.FUNGAL_INFECTIONS,
      name: "north_star.options.healthIssueOptions.fungalInfections",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEALTH_ISSUE.GASTRIC_ISSUES,
      name: "north_star.options.healthIssueOptions.gastricIssues",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.HEALTH_ISSUE.ANY_OTHER,
      name: "north_star.options.healthIssueOptions.anyOther",
    },
  ],
  MUSCULOSKELETAL_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MUSCULOSKELETAL.HERNIATED_DISC,
      name: "north_star.options.musculoskeletalOptions.herniatedDisc",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MUSCULOSKELETAL.OSTEOARTHRITIS,
      name: "north_star.options.musculoskeletalOptions.osteoarthritis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MUSCULOSKELETAL.RHEUMATOID_ARTHRITIS,
      name: "north_star.options.musculoskeletalOptions.rheumatoidArthritis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MUSCULOSKELETAL.ANKYLOSING_SPONDYLITIS,
      name: "north_star.options.musculoskeletalOptions.ankylosingSpondylitis",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.MUSCULOSKELETAL.ANY_OTHER,
      name: "north_star.options.musculoskeletalOptions.anyOther",
    },
  ],
  TREATMENT_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE_DRUGS.DRUGS,
      name: "north_star.options.treatmentTypeOptions.drugs",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE_DRUGS.PHYSIOTHERAPY,
      name: "north_star.options.treatmentTypeOptions.physiotherapy",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE_DRUGS.CHIROPRACTIC,
      name: "north_star.options.treatmentTypeOptions.chiropractic",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE_DRUGS.SURGERY,
      name: "north_star.options.treatmentTypeOptions.surgery",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.TREATMENT_TYPE_DRUGS.HOSPITAL_STAYS,
      name: "north_star.options.treatmentTypeOptions.hospitalStays",
    },
  ],
  EPILEPSY_COMPLICATIONS_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.EPILEPSY_COMPLICATIONS.POST_TRAUMATIC,
      name: "north_star.options.epilepsyComplicationsOptions.postTraumatic",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.EPILEPSY_COMPLICATIONS.STATUS_EPILEPTICUS,
      name: "north_star.options.epilepsyComplicationsOptions.statusEpilepticus",
    },
  ],
  WRECK_DIVING_TYPE_OPTIONS: [
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.WRECK_DIVING_TYPE.WRECKDRIVING,
      name: "north_star.options.wreckDivingTypeOptions.wreckdriving",
    },
    {
      id: HEALTH_QUESTIONS_OPTIONS_VALUES.WRECK_DIVING_TYPE.UNTRAINEDDIVES,
      name: "north_star.options.wreckDivingTypeOptions.untraineddives",
    },
  ],
  NUMBER_OPTIONS: Array.from({ length: 40 }, (_, i) => ({
    id: HEALTH_QUESTIONS_OPTIONS_VALUES.NUMBER[i + 1],
    name: String(i + 1),
  })),
};
export const fundTabHeaders = [
  { label: "fund.fundAllocation.fundDetails", show: true, key: "", title: "Fund Details" },
  { label: "fund.fundAllocation.type", show: false, key: "", title: "Type" },
  { label: "fund.fundAllocation.returnFilter", show: true, key: "", title: "Return Filter" },
  { label: "fund.fundAllocation.fundAllocation", show: true, key: "value", title: "Fund Allocation" },
];
